import { jsx as E, jsxs as ne, Fragment as On } from "react/jsx-runtime";
import * as le from "react";
import Z, { cloneElement as Kt, useRef as K, useState as $e, useEffect as ae, useCallback as se, useMemo as ct, Component as rc, useLayoutEffect as Yi, useReducer as Gi, forwardRef as ce, createContext as Ht, createElement as k, useContext as cn, Children as It, isValidElement as Rn, Fragment as on, memo as oc } from "react";
import ic, { flushSync as qi } from "react-dom";
function Xi(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number")
    o += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var i = e.length;
      for (t = 0; t < i; t++)
        e[t] && (n = Xi(e[t])) && (o && (o += " "), o += n);
    } else
      for (n in e)
        e[n] && (o && (o += " "), o += n);
  return o;
}
function X() {
  for (var e, t, n = 0, o = "", i = arguments.length; n < i; n++)
    (e = arguments[n]) && (t = Xi(e)) && (o && (o += " "), o += t);
  return o;
}
const Xo = {
  remove: {
    class: "icon-remove"
  },
  youtube: {
    class: "icon-youtube"
  },
  tiktok: {
    class: "icon-tiktok"
  },
  linkedin: {
    class: "icon-linkedin"
  },
  twitter: {
    class: "icon-twitter"
  },
  facebook: {
    class: "icon-facebook"
  },
  instagram: {
    class: "icon-instagram"
  },
  translation: {
    class: "icon-translation",
    transform: 4
  },
  "ambassador-sidebar": {
    class: "icon-ambassador-sidebar"
  },
  "chat-lock": {
    class: "icon-chat-lock"
  },
  "private-room": {
    class: "icon-private-room"
  },
  "circle-close": {
    class: "icon-circle-close"
  },
  membership: {
    class: "icon-membership"
  },
  search: {
    class: "icon-search"
  },
  pin: {
    class: "icon-pin"
  },
  gp: {
    class: "icon-gp"
  },
  "types-of-exchanges": {
    class: "icon-types_of_exchanges"
  },
  guarantees: {
    class: "icon-guarantees"
  },
  "up-arrow": {
    class: "icon-up-arrow"
  },
  "down-arrow": {
    class: "icon-down-arrow"
  },
  "selection-tick-selected": {
    class: "icon-selection-tick-selected",
    transform: 2
  },
  "ic-location": {
    class: "icon-ic-location"
  },
  "header-profile-profile": {
    class: "icon-header-profile-profile"
  },
  creme_email: {
    class: "icon-creme_email"
  },
  home: {
    class: "icon-home"
  },
  "credit-card": {
    class: "icon-credit-card"
  },
  "header-profile-home": {
    class: "icon-header-profile-home"
  },
  keys: {
    class: "icon-keys"
  },
  "header-profile-add-home": {
    class: "icon-header-profile-add-home"
  },
  heart: {
    class: "icon-heart"
  },
  "header-profile-settings": {
    class: "icon-header-profile-settings"
  },
  "header-profile-they-love-my-home": {
    class: "icon-header-profile-they-love-my-home"
  },
  "button-power": {
    class: "icon-button-power"
  },
  "header-help": {
    class: "icon-header-help"
  },
  "header-message-read": {
    class: "icon-header-message-read"
  },
  "header-message-new": {
    class: "icon-header-message-new"
  },
  right_arrow: {
    class: "icon-right_arrow"
  },
  "verification-check": {
    class: "icon-verification-check"
  },
  notification: {
    class: "icon-notification"
  },
  user: {
    class: "icon-user"
  },
  "checkbox-fill": {
    class: "icon-checkbox-fill"
  },
  "error-warning-fill": {
    class: "icon-error-warning-fill"
  }
}, sc = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral"
}, ac = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "5xl": "is-5xl"
};
function cc(e = 0) {
  const t = [];
  for (let n = 0; n < e; n++)
    t[n] = `path${n + 1}`;
  return t.map((n) => /* @__PURE__ */ E("span", { className: n }, n));
}
function Fe({ name: e, size: t = "medium", color: n = "base", className: o = "", ...i }) {
  var s;
  const r = X("icon", Xo[e].class, ac[t], sc[n], o);
  return /* @__PURE__ */ E("i", { className: r, ...i, children: cc((s = Xo[e]) == null ? void 0 : s.transform) });
}
const lc = "_button_1jwsc_1", uc = "_disabled_1jwsc_15", Dt = {
  button: lc,
  disabled: uc,
  "is-primary": "_is-primary_1jwsc_28",
  "is-secondary": "_is-secondary_1jwsc_41",
  "is-tertiary": "_is-tertiary_1jwsc_53",
  "is-eco-green": "_is-eco-green_1jwsc_66",
  "is-white": "_is-white_1jwsc_80",
  "is-ghost": "_is-ghost_1jwsc_93",
  "is-destructive-ghost": "_is-destructive-ghost_1jwsc_107",
  "is-destructive": "_is-destructive_1jwsc_107",
  "is-regular": "_is-regular_1jwsc_134",
  "is-medium": "_is-medium_1jwsc_137",
  "is-small": "_is-small_1jwsc_140",
  "is-full-width": "_is-full-width_1jwsc_143"
};
function am({
  color: e = "primary",
  text: t,
  size: n = "regular",
  isFullWidth: o = !1,
  icon: i,
  iconPosition: r = "left",
  onClick: s,
  children: a,
  disabled: c,
  type: p = "button",
  className: l = "",
  href: u,
  ...b
}) {
  const y = X(
    Dt.button,
    Dt[pc[e]],
    Dt[mc[n]],
    o && Dt["is-full-width"],
    c && Dt.disabled,
    r === "right" && Dt["has-icon-right"],
    l
  );
  return /* @__PURE__ */ ne(
    `${u ? "a" : "button"}`,
    {
      href: c ? void 0 : u,
      onClick: s,
      className: y,
      disabled: c,
      type: p,
      ...b,
      children: [
        i && r === "left" && /* @__PURE__ */ E(Fe, { name: i }),
        a ?? t,
        i && r === "right" && /* @__PURE__ */ E(Fe, { name: i })
      ]
    }
  );
}
const dc = "_buttons_fi7p8_1", fc = {
  buttons: dc
}, cm = ({ children: e }) => /* @__PURE__ */ E("div", { className: fc.buttons, children: e }), pc = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  white: "is-white",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive"
}, mc = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
}, _c = "_card_1gftb_1", Je = {
  card: _c,
  "card-header": "_card-header_1gftb_8",
  "card-header-img": "_card-header-img_1gftb_12",
  "card-header-user-img-container": "_card-header-user-img-container_1gftb_18",
  "card-header-user-img": "_card-header-user-img_1gftb_18",
  "card-title": "_card-title_1gftb_29",
  "card-subtitle": "_card-subtitle_1gftb_38",
  "card-details": "_card-details_1gftb_41",
  "card-details-left": "_card-details-left_1gftb_47",
  "card-details-right": "_card-details-right_1gftb_51"
};
function Zo(e, t) {
  return Kt(e, {
    className: t,
    fill: "true",
    ...e.props
  });
}
function lm({ image: e, userImg: t, title: n, subtitle: o, capacity: i, cost: r }) {
  const s = Zo(e, Je["card-header-img"]), a = Zo(t, Je["card-header-user-img"]);
  return /* @__PURE__ */ ne("article", { className: Je.card, children: [
    /* @__PURE__ */ ne("div", { className: Je["card-header"], children: [
      e && s,
      t && /* @__PURE__ */ E("div", { className: Je["card-header-user-img-container"], children: a })
    ] }),
    /* @__PURE__ */ ne("div", { children: [
      /* @__PURE__ */ E("span", { className: Je["card-title"], children: n }),
      /* @__PURE__ */ E("div", { className: Je["card-subtitle"], children: o })
    ] }),
    /* @__PURE__ */ ne("div", { className: Je["card-details"], children: [
      /* @__PURE__ */ ne("span", { className: Je["card-details-left"], children: [
        /* @__PURE__ */ E(Fe, { name: "header-profile-profile", size: "small" }),
        " ",
        i
      ] }),
      /* @__PURE__ */ E("span", { className: Je["card-details-right"], children: r })
    ] })
  ] });
}
const gc = {
  "info-card": "_info-card_16gzh_1",
  "info-card-text": "_info-card-text_16gzh_13"
};
function um({ icon: e, text: t, onClick: n, className: o = "", ...i }) {
  const r = X(gc["info-card"], o);
  return /* @__PURE__ */ ne("div", { className: r, onClick: n, ...i, children: [
    e && /* @__PURE__ */ E(Fe, { name: e, color: "secondary", size: "5xl" }),
    /* @__PURE__ */ E("div", { className: "info-card-text", children: t })
  ] });
}
const vc = "_carousel_13fwf_1", cr = {
  carousel: vc,
  "next-arrow": "_next-arrow_13fwf_10",
  "prev-arrow": "_prev-arrow_13fwf_11"
};
function dm({ children: e, className: t = "", ...n }) {
  var u, b;
  const o = K(null), [i, r] = $e(0), s = i > 0, a = i + (((u = o.current) == null ? void 0 : u.clientWidth) ?? 0) < (((b = o.current) == null ? void 0 : b.scrollWidth) ?? 1);
  ae(() => {
    var I;
    (I = o.current) == null || I.addEventListener("scroll", () => {
      var v;
      return r(((v = o.current) == null ? void 0 : v.scrollLeft) ?? 0);
    });
    const y = o.current;
    return () => {
      y == null || y.removeEventListener("scroll", () => r((y == null ? void 0 : y.scrollLeft) ?? 0));
    };
  }, []);
  function c() {
    o.current && o.current.scrollBy({
      top: 0,
      left: -o.current.offsetWidth,
      behavior: "smooth"
    });
  }
  function p() {
    o.current && o.current.scrollBy({
      top: 0,
      left: o.current.offsetWidth,
      behavior: "smooth"
    });
  }
  const l = X(cr.carousel, t);
  return /* @__PURE__ */ ne("div", { className: l, ref: o, ...n, children: [
    s && /* @__PURE__ */ E("button", { className: cr["prev-arrow"], color: "secondary", onClick: c, children: /* @__PURE__ */ E(Fe, { name: "up-arrow" }) }),
    e,
    a && /* @__PURE__ */ E("button", { className: cr["next-arrow"], color: "secondary", onClick: p, children: /* @__PURE__ */ E(Fe, { name: "up-arrow" }) })
  ] });
}
const hc = {
  "carousel-item": "_carousel-item_1do97_1"
};
function fm({ children: e }) {
  return /* @__PURE__ */ ne("div", { className: hc["carousel-item"], children: [
    " ",
    e
  ] });
}
const bc = "_text_eduhn_1", Pt = {
  text: bc,
  "is-small": "_is-small_eduhn_7",
  "is-ellipsis": "_is-ellipsis_eduhn_11",
  "color-primary": "_color-primary_eduhn_19",
  "color-secondary": "_color-secondary_eduhn_22",
  "color-tertiary": "_color-tertiary_eduhn_25",
  "color-eco-green": "_color-eco-green_eduhn_28",
  "color-success": "_color-success_eduhn_31",
  "color-error": "_color-error_eduhn_34",
  "color-inverted": "_color-inverted_eduhn_37",
  "is-bold": "_is-bold_eduhn_40",
  "size-xs": "_size-xs_eduhn_43",
  "size-sm": "_size-sm_eduhn_46",
  "size-base": "_size-base_eduhn_49",
  "size-lg": "_size-lg_eduhn_52",
  "size-xl": "_size-xl_eduhn_55"
};
function Jo({
  children: e,
  dangerouslySetInnerHTML: t,
  isSmall: n,
  ellipsis: o,
  isSpan: i,
  className: r = "",
  color: s,
  isBold: a,
  size: c,
  ...p
}) {
  const l = X(
    Pt.text,
    n && Pt["is-small"],
    o && Pt["is-ellipsis"],
    s && Pt[`color-${s}`],
    a && Pt["is-bold"],
    c && Pt[`size-${c}`],
    r
  ), u = i ? "span" : "p";
  return t ? /* @__PURE__ */ E(u, { className: l, dangerouslySetInnerHTML: t, ...p }) : /* @__PURE__ */ E(u, { className: l, ...p, children: e });
}
const yc = "_title_nnj9j_1", Ec = "_subtitle_nnj9j_2", bt = {
  title: yc,
  "color-inverted": "_color-inverted_nnj9j_1",
  subtitle: Ec,
  "is-primary": "_is-primary_nnj9j_5",
  "is-secondary": "_is-secondary_nnj9j_9",
  "is-tertiary": "_is-tertiary_nnj9j_13",
  "is-success": "_is-success_nnj9j_17",
  "is-error": "_is-error_nnj9j_21",
  "is-eco-green": "_is-eco-green_nnj9j_25",
  "title-container": "_title-container_nnj9j_30",
  "is-1": "_is-1_nnj9j_43",
  "is-impact": "_is-impact_nnj9j_52",
  "is-2": "_is-2_nnj9j_56",
  "is-3": "_is-3_nnj9j_66"
}, Qo = {
  default: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "color-inverted"
};
function pm({
  color: e = "default",
  children: t,
  level: n = 3,
  hasHeaderTag: o = !1,
  isImpact: i,
  subtitle: r,
  className: s = "",
  ...a
}) {
  const c = `${o ? "h" + n : "p"}`, p = X(
    bt.title,
    bt[`is-${n}`],
    bt[Qo[e]],
    i && bt["is-impact"],
    s
  );
  return /* @__PURE__ */ ne("div", { className: bt["title-container"], children: [
    /* @__PURE__ */ E(c, { className: p, ...a, children: t }),
    r && /* @__PURE__ */ E("p", { className: `${bt.subtitle}  ${e ? bt[Qo[e]] : ""}`, children: r })
  ] });
}
const Ic = "_link_1kbad_1", _n = {
  link: Ic,
  "is-primary": "_is-primary_1kbad_12",
  "is-secondary": "_is-secondary_1kbad_18",
  "is-underlined": "_is-underlined_1kbad_24",
  "is-disabled": "_is-disabled_1kbad_40"
}, $c = {
  primary: "is-primary",
  secondary: "is-secondary"
};
function mm({
  color: e = "primary",
  children: t,
  href: n,
  target: o,
  disabled: i,
  Component: r,
  className: s,
  noUnderline: a = !1,
  ...c
}) {
  const p = X(
    _n.link,
    _n[$c[e]],
    i && _n["is-desabled"],
    !a && _n["is-underlined"],
    s
  );
  return r ? i ? /* @__PURE__ */ E("span", { className: p, ...c, children: t }) : /* @__PURE__ */ E(r, { className: p, href: n, target: o, ...c, children: t }) : i ? /* @__PURE__ */ E("span", { className: p, ...c, children: t }) : /* @__PURE__ */ E("a", { className: p, href: n, target: o, ...c, children: t });
}
const wc = "_block_vgtzn_1", lr = {
  block: wc,
  "is-centered": "_is-centered_vgtzn_5",
  "has-text-left": "_has-text-left_vgtzn_9",
  "has-text-centered": "_has-text-centered_vgtzn_12",
  "has-text-right": "_has-text-right_vgtzn_15",
  "has-text-justified": "_has-text-justified_vgtzn_18"
};
function _m({
  children: e,
  isCentered: t = !1,
  textAlign: n = "left",
  dangerouslySetInnerHTML: o = void 0,
  className: i,
  ...r
}) {
  const s = X(
    lr.block,
    t && lr["is-centered"],
    lr[Cc[n]],
    i
  );
  return o ? /* @__PURE__ */ E("div", { className: s, ...r, dangerouslySetInnerHTML: o }) : /* @__PURE__ */ E("div", { className: s, ...r, children: e });
}
const Cc = {
  left: "has-text-left",
  center: "has-text-centered",
  right: "has-text-right",
  justify: "has-text-justified"
};
function et(e, t) {
  if (e == null)
    return {};
  var n = {}, o = Object.keys(e), i, r;
  for (r = 0; r < o.length; r++)
    i = o[r], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function N() {
  return N = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, N.apply(this, arguments);
}
function ei(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Sr(e, t) {
  return Sr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, i) {
    return o.__proto__ = i, o;
  }, Sr(e, t);
}
function xc(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Sr(e, t);
}
var Tc = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Sc(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Nr = { exports: {} }, ur, ti;
function Wr() {
  if (ti)
    return ur;
  ti = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ur = e, ur;
}
var dr, ni;
function Nc() {
  if (ni)
    return dr;
  ni = 1;
  var e = Wr();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, dr = function() {
    function o(s, a, c, p, l, u) {
      if (u !== e) {
        var b = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw b.name = "Invariant Violation", b;
      }
    }
    o.isRequired = o;
    function i() {
      return o;
    }
    var r = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: i,
      element: o,
      elementType: o,
      instanceOf: i,
      node: o,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return r.PropTypes = r, r;
  }, dr;
}
var gn = { exports: {} }, me = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ri;
function Oc() {
  return ri || (ri = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, r = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, b = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, I = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, $ = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
    function m(R) {
      return typeof R == "string" || typeof R == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      R === o || R === p || R === r || R === i || R === u || R === b || typeof R == "object" && R !== null && (R.$$typeof === I || R.$$typeof === y || R.$$typeof === s || R.$$typeof === a || R.$$typeof === l || R.$$typeof === g || R.$$typeof === $ || R.$$typeof === _ || R.$$typeof === v);
    }
    function f(R) {
      if (typeof R == "object" && R !== null) {
        var be = R.$$typeof;
        switch (be) {
          case t:
            var V = R.type;
            switch (V) {
              case c:
              case p:
              case o:
              case r:
              case i:
              case u:
                return V;
              default:
                var De = V && V.$$typeof;
                switch (De) {
                  case a:
                  case l:
                  case I:
                  case y:
                  case s:
                    return De;
                  default:
                    return be;
                }
            }
          case n:
            return be;
        }
      }
    }
    var d = c, C = p, S = a, T = s, w = t, j = l, Y = o, ee = I, ue = y, re = n, fe = r, Ee = i, oe = u, Pe = !1;
    function Me(R) {
      return Pe || (Pe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), x(R) || f(R) === c;
    }
    function x(R) {
      return f(R) === p;
    }
    function L(R) {
      return f(R) === a;
    }
    function J(R) {
      return f(R) === s;
    }
    function G(R) {
      return typeof R == "object" && R !== null && R.$$typeof === t;
    }
    function D(R) {
      return f(R) === l;
    }
    function M(R) {
      return f(R) === o;
    }
    function P(R) {
      return f(R) === I;
    }
    function F(R) {
      return f(R) === y;
    }
    function q(R) {
      return f(R) === n;
    }
    function z(R) {
      return f(R) === r;
    }
    function W(R) {
      return f(R) === i;
    }
    function de(R) {
      return f(R) === u;
    }
    me.AsyncMode = d, me.ConcurrentMode = C, me.ContextConsumer = S, me.ContextProvider = T, me.Element = w, me.ForwardRef = j, me.Fragment = Y, me.Lazy = ee, me.Memo = ue, me.Portal = re, me.Profiler = fe, me.StrictMode = Ee, me.Suspense = oe, me.isAsyncMode = Me, me.isConcurrentMode = x, me.isContextConsumer = L, me.isContextProvider = J, me.isElement = G, me.isForwardRef = D, me.isFragment = M, me.isLazy = P, me.isMemo = F, me.isPortal = q, me.isProfiler = z, me.isStrictMode = W, me.isSuspense = de, me.isValidElementType = m, me.typeOf = f;
  }()), me;
}
var _e = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var oi;
function Rc() {
  if (oi)
    return _e;
  oi = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, r = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, b = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, I = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, $ = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
  function m(d) {
    if (typeof d == "object" && d !== null) {
      var C = d.$$typeof;
      switch (C) {
        case t:
          switch (d = d.type, d) {
            case c:
            case p:
            case o:
            case r:
            case i:
            case u:
              return d;
            default:
              switch (d = d && d.$$typeof, d) {
                case a:
                case l:
                case I:
                case y:
                case s:
                  return d;
                default:
                  return C;
              }
          }
        case n:
          return C;
      }
    }
  }
  function f(d) {
    return m(d) === p;
  }
  return _e.AsyncMode = c, _e.ConcurrentMode = p, _e.ContextConsumer = a, _e.ContextProvider = s, _e.Element = t, _e.ForwardRef = l, _e.Fragment = o, _e.Lazy = I, _e.Memo = y, _e.Portal = n, _e.Profiler = r, _e.StrictMode = i, _e.Suspense = u, _e.isAsyncMode = function(d) {
    return f(d) || m(d) === c;
  }, _e.isConcurrentMode = f, _e.isContextConsumer = function(d) {
    return m(d) === a;
  }, _e.isContextProvider = function(d) {
    return m(d) === s;
  }, _e.isElement = function(d) {
    return typeof d == "object" && d !== null && d.$$typeof === t;
  }, _e.isForwardRef = function(d) {
    return m(d) === l;
  }, _e.isFragment = function(d) {
    return m(d) === o;
  }, _e.isLazy = function(d) {
    return m(d) === I;
  }, _e.isMemo = function(d) {
    return m(d) === y;
  }, _e.isPortal = function(d) {
    return m(d) === n;
  }, _e.isProfiler = function(d) {
    return m(d) === r;
  }, _e.isStrictMode = function(d) {
    return m(d) === i;
  }, _e.isSuspense = function(d) {
    return m(d) === u;
  }, _e.isValidElementType = function(d) {
    return typeof d == "string" || typeof d == "function" || d === o || d === p || d === r || d === i || d === u || d === b || typeof d == "object" && d !== null && (d.$$typeof === I || d.$$typeof === y || d.$$typeof === s || d.$$typeof === a || d.$$typeof === l || d.$$typeof === g || d.$$typeof === $ || d.$$typeof === _ || d.$$typeof === v);
  }, _e.typeOf = m, _e;
}
var ii;
function Zi() {
  return ii || (ii = 1, process.env.NODE_ENV === "production" ? gn.exports = Rc() : gn.exports = Oc()), gn.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var fr, si;
function Ac() {
  if (si)
    return fr;
  si = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function o(r) {
    if (r == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(r);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var r = new String("abc");
      if (r[5] = "de", Object.getOwnPropertyNames(r)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var c = Object.getOwnPropertyNames(s).map(function(l) {
        return s[l];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(l) {
        p[l] = l;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return fr = i() ? Object.assign : function(r, s) {
    for (var a, c = o(r), p, l = 1; l < arguments.length; l++) {
      a = Object(arguments[l]);
      for (var u in a)
        t.call(a, u) && (c[u] = a[u]);
      if (e) {
        p = e(a);
        for (var b = 0; b < p.length; b++)
          n.call(a, p[b]) && (c[p[b]] = a[p[b]]);
      }
    }
    return c;
  }, fr;
}
var pr, ai;
function Ji() {
  return ai || (ai = 1, pr = Function.call.bind(Object.prototype.hasOwnProperty)), pr;
}
var mr, ci;
function Dc() {
  if (ci)
    return mr;
  ci = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Wr(), n = {}, o = Ji();
    e = function(r) {
      var s = "Warning: " + r;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function i(r, s, a, c, p) {
    if (process.env.NODE_ENV !== "production") {
      for (var l in r)
        if (o(r, l)) {
          var u;
          try {
            if (typeof r[l] != "function") {
              var b = Error(
                (c || "React class") + ": " + a + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw b.name = "Invariant Violation", b;
            }
            u = r[l](s, l, c, a, null, t);
          } catch (I) {
            u = I;
          }
          if (u && !(u instanceof Error) && e(
            (c || "React class") + ": type specification of " + a + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), u instanceof Error && !(u.message in n)) {
            n[u.message] = !0;
            var y = p ? p() : "";
            e(
              "Failed " + a + " type: " + u.message + (y ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, mr = i, mr;
}
var _r, li;
function Pc() {
  if (li)
    return _r;
  li = 1;
  var e = Zi(), t = Ac(), n = Wr(), o = Ji(), i = Dc(), r = function() {
  };
  process.env.NODE_ENV !== "production" && (r = function(a) {
    var c = "Warning: " + a;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return _r = function(a, c) {
    var p = typeof Symbol == "function" && Symbol.iterator, l = "@@iterator";
    function u(x) {
      var L = x && (p && x[p] || x[l]);
      if (typeof L == "function")
        return L;
    }
    var b = "<<anonymous>>", y = {
      array: $("array"),
      bigint: $("bigint"),
      bool: $("boolean"),
      func: $("function"),
      number: $("number"),
      object: $("object"),
      string: $("string"),
      symbol: $("symbol"),
      any: _(),
      arrayOf: m,
      element: f(),
      elementType: d(),
      instanceOf: C,
      node: j(),
      objectOf: T,
      oneOf: S,
      oneOfType: w,
      shape: ee,
      exact: ue
    };
    function I(x, L) {
      return x === L ? x !== 0 || 1 / x === 1 / L : x !== x && L !== L;
    }
    function v(x, L) {
      this.message = x, this.data = L && typeof L == "object" ? L : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function g(x) {
      if (process.env.NODE_ENV !== "production")
        var L = {}, J = 0;
      function G(M, P, F, q, z, W, de) {
        if (q = q || b, W = W || F, de !== n) {
          if (c) {
            var R = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw R.name = "Invariant Violation", R;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var be = q + ":" + F;
            !L[be] && // Avoid spamming the console because they are often not actionable except for lib authors
            J < 3 && (r(
              "You are manually calling a React.PropTypes validation function for the `" + W + "` prop on `" + q + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), L[be] = !0, J++);
          }
        }
        return P[F] == null ? M ? P[F] === null ? new v("The " + z + " `" + W + "` is marked as required " + ("in `" + q + "`, but its value is `null`.")) : new v("The " + z + " `" + W + "` is marked as required in " + ("`" + q + "`, but its value is `undefined`.")) : null : x(P, F, q, z, W);
      }
      var D = G.bind(null, !1);
      return D.isRequired = G.bind(null, !0), D;
    }
    function $(x) {
      function L(J, G, D, M, P, F) {
        var q = J[G], z = Ee(q);
        if (z !== x) {
          var W = oe(q);
          return new v(
            "Invalid " + M + " `" + P + "` of type " + ("`" + W + "` supplied to `" + D + "`, expected ") + ("`" + x + "`."),
            { expectedType: x }
          );
        }
        return null;
      }
      return g(L);
    }
    function _() {
      return g(s);
    }
    function m(x) {
      function L(J, G, D, M, P) {
        if (typeof x != "function")
          return new v("Property `" + P + "` of component `" + D + "` has invalid PropType notation inside arrayOf.");
        var F = J[G];
        if (!Array.isArray(F)) {
          var q = Ee(F);
          return new v("Invalid " + M + " `" + P + "` of type " + ("`" + q + "` supplied to `" + D + "`, expected an array."));
        }
        for (var z = 0; z < F.length; z++) {
          var W = x(F, z, D, M, P + "[" + z + "]", n);
          if (W instanceof Error)
            return W;
        }
        return null;
      }
      return g(L);
    }
    function f() {
      function x(L, J, G, D, M) {
        var P = L[J];
        if (!a(P)) {
          var F = Ee(P);
          return new v("Invalid " + D + " `" + M + "` of type " + ("`" + F + "` supplied to `" + G + "`, expected a single ReactElement."));
        }
        return null;
      }
      return g(x);
    }
    function d() {
      function x(L, J, G, D, M) {
        var P = L[J];
        if (!e.isValidElementType(P)) {
          var F = Ee(P);
          return new v("Invalid " + D + " `" + M + "` of type " + ("`" + F + "` supplied to `" + G + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return g(x);
    }
    function C(x) {
      function L(J, G, D, M, P) {
        if (!(J[G] instanceof x)) {
          var F = x.name || b, q = Me(J[G]);
          return new v("Invalid " + M + " `" + P + "` of type " + ("`" + q + "` supplied to `" + D + "`, expected ") + ("instance of `" + F + "`."));
        }
        return null;
      }
      return g(L);
    }
    function S(x) {
      if (!Array.isArray(x))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? r(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : r("Invalid argument supplied to oneOf, expected an array.")), s;
      function L(J, G, D, M, P) {
        for (var F = J[G], q = 0; q < x.length; q++)
          if (I(F, x[q]))
            return null;
        var z = JSON.stringify(x, function(de, R) {
          var be = oe(R);
          return be === "symbol" ? String(R) : R;
        });
        return new v("Invalid " + M + " `" + P + "` of value `" + String(F) + "` " + ("supplied to `" + D + "`, expected one of " + z + "."));
      }
      return g(L);
    }
    function T(x) {
      function L(J, G, D, M, P) {
        if (typeof x != "function")
          return new v("Property `" + P + "` of component `" + D + "` has invalid PropType notation inside objectOf.");
        var F = J[G], q = Ee(F);
        if (q !== "object")
          return new v("Invalid " + M + " `" + P + "` of type " + ("`" + q + "` supplied to `" + D + "`, expected an object."));
        for (var z in F)
          if (o(F, z)) {
            var W = x(F, z, D, M, P + "." + z, n);
            if (W instanceof Error)
              return W;
          }
        return null;
      }
      return g(L);
    }
    function w(x) {
      if (!Array.isArray(x))
        return process.env.NODE_ENV !== "production" && r("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var L = 0; L < x.length; L++) {
        var J = x[L];
        if (typeof J != "function")
          return r(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Pe(J) + " at index " + L + "."
          ), s;
      }
      function G(D, M, P, F, q) {
        for (var z = [], W = 0; W < x.length; W++) {
          var de = x[W], R = de(D, M, P, F, q, n);
          if (R == null)
            return null;
          R.data && o(R.data, "expectedType") && z.push(R.data.expectedType);
        }
        var be = z.length > 0 ? ", expected one of type [" + z.join(", ") + "]" : "";
        return new v("Invalid " + F + " `" + q + "` supplied to " + ("`" + P + "`" + be + "."));
      }
      return g(G);
    }
    function j() {
      function x(L, J, G, D, M) {
        return re(L[J]) ? null : new v("Invalid " + D + " `" + M + "` supplied to " + ("`" + G + "`, expected a ReactNode."));
      }
      return g(x);
    }
    function Y(x, L, J, G, D) {
      return new v(
        (x || "React class") + ": " + L + " type `" + J + "." + G + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + D + "`."
      );
    }
    function ee(x) {
      function L(J, G, D, M, P) {
        var F = J[G], q = Ee(F);
        if (q !== "object")
          return new v("Invalid " + M + " `" + P + "` of type `" + q + "` " + ("supplied to `" + D + "`, expected `object`."));
        for (var z in x) {
          var W = x[z];
          if (typeof W != "function")
            return Y(D, M, P, z, oe(W));
          var de = W(F, z, D, M, P + "." + z, n);
          if (de)
            return de;
        }
        return null;
      }
      return g(L);
    }
    function ue(x) {
      function L(J, G, D, M, P) {
        var F = J[G], q = Ee(F);
        if (q !== "object")
          return new v("Invalid " + M + " `" + P + "` of type `" + q + "` " + ("supplied to `" + D + "`, expected `object`."));
        var z = t({}, J[G], x);
        for (var W in z) {
          var de = x[W];
          if (o(x, W) && typeof de != "function")
            return Y(D, M, P, W, oe(de));
          if (!de)
            return new v(
              "Invalid " + M + " `" + P + "` key `" + W + "` supplied to `" + D + "`.\nBad object: " + JSON.stringify(J[G], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(x), null, "  ")
            );
          var R = de(F, W, D, M, P + "." + W, n);
          if (R)
            return R;
        }
        return null;
      }
      return g(L);
    }
    function re(x) {
      switch (typeof x) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !x;
        case "object":
          if (Array.isArray(x))
            return x.every(re);
          if (x === null || a(x))
            return !0;
          var L = u(x);
          if (L) {
            var J = L.call(x), G;
            if (L !== x.entries) {
              for (; !(G = J.next()).done; )
                if (!re(G.value))
                  return !1;
            } else
              for (; !(G = J.next()).done; ) {
                var D = G.value;
                if (D && !re(D[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function fe(x, L) {
      return x === "symbol" ? !0 : L ? L["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && L instanceof Symbol : !1;
    }
    function Ee(x) {
      var L = typeof x;
      return Array.isArray(x) ? "array" : x instanceof RegExp ? "object" : fe(L, x) ? "symbol" : L;
    }
    function oe(x) {
      if (typeof x > "u" || x === null)
        return "" + x;
      var L = Ee(x);
      if (L === "object") {
        if (x instanceof Date)
          return "date";
        if (x instanceof RegExp)
          return "regexp";
      }
      return L;
    }
    function Pe(x) {
      var L = oe(x);
      switch (L) {
        case "array":
        case "object":
          return "an " + L;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + L;
        default:
          return L;
      }
    }
    function Me(x) {
      return !x.constructor || !x.constructor.name ? b : x.constructor.name;
    }
    return y.checkPropTypes = i, y.resetWarningCache = i.resetWarningCache, y.PropTypes = y, y;
  }, _r;
}
if (process.env.NODE_ENV !== "production") {
  var Mc = Zi(), kc = !0;
  Nr.exports = Pc()(Mc.isElement, kc);
} else
  Nr.exports = Nc()();
var Lc = Nr.exports;
const O = /* @__PURE__ */ Sc(Lc);
var Or = { exports: {} }, ge = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ui;
function Fc() {
  return ui || (ui = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), r = Symbol.for("react.provider"), s = Symbol.for("react.context"), a = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), b = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), I = !1, v = !1, g = !1, $ = !1, _ = !1, m;
    m = Symbol.for("react.module.reference");
    function f(V) {
      return !!(typeof V == "string" || typeof V == "function" || V === n || V === i || _ || V === o || V === p || V === l || $ || V === y || I || v || g || typeof V == "object" && V !== null && (V.$$typeof === b || V.$$typeof === u || V.$$typeof === r || V.$$typeof === s || V.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      V.$$typeof === m || V.getModuleId !== void 0));
    }
    function d(V) {
      if (typeof V == "object" && V !== null) {
        var De = V.$$typeof;
        switch (De) {
          case e:
            var xe = V.type;
            switch (xe) {
              case n:
              case i:
              case o:
              case p:
              case l:
                return xe;
              default:
                var lt = xe && xe.$$typeof;
                switch (lt) {
                  case a:
                  case s:
                  case c:
                  case b:
                  case u:
                  case r:
                    return lt;
                  default:
                    return De;
                }
            }
          case t:
            return De;
        }
      }
    }
    var C = s, S = r, T = e, w = c, j = n, Y = b, ee = u, ue = t, re = i, fe = o, Ee = p, oe = l, Pe = !1, Me = !1;
    function x(V) {
      return Pe || (Pe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function L(V) {
      return Me || (Me = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function J(V) {
      return d(V) === s;
    }
    function G(V) {
      return d(V) === r;
    }
    function D(V) {
      return typeof V == "object" && V !== null && V.$$typeof === e;
    }
    function M(V) {
      return d(V) === c;
    }
    function P(V) {
      return d(V) === n;
    }
    function F(V) {
      return d(V) === b;
    }
    function q(V) {
      return d(V) === u;
    }
    function z(V) {
      return d(V) === t;
    }
    function W(V) {
      return d(V) === i;
    }
    function de(V) {
      return d(V) === o;
    }
    function R(V) {
      return d(V) === p;
    }
    function be(V) {
      return d(V) === l;
    }
    ge.ContextConsumer = C, ge.ContextProvider = S, ge.Element = T, ge.ForwardRef = w, ge.Fragment = j, ge.Lazy = Y, ge.Memo = ee, ge.Portal = ue, ge.Profiler = re, ge.StrictMode = fe, ge.Suspense = Ee, ge.SuspenseList = oe, ge.isAsyncMode = x, ge.isConcurrentMode = L, ge.isContextConsumer = J, ge.isContextProvider = G, ge.isElement = D, ge.isForwardRef = M, ge.isFragment = P, ge.isLazy = F, ge.isMemo = q, ge.isPortal = z, ge.isProfiler = W, ge.isStrictMode = de, ge.isSuspense = R, ge.isSuspenseList = be, ge.isValidElementType = f, ge.typeOf = d;
  }()), ge;
}
var ve = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var di;
function Vc() {
  if (di)
    return ve;
  di = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), r = Symbol.for("react.provider"), s = Symbol.for("react.context"), a = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), b = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), I;
  I = Symbol.for("react.module.reference");
  function v(g) {
    if (typeof g == "object" && g !== null) {
      var $ = g.$$typeof;
      switch ($) {
        case e:
          switch (g = g.type, g) {
            case n:
            case i:
            case o:
            case p:
            case l:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case a:
                case s:
                case c:
                case b:
                case u:
                case r:
                  return g;
                default:
                  return $;
              }
          }
        case t:
          return $;
      }
    }
  }
  return ve.ContextConsumer = s, ve.ContextProvider = r, ve.Element = e, ve.ForwardRef = c, ve.Fragment = n, ve.Lazy = b, ve.Memo = u, ve.Portal = t, ve.Profiler = i, ve.StrictMode = o, ve.Suspense = p, ve.SuspenseList = l, ve.isAsyncMode = function() {
    return !1;
  }, ve.isConcurrentMode = function() {
    return !1;
  }, ve.isContextConsumer = function(g) {
    return v(g) === s;
  }, ve.isContextProvider = function(g) {
    return v(g) === r;
  }, ve.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === e;
  }, ve.isForwardRef = function(g) {
    return v(g) === c;
  }, ve.isFragment = function(g) {
    return v(g) === n;
  }, ve.isLazy = function(g) {
    return v(g) === b;
  }, ve.isMemo = function(g) {
    return v(g) === u;
  }, ve.isPortal = function(g) {
    return v(g) === t;
  }, ve.isProfiler = function(g) {
    return v(g) === i;
  }, ve.isStrictMode = function(g) {
    return v(g) === o;
  }, ve.isSuspense = function(g) {
    return v(g) === p;
  }, ve.isSuspenseList = function(g) {
    return v(g) === l;
  }, ve.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === n || g === i || g === o || g === p || g === l || g === y || typeof g == "object" && g !== null && (g.$$typeof === b || g.$$typeof === u || g.$$typeof === r || g.$$typeof === s || g.$$typeof === c || g.$$typeof === I || g.getModuleId !== void 0);
  }, ve.typeOf = v, ve;
}
process.env.NODE_ENV === "production" ? Or.exports = Vc() : Or.exports = Fc();
var fi = Or.exports;
const pi = (e) => typeof e == "object" && e != null && e.nodeType === 1, mi = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip", gr = (e, t) => {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    const n = getComputedStyle(e, null);
    return mi(n.overflowY, t) || mi(n.overflowX, t) || ((o) => {
      const i = ((r) => {
        if (!r.ownerDocument || !r.ownerDocument.defaultView)
          return null;
        try {
          return r.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(o);
      return !!i && (i.clientHeight < o.scrollHeight || i.clientWidth < o.scrollWidth);
    })(e);
  }
  return !1;
}, vn = (e, t, n, o, i, r, s, a) => r < e && s > t || r > e && s < t ? 0 : r <= e && a <= n || s >= t && a >= n ? r - e - o : s > t && a < n || r < e && a > n ? s - t + i : 0, jc = (e) => {
  const t = e.parentElement;
  return t ?? (e.getRootNode().host || null);
}, Hc = (e, t) => {
  var n, o, i, r;
  if (typeof document > "u")
    return [];
  const { scrollMode: s, block: a, inline: c, boundary: p, skipOverflowHiddenElements: l } = t, u = typeof p == "function" ? p : (Ee) => Ee !== p;
  if (!pi(e))
    throw new TypeError("Invalid target");
  const b = document.scrollingElement || document.documentElement, y = [];
  let I = e;
  for (; pi(I) && u(I); ) {
    if (I = jc(I), I === b) {
      y.push(I);
      break;
    }
    I != null && I === document.body && gr(I) && !gr(document.documentElement) || I != null && gr(I, l) && y.push(I);
  }
  const v = (o = (n = window.visualViewport) == null ? void 0 : n.width) != null ? o : innerWidth, g = (r = (i = window.visualViewport) == null ? void 0 : i.height) != null ? r : innerHeight, { scrollX: $, scrollY: _ } = window, { height: m, width: f, top: d, right: C, bottom: S, left: T } = e.getBoundingClientRect(), { top: w, right: j, bottom: Y, left: ee } = ((Ee) => {
    const oe = window.getComputedStyle(Ee);
    return { top: parseFloat(oe.scrollMarginTop) || 0, right: parseFloat(oe.scrollMarginRight) || 0, bottom: parseFloat(oe.scrollMarginBottom) || 0, left: parseFloat(oe.scrollMarginLeft) || 0 };
  })(e);
  let ue = a === "start" || a === "nearest" ? d - w : a === "end" ? S + Y : d + m / 2 - w + Y, re = c === "center" ? T + f / 2 - ee + j : c === "end" ? C + j : T - ee;
  const fe = [];
  for (let Ee = 0; Ee < y.length; Ee++) {
    const oe = y[Ee], { height: Pe, width: Me, top: x, right: L, bottom: J, left: G } = oe.getBoundingClientRect();
    if (s === "if-needed" && d >= 0 && T >= 0 && S <= g && C <= v && d >= x && S <= J && T >= G && C <= L)
      return fe;
    const D = getComputedStyle(oe), M = parseInt(D.borderLeftWidth, 10), P = parseInt(D.borderTopWidth, 10), F = parseInt(D.borderRightWidth, 10), q = parseInt(D.borderBottomWidth, 10);
    let z = 0, W = 0;
    const de = "offsetWidth" in oe ? oe.offsetWidth - oe.clientWidth - M - F : 0, R = "offsetHeight" in oe ? oe.offsetHeight - oe.clientHeight - P - q : 0, be = "offsetWidth" in oe ? oe.offsetWidth === 0 ? 0 : Me / oe.offsetWidth : 0, V = "offsetHeight" in oe ? oe.offsetHeight === 0 ? 0 : Pe / oe.offsetHeight : 0;
    if (b === oe)
      z = a === "start" ? ue : a === "end" ? ue - g : a === "nearest" ? vn(_, _ + g, g, P, q, _ + ue, _ + ue + m, m) : ue - g / 2, W = c === "start" ? re : c === "center" ? re - v / 2 : c === "end" ? re - v : vn($, $ + v, v, M, F, $ + re, $ + re + f, f), z = Math.max(0, z + _), W = Math.max(0, W + $);
    else {
      z = a === "start" ? ue - x - P : a === "end" ? ue - J + q + R : a === "nearest" ? vn(x, J, Pe, P, q + R, ue, ue + m, m) : ue - (x + Pe / 2) + R / 2, W = c === "start" ? re - G - M : c === "center" ? re - (G + Me / 2) + de / 2 : c === "end" ? re - L + F + de : vn(G, L, Me, M, F + de, re, re + f, f);
      const { scrollLeft: De, scrollTop: xe } = oe;
      z = V === 0 ? 0 : Math.max(0, Math.min(xe + z / V, oe.scrollHeight - Pe / V + R)), W = be === 0 ? 0 : Math.max(0, Math.min(De + W / be, oe.scrollWidth - Me / be + de)), ue += xe - z, re += De - W;
    }
    fe.push({ el: oe, top: z, left: W });
  }
  return fe;
};
var Ke = function() {
  return Ke = Object.assign || function(t) {
    for (var n, o = 1, i = arguments.length; o < i; o++) {
      n = arguments[o];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Ke.apply(this, arguments);
};
function Qi(e, t) {
  var n = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, o = Object.getOwnPropertySymbols(e); i < o.length; i++)
      t.indexOf(o[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[i]) && (n[o[i]] = e[o[i]]);
  return n;
}
function Uc(e, t, n) {
  if (n || arguments.length === 2)
    for (var o = 0, i = t.length, r; o < i; o++)
      (r || !(o in t)) && (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}
var Bc = 0;
function _i(e) {
  return typeof e == "function" ? e : qe;
}
function qe() {
}
function es(e, t) {
  if (e) {
    var n = Hc(e, {
      boundary: t,
      block: "nearest",
      scrollMode: "if-needed"
    });
    n.forEach(function(o) {
      var i = o.el, r = o.top, s = o.left;
      i.scrollTop = r, i.scrollLeft = s;
    });
  }
}
function gi(e, t, n) {
  var o = e === t || t instanceof n.Node && e.contains && e.contains(t);
  return o;
}
function zr(e, t) {
  var n;
  function o() {
    n && clearTimeout(n);
  }
  function i() {
    for (var r = arguments.length, s = new Array(r), a = 0; a < r; a++)
      s[a] = arguments[a];
    o(), n = setTimeout(function() {
      n = null, e.apply(void 0, s);
    }, t);
  }
  return i.cancel = o, i;
}
function Ne() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(o) {
    for (var i = arguments.length, r = new Array(i > 1 ? i - 1 : 0), s = 1; s < i; s++)
      r[s - 1] = arguments[s];
    return t.some(function(a) {
      return a && a.apply(void 0, [o].concat(r)), o.preventDownshiftDefault || o.hasOwnProperty("nativeEvent") && o.nativeEvent.preventDownshiftDefault;
    });
  };
}
function jt() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(o) {
    t.forEach(function(i) {
      typeof i == "function" ? i(o) : i && (i.current = o);
    });
  };
}
function ts() {
  return String(Bc++);
}
function ns(e) {
  var t = e.isOpen, n = e.resultCount, o = e.previousResultCount;
  return t ? n ? n !== o ? n + " result" + (n === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function vi(e, t) {
  return e = Array.isArray(e) ? (
    /* istanbul ignore next (preact) */
    e[0]
  ) : e, !e && t ? t : e;
}
function rs(e) {
  return typeof e.type == "string";
}
function os(e) {
  return e.props;
}
function Kc(e, t) {
  console.error('The property "' + t + '" is required in "' + e + '"');
}
var Wc = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function hn(e) {
  e === void 0 && (e = {});
  var t = {};
  return Wc.forEach(function(n) {
    e.hasOwnProperty(n) && (t[n] = e[n]);
  }), t;
}
function An(e, t) {
  return Object.keys(e).reduce(function(n, o) {
    return n[o] = Dn(t, o) ? t[o] : e[o], n;
  }, {});
}
function Dn(e, t) {
  return e[t] !== void 0;
}
function Rr(e) {
  var t = e.key, n = e.keyCode;
  return n >= 37 && n <= 40 && t.indexOf("Arrow") !== 0 ? "Arrow" + t : t;
}
function zc(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Et(e, t, n, o, i) {
  i === void 0 && (i = !1);
  var r = n.length;
  if (r === 0)
    return -1;
  var s = r - 1;
  (typeof e != "number" || e < 0 || e > s) && (e = t > 0 ? -1 : s + 1);
  var a = e + t;
  a < 0 ? a = i ? s : 0 : a > s && (a = i ? 0 : s);
  var c = Ut(a, t < 0, n, o, i);
  return c === -1 ? e >= r ? -1 : e : c;
}
function Ut(e, t, n, o, i) {
  i === void 0 && (i = !1);
  var r = n.length;
  if (t) {
    for (var s = e; s >= 0; s--)
      if (!o(n[s], s))
        return s;
  } else
    for (var a = e; a < r; a++)
      if (!o(n[a], a))
        return a;
  return i ? Ut(t ? r - 1 : 0, t, n, o) : -1;
}
function Pn(e, t, n, o) {
  return o === void 0 && (o = !0), n && t.some(function(i) {
    return i && (gi(i, e, n) || o && gi(i, n.document.activeElement, n));
  });
}
var Yr = qe;
process.env.NODE_ENV !== "production" && (Yr = function(t, n, o) {
  var i = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(t).forEach(function(r) {
    n[r] !== void 0 && o[r] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + r + '" to be uncontrolled. ' + i) : n[r] === void 0 && o[r] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + r + '" to be controlled. ' + i);
  });
});
var Yc = zr(function(e) {
  is(e).textContent = "";
}, 500);
function is(e) {
  var t = e.getElementById("a11y-status-message");
  return t || (t = e.createElement("div"), t.setAttribute("id", "a11y-status-message"), t.setAttribute("role", "status"), t.setAttribute("aria-live", "polite"), t.setAttribute("aria-relevant", "additions text"), Object.assign(t.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), e.body.appendChild(t), t);
}
function ss(e, t) {
  if (!(!e || !t)) {
    var n = is(t);
    n.textContent = e, Yc(t);
  }
}
var as = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, cs = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, ls = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, Cn = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, xn = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, us = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, ds = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, fs = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, ps = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, ms = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, _s = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, gs = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, vs = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, Ar = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, hs = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, bs = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, ys = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, Gc = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  unknown: as,
  mouseUp: cs,
  itemMouseEnter: ls,
  keyDownArrowUp: Cn,
  keyDownArrowDown: xn,
  keyDownEscape: us,
  keyDownEnter: ds,
  keyDownHome: fs,
  keyDownEnd: ps,
  clickItem: ms,
  blurInput: _s,
  changeInput: gs,
  keyDownSpaceButton: vs,
  clickButton: Ar,
  blurButton: hs,
  controlledPropUpdatedSelectedItem: bs,
  touchEnd: ys
}), qc = ["refKey", "ref"], Xc = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], Zc = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], Jc = ["refKey", "ref"], Qc = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], el = /* @__PURE__ */ function() {
  var e = /* @__PURE__ */ function(t) {
    xc(n, t);
    function n(i) {
      var r;
      r = t.call(this, i) || this, r.id = r.props.id || "downshift-" + ts(), r.menuId = r.props.menuId || r.id + "-menu", r.labelId = r.props.labelId || r.id + "-label", r.inputId = r.props.inputId || r.id + "-input", r.getItemId = r.props.getItemId || function(_) {
        return r.id + "-item-" + _;
      }, r.items = [], r.itemCount = null, r.previousResultCount = 0, r.timeoutIds = [], r.internalSetTimeout = function(_, m) {
        var f = setTimeout(function() {
          r.timeoutIds = r.timeoutIds.filter(function(d) {
            return d !== f;
          }), _();
        }, m);
        r.timeoutIds.push(f);
      }, r.setItemCount = function(_) {
        r.itemCount = _;
      }, r.unsetItemCount = function() {
        r.itemCount = null;
      }, r.isItemDisabled = function(_, m) {
        var f = r.getItemNodeFromIndex(m);
        return f && f.hasAttribute("disabled");
      }, r.setHighlightedIndex = function(_, m) {
        _ === void 0 && (_ = r.props.defaultHighlightedIndex), m === void 0 && (m = {}), m = hn(m), r.internalSetState(N({
          highlightedIndex: _
        }, m));
      }, r.clearSelection = function(_) {
        r.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: r.props.defaultHighlightedIndex,
          isOpen: r.props.defaultIsOpen
        }, _);
      }, r.selectItem = function(_, m, f) {
        m = hn(m), r.internalSetState(N({
          isOpen: r.props.defaultIsOpen,
          highlightedIndex: r.props.defaultHighlightedIndex,
          selectedItem: _,
          inputValue: r.props.itemToString(_)
        }, m), f);
      }, r.selectItemAtIndex = function(_, m, f) {
        var d = r.items[_];
        d != null && r.selectItem(d, m, f);
      }, r.selectHighlightedItem = function(_, m) {
        return r.selectItemAtIndex(r.getState().highlightedIndex, _, m);
      }, r.internalSetState = function(_, m) {
        var f, d, C = {}, S = typeof _ == "function";
        return !S && _.hasOwnProperty("inputValue") && r.props.onInputValueChange(_.inputValue, N({}, r.getStateAndHelpers(), _)), r.setState(function(T) {
          var w;
          T = r.getState(T);
          var j = S ? _(T) : _;
          j = r.props.stateReducer(T, j), f = j.hasOwnProperty("selectedItem");
          var Y = {};
          return f && j.selectedItem !== T.selectedItem && (d = j.selectedItem), (w = j).type || (w.type = as), Object.keys(j).forEach(function(ee) {
            T[ee] !== j[ee] && (C[ee] = j[ee]), ee !== "type" && (j[ee], Dn(r.props, ee) || (Y[ee] = j[ee]));
          }), S && j.hasOwnProperty("inputValue") && r.props.onInputValueChange(j.inputValue, N({}, r.getStateAndHelpers(), j)), Y;
        }, function() {
          _i(m)();
          var T = Object.keys(C).length > 1;
          T && r.props.onStateChange(C, r.getStateAndHelpers()), f && r.props.onSelect(_.selectedItem, r.getStateAndHelpers()), d !== void 0 && r.props.onChange(d, r.getStateAndHelpers()), r.props.onUserAction(C, r.getStateAndHelpers());
        });
      }, r.rootRef = function(_) {
        return r._rootNode = _;
      }, r.getRootProps = function(_, m) {
        var f, d = _ === void 0 ? {} : _, C = d.refKey, S = C === void 0 ? "ref" : C, T = d.ref, w = et(d, qc), j = m === void 0 ? {} : m, Y = j.suppressRefError, ee = Y === void 0 ? !1 : Y;
        r.getRootProps.called = !0, r.getRootProps.refKey = S, r.getRootProps.suppressRefError = ee;
        var ue = r.getState(), re = ue.isOpen;
        return N((f = {}, f[S] = jt(T, r.rootRef), f.role = "combobox", f["aria-expanded"] = re, f["aria-haspopup"] = "listbox", f["aria-owns"] = re ? r.menuId : void 0, f["aria-labelledby"] = r.labelId, f), w);
      }, r.keyDownHandlers = {
        ArrowDown: function(m) {
          var f = this;
          if (m.preventDefault(), this.getState().isOpen) {
            var d = m.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(d, {
              type: xn
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: xn
            }, function() {
              var C = f.getItemCount();
              if (C > 0) {
                var S = f.getState(), T = S.highlightedIndex, w = Et(T, 1, {
                  length: C
                }, f.isItemDisabled, !0);
                f.setHighlightedIndex(w, {
                  type: xn
                });
              }
            });
        },
        ArrowUp: function(m) {
          var f = this;
          if (m.preventDefault(), this.getState().isOpen) {
            var d = m.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(d, {
              type: Cn
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: Cn
            }, function() {
              var C = f.getItemCount();
              if (C > 0) {
                var S = f.getState(), T = S.highlightedIndex, w = Et(T, -1, {
                  length: C
                }, f.isItemDisabled, !0);
                f.setHighlightedIndex(w, {
                  type: Cn
                });
              }
            });
        },
        Enter: function(m) {
          if (m.which !== 229) {
            var f = this.getState(), d = f.isOpen, C = f.highlightedIndex;
            if (d && C != null) {
              m.preventDefault();
              var S = this.items[C], T = this.getItemNodeFromIndex(C);
              if (S == null || T && T.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: ds
              });
            }
          }
        },
        Escape: function(m) {
          m.preventDefault(), this.reset(N({
            type: us
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, r.buttonKeyDownHandlers = N({}, r.keyDownHandlers, {
        " ": function(m) {
          m.preventDefault(), this.toggleMenu({
            type: vs
          });
        }
      }), r.inputKeyDownHandlers = N({}, r.keyDownHandlers, {
        Home: function(m) {
          var f = this.getState(), d = f.isOpen;
          if (d) {
            m.preventDefault();
            var C = this.getItemCount();
            if (!(C <= 0 || !d)) {
              var S = Ut(0, !1, {
                length: C
              }, this.isItemDisabled);
              this.setHighlightedIndex(S, {
                type: fs
              });
            }
          }
        },
        End: function(m) {
          var f = this.getState(), d = f.isOpen;
          if (d) {
            m.preventDefault();
            var C = this.getItemCount();
            if (!(C <= 0 || !d)) {
              var S = Ut(C - 1, !0, {
                length: C
              }, this.isItemDisabled);
              this.setHighlightedIndex(S, {
                type: ps
              });
            }
          }
        }
      }), r.getToggleButtonProps = function(_) {
        var m = _ === void 0 ? {} : _, f = m.onClick;
        m.onPress;
        var d = m.onKeyDown, C = m.onKeyUp, S = m.onBlur, T = et(m, Xc), w = r.getState(), j = w.isOpen, Y = {
          onClick: Ne(f, r.buttonHandleClick),
          onKeyDown: Ne(d, r.buttonHandleKeyDown),
          onKeyUp: Ne(C, r.buttonHandleKeyUp),
          onBlur: Ne(S, r.buttonHandleBlur)
        }, ee = T.disabled ? {} : Y;
        return N({
          type: "button",
          role: "button",
          "aria-label": j ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, ee, T);
      }, r.buttonHandleKeyUp = function(_) {
        _.preventDefault();
      }, r.buttonHandleKeyDown = function(_) {
        var m = Rr(_);
        r.buttonKeyDownHandlers[m] && r.buttonKeyDownHandlers[m].call(ei(r), _);
      }, r.buttonHandleClick = function(_) {
        if (_.preventDefault(), r.props.environment) {
          var m = r.props.environment.document, f = m.body, d = m.activeElement;
          f && f === d && _.target.focus();
        }
        process.env.NODE_ENV === "test" ? r.toggleMenu({
          type: Ar
        }) : r.internalSetTimeout(function() {
          return r.toggleMenu({
            type: Ar
          });
        });
      }, r.buttonHandleBlur = function(_) {
        var m = _.target;
        r.internalSetTimeout(function() {
          if (!(r.isMouseDown || !r.props.environment)) {
            var f = r.props.environment.document.activeElement;
            (f == null || f.id !== r.inputId) && f !== m && r.reset({
              type: hs
            });
          }
        });
      }, r.getLabelProps = function(_) {
        return N({
          htmlFor: r.inputId,
          id: r.labelId
        }, _);
      }, r.getInputProps = function(_) {
        var m = _ === void 0 ? {} : _, f = m.onKeyDown, d = m.onBlur, C = m.onChange, S = m.onInput;
        m.onChangeText;
        var T = et(m, Zc), w, j = {};
        w = "onChange";
        var Y = r.getState(), ee = Y.inputValue, ue = Y.isOpen, re = Y.highlightedIndex;
        if (!T.disabled) {
          var fe;
          j = (fe = {}, fe[w] = Ne(C, S, r.inputHandleChange), fe.onKeyDown = Ne(f, r.inputHandleKeyDown), fe.onBlur = Ne(d, r.inputHandleBlur), fe);
        }
        return N({
          "aria-autocomplete": "list",
          "aria-activedescendant": ue && typeof re == "number" && re >= 0 ? r.getItemId(re) : void 0,
          "aria-controls": ue ? r.menuId : void 0,
          "aria-labelledby": T && T["aria-label"] ? void 0 : r.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: ee,
          id: r.inputId
        }, j, T);
      }, r.inputHandleKeyDown = function(_) {
        var m = Rr(_);
        m && r.inputKeyDownHandlers[m] && r.inputKeyDownHandlers[m].call(ei(r), _);
      }, r.inputHandleChange = function(_) {
        r.internalSetState({
          type: gs,
          isOpen: !0,
          inputValue: _.target.value,
          highlightedIndex: r.props.defaultHighlightedIndex
        });
      }, r.inputHandleBlur = function() {
        r.internalSetTimeout(function() {
          var _;
          if (!(r.isMouseDown || !r.props.environment)) {
            var m = r.props.environment.document.activeElement, f = (m == null || (_ = m.dataset) == null ? void 0 : _.toggle) && r._rootNode && r._rootNode.contains(m);
            f || r.reset({
              type: _s
            });
          }
        });
      }, r.menuRef = function(_) {
        r._menuNode = _;
      }, r.getMenuProps = function(_, m) {
        var f, d = _ === void 0 ? {} : _, C = d.refKey, S = C === void 0 ? "ref" : C, T = d.ref, w = et(d, Jc), j = m === void 0 ? {} : m, Y = j.suppressRefError, ee = Y === void 0 ? !1 : Y;
        return r.getMenuProps.called = !0, r.getMenuProps.refKey = S, r.getMenuProps.suppressRefError = ee, N((f = {}, f[S] = jt(T, r.menuRef), f.role = "listbox", f["aria-labelledby"] = w && w["aria-label"] ? void 0 : r.labelId, f.id = r.menuId, f), w);
      }, r.getItemProps = function(_) {
        var m, f = _ === void 0 ? {} : _, d = f.onMouseMove, C = f.onMouseDown, S = f.onClick;
        f.onPress;
        var T = f.index, w = f.item, j = w === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : Kc("getItemProps", "item") : w, Y = et(f, Qc);
        T === void 0 ? (r.items.push(j), T = r.items.indexOf(j)) : r.items[T] = j;
        var ee = "onClick", ue = S, re = (m = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: Ne(d, function() {
            T !== r.getState().highlightedIndex && (r.setHighlightedIndex(T, {
              type: ls
            }), r.avoidScrolling = !0, r.internalSetTimeout(function() {
              return r.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: Ne(C, function(Ee) {
            Ee.preventDefault();
          })
        }, m[ee] = Ne(ue, function() {
          r.selectItemAtIndex(T, {
            type: ms
          });
        }), m), fe = Y.disabled ? {
          onMouseDown: re.onMouseDown
        } : re;
        return N({
          id: r.getItemId(T),
          role: "option",
          "aria-selected": r.getState().highlightedIndex === T
        }, fe, Y);
      }, r.clearItems = function() {
        r.items = [];
      }, r.reset = function(_, m) {
        _ === void 0 && (_ = {}), _ = hn(_), r.internalSetState(function(f) {
          var d = f.selectedItem;
          return N({
            isOpen: r.props.defaultIsOpen,
            highlightedIndex: r.props.defaultHighlightedIndex,
            inputValue: r.props.itemToString(d)
          }, _);
        }, m);
      }, r.toggleMenu = function(_, m) {
        _ === void 0 && (_ = {}), _ = hn(_), r.internalSetState(function(f) {
          var d = f.isOpen;
          return N({
            isOpen: !d
          }, d && {
            highlightedIndex: r.props.defaultHighlightedIndex
          }, _);
        }, function() {
          var f = r.getState(), d = f.isOpen, C = f.highlightedIndex;
          d && r.getItemCount() > 0 && typeof C == "number" && r.setHighlightedIndex(C, _), _i(m)();
        });
      }, r.openMenu = function(_) {
        r.internalSetState({
          isOpen: !0
        }, _);
      }, r.closeMenu = function(_) {
        r.internalSetState({
          isOpen: !1
        }, _);
      }, r.updateStatus = zr(function() {
        var _;
        if ((_ = r.props) != null && (_ = _.environment) != null && _.document) {
          var m = r.getState(), f = r.items[m.highlightedIndex], d = r.getItemCount(), C = r.props.getA11yStatusMessage(N({
            itemToString: r.props.itemToString,
            previousResultCount: r.previousResultCount,
            resultCount: d,
            highlightedItem: f
          }, m));
          r.previousResultCount = d, ss(C, r.props.environment.document);
        }
      }, 200);
      var s = r.props, a = s.defaultHighlightedIndex, c = s.initialHighlightedIndex, p = c === void 0 ? a : c, l = s.defaultIsOpen, u = s.initialIsOpen, b = u === void 0 ? l : u, y = s.initialInputValue, I = y === void 0 ? "" : y, v = s.initialSelectedItem, g = v === void 0 ? null : v, $ = r.getState({
        highlightedIndex: p,
        isOpen: b,
        inputValue: I,
        selectedItem: g
      });
      return $.selectedItem != null && r.props.initialInputValue === void 0 && ($.inputValue = r.props.itemToString($.selectedItem)), r.state = $, r;
    }
    var o = n.prototype;
    return o.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(r) {
        clearTimeout(r);
      }), this.timeoutIds = [];
    }, o.getState = function(r) {
      return r === void 0 && (r = this.state), An(r, this.props);
    }, o.getItemCount = function() {
      var r = this.items.length;
      return this.itemCount != null ? r = this.itemCount : this.props.itemCount !== void 0 && (r = this.props.itemCount), r;
    }, o.getItemNodeFromIndex = function(r) {
      return this.props.environment ? this.props.environment.document.getElementById(this.getItemId(r)) : null;
    }, o.scrollHighlightedItemIntoView = function() {
      {
        var r = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(r, this._menuNode);
      }
    }, o.moveHighlightedIndex = function(r, s) {
      var a = this.getItemCount(), c = this.getState(), p = c.highlightedIndex;
      if (a > 0) {
        var l = Et(p, r, {
          length: a
        }, this.isItemDisabled, !0);
        this.setHighlightedIndex(l, s);
      }
    }, o.getStateAndHelpers = function() {
      var r = this.getState(), s = r.highlightedIndex, a = r.inputValue, c = r.selectedItem, p = r.isOpen, l = this.props.itemToString, u = this.id, b = this.getRootProps, y = this.getToggleButtonProps, I = this.getLabelProps, v = this.getMenuProps, g = this.getInputProps, $ = this.getItemProps, _ = this.openMenu, m = this.closeMenu, f = this.toggleMenu, d = this.selectItem, C = this.selectItemAtIndex, S = this.selectHighlightedItem, T = this.setHighlightedIndex, w = this.clearSelection, j = this.clearItems, Y = this.reset, ee = this.setItemCount, ue = this.unsetItemCount, re = this.internalSetState;
      return {
        // prop getters
        getRootProps: b,
        getToggleButtonProps: y,
        getLabelProps: I,
        getMenuProps: v,
        getInputProps: g,
        getItemProps: $,
        // actions
        reset: Y,
        openMenu: _,
        closeMenu: m,
        toggleMenu: f,
        selectItem: d,
        selectItemAtIndex: C,
        selectHighlightedItem: S,
        setHighlightedIndex: T,
        clearSelection: w,
        clearItems: j,
        setItemCount: ee,
        unsetItemCount: ue,
        setState: re,
        // props
        itemToString: l,
        // derived
        id: u,
        // state
        highlightedIndex: s,
        inputValue: a,
        isOpen: p,
        selectedItem: c
      };
    }, o.componentDidMount = function() {
      var r = this;
      if (process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && hi(this._menuNode, this.getMenuProps), !this.props.environment)
        this.cleanup = function() {
          r.internalClearTimeouts();
        };
      else {
        var s = function() {
          r.isMouseDown = !0;
        }, a = function(y) {
          r.isMouseDown = !1;
          var I = Pn(y.target, [r._rootNode, r._menuNode], r.props.environment);
          !I && r.getState().isOpen && r.reset({
            type: cs
          }, function() {
            return r.props.onOuterClick(r.getStateAndHelpers());
          });
        }, c = function() {
          r.isTouchMove = !1;
        }, p = function() {
          r.isTouchMove = !0;
        }, l = function(y) {
          var I = Pn(y.target, [r._rootNode, r._menuNode], r.props.environment, !1);
          !r.isTouchMove && !I && r.getState().isOpen && r.reset({
            type: ys
          }, function() {
            return r.props.onOuterClick(r.getStateAndHelpers());
          });
        }, u = this.props.environment;
        u.addEventListener("mousedown", s), u.addEventListener("mouseup", a), u.addEventListener("touchstart", c), u.addEventListener("touchmove", p), u.addEventListener("touchend", l), this.cleanup = function() {
          r.internalClearTimeouts(), r.updateStatus.cancel(), u.removeEventListener("mousedown", s), u.removeEventListener("mouseup", a), u.removeEventListener("touchstart", c), u.removeEventListener("touchmove", p), u.removeEventListener("touchend", l);
        };
      }
    }, o.shouldScroll = function(r, s) {
      var a = this.props.highlightedIndex === void 0 ? this.getState() : this.props, c = a.highlightedIndex, p = s.highlightedIndex === void 0 ? r : s, l = p.highlightedIndex, u = c && this.getState().isOpen && !r.isOpen, b = c !== l;
      return u || b;
    }, o.componentDidUpdate = function(r, s) {
      process.env.NODE_ENV !== "production" && (Yr(this.state, r, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && hi(this._menuNode, this.getMenuProps)), Dn(this.props, "selectedItem") && this.props.selectedItemChanged(r.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: bs,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(s, r) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, o.componentWillUnmount = function() {
      this.cleanup();
    }, o.render = function() {
      var r = vi(this.props.children, qe);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var s = vi(r(this.getStateAndHelpers()));
      if (!s)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && tl(s, this.getRootProps), s;
      if (rs(s))
        return /* @__PURE__ */ Kt(s, this.getRootProps(os(s)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, n;
  }(rc);
  return e.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: ns,
    itemToString: function(n) {
      return n == null ? "" : (process.env.NODE_ENV !== "production" && zc(n) && !n.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", n), String(n));
    },
    onStateChange: qe,
    onInputValueChange: qe,
    onUserAction: qe,
    onChange: qe,
    onSelect: qe,
    onOuterClick: qe,
    selectedItemChanged: function(n, o) {
      return n !== o;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? void 0 : window
    ),
    stateReducer: function(n, o) {
      return o;
    },
    suppressRefError: !1,
    scrollIntoView: es
  }, e.stateChangeTypes = Gc, e;
}();
process.env.NODE_ENV !== "production" && (el.propTypes = {
  children: O.func,
  defaultHighlightedIndex: O.number,
  defaultIsOpen: O.bool,
  initialHighlightedIndex: O.number,
  initialSelectedItem: O.any,
  initialInputValue: O.string,
  initialIsOpen: O.bool,
  getA11yStatusMessage: O.func,
  itemToString: O.func,
  onChange: O.func,
  onSelect: O.func,
  onStateChange: O.func,
  onInputValueChange: O.func,
  onUserAction: O.func,
  onOuterClick: O.func,
  selectedItemChanged: O.func,
  stateReducer: O.func,
  itemCount: O.number,
  id: O.string,
  environment: O.shape({
    addEventListener: O.func.isRequired,
    removeEventListener: O.func.isRequired,
    document: O.shape({
      createElement: O.func.isRequired,
      getElementById: O.func.isRequired,
      activeElement: O.any.isRequired,
      body: O.any.isRequired
    }).isRequired,
    Node: O.func.isRequired
  }),
  suppressRefError: O.bool,
  scrollIntoView: O.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: O.any,
  isOpen: O.bool,
  inputValue: O.string,
  highlightedIndex: O.number,
  labelId: O.string,
  inputId: O.string,
  menuId: O.string,
  getItemId: O.func
  /* eslint-enable react/no-unused-prop-types */
});
function hi(e, t) {
  var n = t.refKey;
  e || console.error('downshift: The ref prop "' + n + '" from getMenuProps was not applied correctly on your menu element.');
}
function tl(e, t) {
  var n = t.refKey, o = n !== "ref", i = !rs(e);
  i && !o && !fi.isForwardRef(e) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !i && o && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + n + '"'), !fi.isForwardRef(e) && !os(e)[n] && console.error('downshift: You must apply the ref prop "' + n + '" from getRootProps onto your root element.');
}
var nl = ["isInitialMount", "highlightedIndex", "items", "environment"], Es = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function rl(e, t, n) {
  var o = e.props, i = e.type, r = {};
  Object.keys(t).forEach(function(s) {
    ol(s, e, t, n), n[s] !== t[s] && (r[s] = n[s]);
  }), o.onStateChange && Object.keys(r).length && o.onStateChange(N({
    type: i
  }, r));
}
function ol(e, t, n, o) {
  var i = t.props, r = t.type, s = "on" + Gr(e) + "Change";
  i[s] && o[e] !== void 0 && o[e] !== n[e] && i[s](N({
    type: r
  }, o));
}
function il(e, t) {
  return t.changes;
}
function sl(e) {
  var t = e.selectedItem, n = e.itemToString;
  return t ? n(t) + " has been selected." : "";
}
var al = zr(function(e, t) {
  ss(e(), t);
}, 200), cl = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? Yi : ae, ll = "useId" in Z ? function(t) {
  var n = t.id, o = t.labelId, i = t.menuId, r = t.getItemId, s = t.toggleButtonId, a = t.inputId, c = "downshift-" + Z.useId();
  n || (n = c);
  var p = K({
    labelId: o || n + "-label",
    menuId: i || n + "-menu",
    getItemId: r || function(l) {
      return n + "-item-" + l;
    },
    toggleButtonId: s || n + "-toggle-button",
    inputId: a || n + "-input"
  });
  return p.current;
} : function(t) {
  var n = t.id, o = n === void 0 ? "downshift-" + ts() : n, i = t.labelId, r = t.menuId, s = t.getItemId, a = t.toggleButtonId, c = t.inputId, p = K({
    labelId: i || o + "-label",
    menuId: r || o + "-menu",
    getItemId: s || function(l) {
      return o + "-item-" + l;
    },
    toggleButtonId: a || o + "-toggle-button",
    inputId: c || o + "-input"
  });
  return p.current;
};
function ul(e, t, n, o) {
  var i, r;
  if (e === void 0) {
    if (t === void 0)
      throw new Error(o);
    i = n[t], r = t;
  } else
    r = t === void 0 ? n.indexOf(e) : t, i = e;
  return [i, r];
}
function dl(e) {
  return e ? String(e) : "";
}
function Gr(e) {
  return "" + e.slice(0, 1).toUpperCase() + e.slice(1);
}
function Is(e) {
  var t = K(e);
  return t.current = e, t;
}
function fl(e, t, n, o) {
  var i = K(), r = K(), s = se(function(y, I) {
    r.current = I, y = An(y, I.props);
    var v = e(y, I), g = I.props.stateReducer(y, N({}, I, {
      changes: v
    }));
    return g;
  }, [e]), a = Gi(s, t, n), c = a[0], p = a[1], l = Is(t), u = se(function(y) {
    return p(N({
      props: l.current
    }, y));
  }, [l]), b = r.current;
  return ae(function() {
    var y = b && i.current && !o(i.current, c);
    y && rl(b, An(i.current, b.props), c), i.current = c;
  }, [c, b, o]), [c, u];
}
var nn = {
  itemToString: dl,
  stateReducer: il,
  getA11ySelectionMessage: sl,
  scrollIntoView: es,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? void 0 : window
  )
};
function tt(e, t, n) {
  n === void 0 && (n = Es);
  var o = e["default" + Gr(t)];
  return o !== void 0 ? o : n[t];
}
function en(e, t, n) {
  n === void 0 && (n = Es);
  var o = e[t];
  if (o !== void 0)
    return o;
  var i = e["initial" + Gr(t)];
  return i !== void 0 ? i : tt(e, t, n);
}
function pl(e) {
  var t = en(e, "selectedItem"), n = en(e, "isOpen"), o = en(e, "highlightedIndex"), i = en(e, "inputValue");
  return {
    highlightedIndex: o < 0 && t && n ? e.items.indexOf(t) : o,
    isOpen: n,
    selectedItem: t,
    inputValue: i
  };
}
function rn(e, t, n) {
  var o = e.items, i = e.initialHighlightedIndex, r = e.defaultHighlightedIndex, s = t.selectedItem, a = t.highlightedIndex;
  return o.length === 0 ? -1 : i !== void 0 && a === i ? i : r !== void 0 ? r : s ? o.indexOf(s) : n === 0 ? -1 : n < 0 ? o.length - 1 : 0;
}
function ml(e, t, n, o) {
  var i = K({
    isMouseDown: !1,
    isTouchMove: !1
  });
  return ae(function() {
    if (n) {
      var r = function() {
        i.current.isMouseDown = !0;
      }, s = function(u) {
        i.current.isMouseDown = !1, e && !Pn(u.target, t.map(function(b) {
          return b.current;
        }), n) && o();
      }, a = function() {
        i.current.isTouchMove = !1;
      }, c = function() {
        i.current.isTouchMove = !0;
      }, p = function(u) {
        e && !i.current.isTouchMove && !Pn(u.target, t.map(function(b) {
          return b.current;
        }), n, !1) && o();
      };
      return n.addEventListener("mousedown", r), n.addEventListener("mouseup", s), n.addEventListener("touchstart", a), n.addEventListener("touchmove", c), n.addEventListener("touchend", p), function() {
        n.removeEventListener("mousedown", r), n.removeEventListener("mouseup", s), n.removeEventListener("touchstart", a), n.removeEventListener("touchmove", c), n.removeEventListener("touchend", p);
      };
    }
  }, [e, n]), i;
}
var $s = function() {
  return qe;
};
process.env.NODE_ENV !== "production" && ($s = function() {
  for (var t = K(!0), n = arguments.length, o = new Array(n), i = 0; i < n; i++)
    o[i] = arguments[i];
  var r = K(o.reduce(function(a, c) {
    return a[c] = {}, a;
  }, {}));
  ae(function() {
    Object.keys(r.current).forEach(function(a) {
      var c = r.current[a];
      if (t.current && !Object.keys(c).length) {
        console.error("downshift: You forgot to call the " + a + " getter function on your component / element.");
        return;
      }
      var p = c.suppressRefError, l = c.refKey, u = c.elementRef;
      (!u || !u.current) && !p && console.error('downshift: The ref prop "' + l + '" from ' + a + " was not applied correctly on your element.");
    }), t.current = !1;
  });
  var s = se(function(a, c, p, l) {
    r.current[a] = {
      suppressRefError: c,
      refKey: p,
      elementRef: l
    };
  }, []);
  return s;
});
function bi(e, t, n) {
  var o = n.isInitialMount, i = n.highlightedIndex, r = n.items, s = n.environment, a = et(n, nl);
  ae(function() {
    o || !(s != null && s.document) || al(function() {
      return e(N({
        highlightedIndex: i,
        highlightedItem: r[i],
        resultCount: r.length
      }, a));
    }, s.document);
  }, t);
}
function _l(e) {
  var t = e.highlightedIndex, n = e.isOpen, o = e.itemRefs, i = e.getItemNodeFromIndex, r = e.menuElement, s = e.scrollIntoView, a = K(!0);
  return cl(function() {
    t < 0 || !n || !Object.keys(o.current).length || (a.current === !1 ? a.current = !0 : s(i(t), r));
  }, [t]), a;
}
var ws = qe;
process.env.NODE_ENV !== "production" && (ws = function(t) {
  var n = t.isInitialMount, o = t.props, i = t.state, r = K(o);
  ae(function() {
    n || (Yr(i, r.current, o), r.current = o);
  }, [i, o, n]);
});
function yi(e, t, n) {
  var o;
  n === void 0 && (n = !0);
  var i = ((o = e.items) == null ? void 0 : o.length) && t >= 0;
  return N({
    isOpen: !1,
    highlightedIndex: -1
  }, i && N({
    selectedItem: e.items[t],
    isOpen: tt(e, "isOpen"),
    highlightedIndex: tt(e, "highlightedIndex")
  }, n && {
    inputValue: e.itemToString(e.items[t])
  }));
}
function gl(e, t) {
  return e.isOpen === t.isOpen && e.inputValue === t.inputValue && e.highlightedIndex === t.highlightedIndex && e.selectedItem === t.selectedItem;
}
var Cs = {
  environment: O.shape({
    addEventListener: O.func.isRequired,
    removeEventListener: O.func.isRequired,
    document: O.shape({
      createElement: O.func.isRequired,
      getElementById: O.func.isRequired,
      activeElement: O.any.isRequired,
      body: O.any.isRequired
    }).isRequired,
    Node: O.func.isRequired
  }),
  itemToString: O.func,
  stateReducer: O.func
}, xs = N({}, Cs, {
  getA11yStatusMessage: O.func,
  highlightedIndex: O.number,
  defaultHighlightedIndex: O.number,
  initialHighlightedIndex: O.number,
  isOpen: O.bool,
  defaultIsOpen: O.bool,
  initialIsOpen: O.bool,
  selectedItem: O.any,
  initialSelectedItem: O.any,
  defaultSelectedItem: O.any,
  id: O.string,
  labelId: O.string,
  menuId: O.string,
  getItemId: O.func,
  toggleButtonId: O.string,
  onSelectedItemChange: O.func,
  onHighlightedIndexChange: O.func,
  onStateChange: O.func,
  onIsOpenChange: O.func,
  scrollIntoView: O.func
});
function vl(e, t, n) {
  var o = t.type, i = t.props, r;
  switch (o) {
    case n.ItemMouseMove:
      r = {
        highlightedIndex: t.disabled ? -1 : t.index
      };
      break;
    case n.MenuMouseLeave:
      r = {
        highlightedIndex: -1
      };
      break;
    case n.ToggleButtonClick:
    case n.FunctionToggleMenu:
      r = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : rn(i, e, 0)
      };
      break;
    case n.FunctionOpenMenu:
      r = {
        isOpen: !0,
        highlightedIndex: rn(i, e, 0)
      };
      break;
    case n.FunctionCloseMenu:
      r = {
        isOpen: !1
      };
      break;
    case n.FunctionSetHighlightedIndex:
      r = {
        highlightedIndex: t.highlightedIndex
      };
      break;
    case n.FunctionSetInputValue:
      r = {
        inputValue: t.inputValue
      };
      break;
    case n.FunctionReset:
      r = {
        highlightedIndex: tt(i, "highlightedIndex"),
        isOpen: tt(i, "isOpen"),
        selectedItem: tt(i, "selectedItem"),
        inputValue: tt(i, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return N({}, e, r);
}
Ke(Ke({}, xs), { items: O.array.isRequired, isItemDisabled: O.func, getA11ySelectionMessage: O.func });
function hl(e) {
  var t = e.isOpen, n = e.resultCount, o = e.previousResultCount;
  return t ? n ? n !== o ? "".concat(n, " result").concat(n === 1 ? " is" : "s are", " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.") : "" : "No results are available." : "";
}
Ke(Ke({}, nn), { getA11yStatusMessage: hl, isItemDisabled: function() {
  return !1;
} });
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
var qr = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0, Xr = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1, Zr = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2, Jr = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3, Qr = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4, eo = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5, to = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6, no = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7, ro = process.env.NODE_ENV !== "production" ? "__input_change__" : 8, Mn = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9, oo = process.env.NODE_ENV !== "production" ? "__input_click__" : 10, Ts = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11, Ss = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12, io = process.env.NODE_ENV !== "production" ? "__item_click__" : 13, Ns = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14, Os = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, Rs = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, As = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, Ds = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, so = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, Ps = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, Ms = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, ao = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22, ks = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  InputKeyDownArrowDown: qr,
  InputKeyDownArrowUp: Xr,
  InputKeyDownEscape: Zr,
  InputKeyDownHome: Jr,
  InputKeyDownEnd: Qr,
  InputKeyDownPageUp: eo,
  InputKeyDownPageDown: to,
  InputKeyDownEnter: no,
  InputChange: ro,
  InputBlur: Mn,
  InputClick: oo,
  MenuMouseLeave: Ts,
  ItemMouseMove: Ss,
  ItemClick: io,
  ToggleButtonClick: Ns,
  FunctionToggleMenu: Os,
  FunctionOpenMenu: Rs,
  FunctionCloseMenu: As,
  FunctionSetHighlightedIndex: Ds,
  FunctionSelectItem: so,
  FunctionSetInputValue: Ps,
  FunctionReset: Ms,
  ControlledPropUpdatedSelectedItem: ao
});
function bl(e) {
  var t = pl(e), n = t.selectedItem, o = t.inputValue;
  return o === "" && n && e.defaultInputValue === void 0 && e.initialInputValue === void 0 && e.inputValue === void 0 && (o = e.itemToString(n)), N({}, t, {
    inputValue: o
  });
}
var yl = N({}, xs, {
  items: O.array.isRequired,
  isItemDisabled: O.func,
  selectedItemChanged: O.func,
  getA11ySelectionMessage: O.func,
  inputValue: O.string,
  defaultInputValue: O.string,
  initialInputValue: O.string,
  inputId: O.string,
  onInputValueChange: O.func
});
function El(e, t, n, o) {
  var i = K(), r = fl(e, t, n, o), s = r[0], a = r[1];
  return ae(function() {
    Dn(t, "selectedItem") && (t.selectedItemChanged(i.current, t.selectedItem) && a({
      type: ao,
      inputValue: t.itemToString(t.selectedItem)
    }), i.current = s.selectedItem === i.current ? t.selectedItem : s.selectedItem);
  }, [s.selectedItem, t.selectedItem]), [An(s, t), a];
}
var Ls = qe;
process.env.NODE_ENV !== "production" && (Ls = function(t, n) {
  O.checkPropTypes(yl, t, "prop", n.name);
});
var Il = N({}, nn, {
  selectedItemChanged: function(t, n) {
    return t !== n;
  },
  getA11yStatusMessage: ns,
  isItemDisabled: function() {
    return !1;
  }
});
function $l(e, t) {
  var n, o = t.type, i = t.props, r = t.altKey, s;
  switch (o) {
    case io:
      s = {
        isOpen: tt(i, "isOpen"),
        highlightedIndex: tt(i, "highlightedIndex"),
        selectedItem: i.items[t.index],
        inputValue: i.itemToString(i.items[t.index])
      };
      break;
    case qr:
      e.isOpen ? s = {
        highlightedIndex: Et(e.highlightedIndex, 1, i.items, i.isItemDisabled, !0)
      } : s = {
        highlightedIndex: r && e.selectedItem == null ? -1 : rn(i, e, 1),
        isOpen: i.items.length >= 0
      };
      break;
    case Xr:
      e.isOpen ? r ? s = yi(i, e.highlightedIndex) : s = {
        highlightedIndex: Et(e.highlightedIndex, -1, i.items, i.isItemDisabled, !0)
      } : s = {
        highlightedIndex: rn(i, e, -1),
        isOpen: i.items.length >= 0
      };
      break;
    case no:
      s = yi(i, e.highlightedIndex);
      break;
    case Zr:
      s = N({
        isOpen: !1,
        highlightedIndex: -1
      }, !e.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case eo:
      s = {
        highlightedIndex: Et(e.highlightedIndex, -10, i.items, i.isItemDisabled, !0)
      };
      break;
    case to:
      s = {
        highlightedIndex: Et(e.highlightedIndex, 10, i.items, i.isItemDisabled, !0)
      };
      break;
    case Jr:
      s = {
        highlightedIndex: Ut(0, !1, i.items, i.isItemDisabled)
      };
      break;
    case Qr:
      s = {
        highlightedIndex: Ut(i.items.length - 1, !0, i.items, i.isItemDisabled)
      };
      break;
    case Mn:
      s = N({
        isOpen: !1,
        highlightedIndex: -1
      }, e.highlightedIndex >= 0 && ((n = i.items) == null ? void 0 : n.length) && t.selectItem && {
        selectedItem: i.items[e.highlightedIndex],
        inputValue: i.itemToString(i.items[e.highlightedIndex])
      });
      break;
    case ro:
      s = {
        isOpen: !0,
        highlightedIndex: tt(i, "highlightedIndex"),
        inputValue: t.inputValue
      };
      break;
    case oo:
      s = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : rn(i, e, 0)
      };
      break;
    case so:
      s = {
        selectedItem: t.selectedItem,
        inputValue: i.itemToString(t.selectedItem)
      };
      break;
    case ao:
      s = {
        inputValue: t.inputValue
      };
      break;
    default:
      return vl(e, t, ks);
  }
  return N({}, e, s);
}
var wl = ["onMouseLeave", "refKey", "ref"], Cl = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"], xl = ["onClick", "onPress", "refKey", "ref"], Tl = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "onClick", "refKey", "ref"];
co.stateChangeTypes = ks;
function co(e) {
  e === void 0 && (e = {}), Ls(e, co);
  var t = N({}, Il, e), n = t.items, o = t.scrollIntoView, i = t.environment, r = t.getA11yStatusMessage, s = t.getA11ySelectionMessage, a = t.itemToString, c = El($l, t, bl, gl), p = c[0], l = c[1], u = p.isOpen, b = p.highlightedIndex, y = p.selectedItem, I = p.inputValue, v = K(null), g = K({}), $ = K(null), _ = K(null), m = K(!0), f = ll(t), d = K(), C = Is({
    state: p,
    props: t
  }), S = se(function(D) {
    return g.current[f.getItemId(D)];
  }, [f]);
  bi(r, [u, b, I, n], N({
    isInitialMount: m.current,
    previousResultCount: d.current,
    items: n,
    environment: i,
    itemToString: a
  }, p)), bi(s, [y], N({
    isInitialMount: m.current,
    previousResultCount: d.current,
    items: n,
    environment: i,
    itemToString: a
  }, p));
  var T = _l({
    menuElement: v.current,
    highlightedIndex: b,
    isOpen: u,
    itemRefs: g,
    scrollIntoView: o,
    getItemNodeFromIndex: S
  });
  ws({
    isInitialMount: m.current,
    props: t,
    state: p
  }), ae(function() {
    var D = en(t, "isOpen");
    D && $.current && $.current.focus();
  }, []), ae(function() {
    m.current || (d.current = n.length);
  });
  var w = ml(u, [$, v, _], i, function() {
    l({
      type: Mn,
      selectItem: !1
    });
  }), j = $s("getInputProps", "getMenuProps");
  ae(function() {
    return m.current = !1, function() {
      m.current = !0;
    };
  }, []), ae(function() {
    u || (g.current = {});
  }, [u]), ae(function() {
    var D;
    !u || !(i != null && i.document) || !($ != null && (D = $.current) != null && D.focus) || i.document.activeElement !== $.current && $.current.focus();
  }, [u, i]);
  var Y = ct(function() {
    return {
      ArrowDown: function(M) {
        M.preventDefault(), l({
          type: qr,
          altKey: M.altKey
        });
      },
      ArrowUp: function(M) {
        M.preventDefault(), l({
          type: Xr,
          altKey: M.altKey
        });
      },
      Home: function(M) {
        C.current.state.isOpen && (M.preventDefault(), l({
          type: Jr
        }));
      },
      End: function(M) {
        C.current.state.isOpen && (M.preventDefault(), l({
          type: Qr
        }));
      },
      Escape: function(M) {
        var P = C.current.state;
        (P.isOpen || P.inputValue || P.selectedItem || P.highlightedIndex > -1) && (M.preventDefault(), l({
          type: Zr
        }));
      },
      Enter: function(M) {
        var P = C.current.state;
        !P.isOpen || M.which === 229 || (M.preventDefault(), l({
          type: no
        }));
      },
      PageUp: function(M) {
        C.current.state.isOpen && (M.preventDefault(), l({
          type: eo
        }));
      },
      PageDown: function(M) {
        C.current.state.isOpen && (M.preventDefault(), l({
          type: to
        }));
      }
    };
  }, [l, C]), ee = se(function(D) {
    return N({
      id: f.labelId,
      htmlFor: f.inputId
    }, D);
  }, [f]), ue = se(function(D, M) {
    var P, F = D === void 0 ? {} : D, q = F.onMouseLeave, z = F.refKey, W = z === void 0 ? "ref" : z, de = F.ref, R = et(F, wl), be = M === void 0 ? {} : M, V = be.suppressRefError, De = V === void 0 ? !1 : V;
    return j("getMenuProps", De, W, v), N((P = {}, P[W] = jt(de, function(xe) {
      v.current = xe;
    }), P.id = f.menuId, P.role = "listbox", P["aria-labelledby"] = R && R["aria-label"] ? void 0 : "" + f.labelId, P.onMouseLeave = Ne(q, function() {
      l({
        type: Ts
      });
    }), P), R);
  }, [l, j, f]), re = se(function(D) {
    var M, P, F = D === void 0 ? {} : D, q = F.item, z = F.index, W = F.refKey, de = W === void 0 ? "ref" : W, R = F.ref, be = F.onMouseMove, V = F.onMouseDown, De = F.onClick;
    F.onPress;
    var xe = F.disabled, lt = et(F, Cl);
    xe !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
    var ie = C.current, H = ie.props, te = ie.state, Q = ul(q, z, H.items, "Pass either item or index to getItemProps!"), Te = Q[0], Se = Q[1], Ye = H.isItemDisabled(Te, Se), mt = "onClick", _t = De, Ge = function() {
      Se !== te.highlightedIndex && (T.current = !1, l({
        type: Ss,
        index: Se,
        disabled: Ye
      }));
    }, rt = function() {
      l({
        type: io,
        index: Se
      });
    }, Xe = function(xt) {
      return xt.preventDefault();
    };
    return N((M = {}, M[de] = jt(R, function(ze) {
      ze && (g.current[f.getItemId(Se)] = ze);
    }), M["aria-disabled"] = Ye, M["aria-selected"] = "" + (Se === te.highlightedIndex), M.id = f.getItemId(Se), M.role = "option", M), !Ye && (P = {}, P[mt] = Ne(_t, rt), P), {
      onMouseMove: Ne(be, Ge),
      onMouseDown: Ne(V, Xe)
    }, lt);
  }, [l, C, T, f]), fe = se(function(D) {
    var M, P = D === void 0 ? {} : D, F = P.onClick;
    P.onPress;
    var q = P.refKey, z = q === void 0 ? "ref" : q, W = P.ref, de = et(P, xl), R = C.current.state, be = function() {
      l({
        type: Ns
      });
    };
    return N((M = {}, M[z] = jt(W, function(V) {
      _.current = V;
    }), M["aria-controls"] = f.menuId, M["aria-expanded"] = R.isOpen, M.id = f.toggleButtonId, M.tabIndex = -1, M), !de.disabled && N({}, {
      onClick: Ne(F, be)
    }), de);
  }, [l, C, f]), Ee = se(function(D, M) {
    var P, F = D === void 0 ? {} : D, q = F.onKeyDown, z = F.onChange, W = F.onInput, de = F.onBlur;
    F.onChangeText;
    var R = F.onClick, be = F.refKey, V = be === void 0 ? "ref" : be, De = F.ref, xe = et(F, Tl), lt = M === void 0 ? {} : M, ie = lt.suppressRefError, H = ie === void 0 ? !1 : ie;
    j("getInputProps", H, V, $);
    var te = C.current.state, Q = function(Xe) {
      var ze = Rr(Xe);
      ze && Y[ze] && Y[ze](Xe);
    }, Te = function(Xe) {
      l({
        type: ro,
        inputValue: Xe.target.value
      });
    }, Se = function(Xe) {
      if (i != null && i.document && te.isOpen && !w.current.isMouseDown) {
        var ze = Xe.relatedTarget === null && i.document.activeElement !== i.document.body;
        l({
          type: Mn,
          selectItem: !ze
        });
      }
    }, Ye = function() {
      l({
        type: oo
      });
    }, mt = "onChange", _t = {};
    if (!xe.disabled) {
      var Ge;
      _t = (Ge = {}, Ge[mt] = Ne(z, W, Te), Ge.onKeyDown = Ne(q, Q), Ge.onBlur = Ne(de, Se), Ge.onClick = Ne(R, Ye), Ge);
    }
    return N((P = {}, P[V] = jt(De, function(rt) {
      $.current = rt;
    }), P["aria-activedescendant"] = te.isOpen && te.highlightedIndex > -1 ? f.getItemId(te.highlightedIndex) : "", P["aria-autocomplete"] = "list", P["aria-controls"] = f.menuId, P["aria-expanded"] = te.isOpen, P["aria-labelledby"] = xe && xe["aria-label"] ? void 0 : f.labelId, P.autoComplete = "off", P.id = f.inputId, P.role = "combobox", P.value = te.inputValue, P), _t, xe);
  }, [j, C, f, Y, l, w, i]), oe = se(function() {
    l({
      type: Os
    });
  }, [l]), Pe = se(function() {
    l({
      type: As
    });
  }, [l]), Me = se(function() {
    l({
      type: Rs
    });
  }, [l]), x = se(function(D) {
    l({
      type: Ds,
      highlightedIndex: D
    });
  }, [l]), L = se(function(D) {
    l({
      type: so,
      selectedItem: D
    });
  }, [l]), J = se(function(D) {
    l({
      type: Ps,
      inputValue: D
    });
  }, [l]), G = se(function() {
    l({
      type: Ms
    });
  }, [l]);
  return {
    // prop getters.
    getItemProps: re,
    getLabelProps: ee,
    getMenuProps: ue,
    getInputProps: Ee,
    getToggleButtonProps: fe,
    // actions.
    toggleMenu: oe,
    openMenu: Me,
    closeMenu: Pe,
    setHighlightedIndex: x,
    setInputValue: J,
    selectItem: L,
    reset: G,
    // state.
    highlightedIndex: b,
    isOpen: u,
    selectedItem: y,
    inputValue: I
  };
}
function Sl(e) {
  var t = e.removedSelectedItem, n = e.itemToString;
  return n(t) + " has been removed.";
}
N({}, Cs, {
  selectedItems: O.array,
  initialSelectedItems: O.array,
  defaultSelectedItems: O.array,
  getA11yRemovalMessage: O.func,
  activeIndex: O.number,
  initialActiveIndex: O.number,
  defaultActiveIndex: O.number,
  onActiveIndexChange: O.func,
  onSelectedItemsChange: O.func,
  keyNavigationNext: O.string,
  keyNavigationPrevious: O.string
});
nn.itemToString, nn.stateReducer, nn.environment;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
const Nl = "_autocomplete_1g5xw_1", Ol = "_suggestion_1g5xw_63", Rl = "_highlight_1g5xw_83", st = {
  autocomplete: Nl,
  "is-small": "_is-small_1g5xw_13",
  "autocomplete-container": "_autocomplete-container_1g5xw_16",
  "input-button-container": "_input-button-container_1g5xw_21",
  "autocomplete-input": "_autocomplete-input_1g5xw_27",
  "autocomplete-button": "_autocomplete-button_1g5xw_39",
  "suggestions-container": "_suggestions-container_1g5xw_63",
  suggestion: Ol,
  highlight: Rl
};
function gm({
  id: e,
  placeholder: t,
  value: n,
  onChange: o,
  suggestions: i = [],
  buttonText: r,
  onSubmit: s,
  hideButtonText: a,
  size: c = "medium",
  className: p,
  ...l
}) {
  const { isOpen: u, getLabelProps: b, getMenuProps: y, getInputProps: I, highlightedIndex: v, getItemProps: g, selectedItem: $ } = co({
    id: e,
    onInputValueChange({ inputValue: f }) {
      o && o(f || "");
    },
    items: i,
    itemToString(f) {
      return (f == null ? void 0 : f.value) || "";
    }
  }), _ = X(st.autocomplete, st[`is-${c}`], p);
  function m(f) {
    f.preventDefault(), s && s(f, $ || void 0);
  }
  return /* @__PURE__ */ ne("div", { className: _, ...l, children: [
    /* @__PURE__ */ E("form", { className: st["autocomplete-container"], onSubmit: m, children: /* @__PURE__ */ ne("div", { className: st["input-button-container"], children: [
      /* @__PURE__ */ E("label", { ...b(), hidden: !0, children: t }),
      /* @__PURE__ */ E(
        "input",
        {
          className: st["autocomplete-input"],
          type: "text",
          placeholder: t,
          value: n,
          ...I()
        }
      ),
      /* @__PURE__ */ ne("button", { "aria-label": r, className: st["autocomplete-button"], children: [
        /* @__PURE__ */ E(Fe, { name: "search" }),
        !a && r
      ] })
    ] }) }),
    /* @__PURE__ */ E("ul", { className: st["suggestions-container"], ...y(), "data-test": u, children: u && i.map((f, d) => /* @__PURE__ */ E(
      "li",
      {
        className: `${st.suggestion} ${v === d ? st.highlight : ""}`,
        ...g({ item: f, index: d }),
        children: f.value
      },
      f.id
    )) })
  ] });
}
const Al = "_input_1yuut_1", Dl = "_legend_1yuut_4", Ue = {
  input: Al,
  legend: Dl,
  "legend-text": "_legend-text_1yuut_10",
  "is-success": "_is-success_1yuut_13",
  "input-text": "_input-text_1yuut_13",
  "is-error": "_is-error_1yuut_13",
  "is-warning": "_is-warning_1yuut_13",
  "input-label": "_input-label_1yuut_16",
  "input-container": "_input-container_1yuut_19",
  "input-fieldset": "_input-fieldset_1yuut_19",
  "is-disabled": "_is-disabled_1yuut_55",
  "is-display": "_is-display_1yuut_61",
  "is-full-width": "_is-full-width_1yuut_98",
  "has-icon": "_has-icon_1yuut_101",
  "input-icon": "_input-icon_1yuut_101",
  "hidden-fieldset": "_hidden-fieldset_1yuut_109"
}, Pl = {
  success: "is-success",
  warning: "is-warning",
  error: "is-error"
}, vm = ({
  className: e,
  name: t,
  type: n = "text",
  value: o = "",
  status: i,
  label: r,
  legend: s,
  onChange: a,
  isDisabled: c,
  isDisplay: p,
  icon: l,
  isFullWidth: u
}) => {
  const [b, y] = $e(o), I = X(
    Ue.input,
    i && Ue[Pl[i]],
    c && Ue["is-disabled"],
    p && Ue["is-display"],
    l && Ue["has-icon"],
    (!b || c || p) && Ue["hidden-fieldset"],
    u && Ue["is-full-width"],
    e
  ), v = (g) => {
    y(g.target.value), a && a(g);
  };
  return /* @__PURE__ */ ne("div", { className: I, children: [
    /* @__PURE__ */ ne("div", { className: Ue["input-container"], children: [
      l && /* @__PURE__ */ E(Fe, { className: Ue["input-icon"], name: l }),
      /* @__PURE__ */ E(
        "input",
        {
          name: t,
          value: b,
          className: Ue["input-text"],
          type: n,
          placeholder: r,
          onChange: v
        }
      ),
      /* @__PURE__ */ E("fieldset", { className: Ue["input-fieldset"], children: /* @__PURE__ */ E("legend", { className: Ue["input-label"], children: r }) })
    ] }),
    s && /* @__PURE__ */ ne("div", { className: Ue.legend, children: [
      i && /* @__PURE__ */ E(Fe, { name: i === "success" ? "checkbox-fill" : "error-warning-fill", color: i }),
      /* @__PURE__ */ E("span", { className: Ue["legend-text"], children: s })
    ] })
  ] });
}, hm = ce(function({ name: t, onBlur: n, onChange: o, value: i, label: r }, s) {
  return /* @__PURE__ */ ne(On, { children: [
    /* @__PURE__ */ E("input", { type: "checkbox", name: t, onBlur: n, onChange: o, ref: s, checked: i }),
    /* @__PURE__ */ E("label", { htmlFor: t, children: r })
  ] });
}), Ml = "_tag_10brd_1", kl = {
  tag: Ml
};
function bm({ label: e, icon: t, componentlink: n, href: o, className: i = "", ...r }) {
  const s = X(kl.tag, i), a = /* @__PURE__ */ ne("span", { className: s, ...r, children: [
    t && /* @__PURE__ */ E(Fe, { name: t, color: "base" }),
    e
  ] });
  return n ? /* @__PURE__ */ E(n, { href: o, children: a }) : o ? /* @__PURE__ */ E("a", { href: o, children: a }) : a;
}
const Ll = "_breadcrumbs_bnx8n_1", Xt = {
  breadcrumbs: Ll,
  "breadcrumbs-link": "_breadcrumbs-link_bnx8n_8",
  "color-inverted": "_color-inverted_bnx8n_13",
  "is-primary": "_is-primary_bnx8n_16",
  "is-secondary": "_is-secondary_bnx8n_19",
  "is-tertiary": "_is-tertiary_bnx8n_22",
  "is-success": "_is-success_bnx8n_25",
  "is-error": "_is-error_bnx8n_28",
  "is-eco-green": "_is-eco-green_bnx8n_31"
};
function ym({
  items: e,
  separator: t = "/",
  color: n = "default",
  LinkElement: o,
  className: i,
  ...r
}) {
  const s = X(Xt.breadcrumbs, Xt[Fl[n]], i);
  return /* @__PURE__ */ E("nav", { className: s, "aria-label": "breadcrumbs", ...r, children: /* @__PURE__ */ E("ol", { children: e == null ? void 0 : e.map((a, c) => /* @__PURE__ */ ne("li", { children: [
    o ? /* @__PURE__ */ E(o, { className: Xt["breadcrumbs-link"], href: a.href, children: a.value }) : /* @__PURE__ */ E("a", { className: Xt["breadcrumbs-link"], href: a.href, children: a.value }),
    c !== e.length - 1 && /* @__PURE__ */ E("span", { className: Xt.separator, children: t })
  ] }, `${a.value}${a.href}`)) }) });
}
const Fl = {
  default: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "color-inverted"
};
function ft(e, t = []) {
  let n = [];
  function o(r, s) {
    const a = /* @__PURE__ */ Ht(s), c = n.length;
    n = [
      ...n,
      s
    ];
    function p(u) {
      const { scope: b, children: y, ...I } = u, v = (b == null ? void 0 : b[e][c]) || a, g = ct(
        () => I,
        Object.values(I)
      );
      return /* @__PURE__ */ k(v.Provider, {
        value: g
      }, y);
    }
    function l(u, b) {
      const y = (b == null ? void 0 : b[e][c]) || a, I = cn(y);
      if (I)
        return I;
      if (s !== void 0)
        return s;
      throw new Error(`\`${u}\` must be used within \`${r}\``);
    }
    return p.displayName = r + "Provider", [
      p,
      l
    ];
  }
  const i = () => {
    const r = n.map((s) => /* @__PURE__ */ Ht(s));
    return function(a) {
      const c = (a == null ? void 0 : a[e]) || r;
      return ct(
        () => ({
          [`__scope${e}`]: {
            ...a,
            [e]: c
          }
        }),
        [
          a,
          c
        ]
      );
    };
  };
  return i.scopeName = e, [
    o,
    Vl(i, ...t)
  ];
}
function Vl(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const o = e.map(
      (i) => ({
        useScope: i(),
        scopeName: i.scopeName
      })
    );
    return function(r) {
      const s = o.reduce((a, { useScope: c, scopeName: p }) => {
        const u = c(r)[`__scope${p}`];
        return {
          ...a,
          ...u
        };
      }, {});
      return ct(
        () => ({
          [`__scope${t.scopeName}`]: s
        }),
        [
          s
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
function jl(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Fs(...e) {
  return (t) => e.forEach(
    (n) => jl(n, t)
  );
}
function We(...e) {
  return se(Fs(...e), e);
}
const sn = /* @__PURE__ */ ce((e, t) => {
  const { children: n, ...o } = e, i = It.toArray(n), r = i.find(Ul);
  if (r) {
    const s = r.props.children, a = i.map((c) => c === r ? It.count(s) > 1 ? It.only(null) : /* @__PURE__ */ Rn(s) ? s.props.children : null : c);
    return /* @__PURE__ */ k(Dr, N({}, o, {
      ref: t
    }), /* @__PURE__ */ Rn(s) ? /* @__PURE__ */ Kt(s, void 0, a) : null);
  }
  return /* @__PURE__ */ k(Dr, N({}, o, {
    ref: t
  }), n);
});
sn.displayName = "Slot";
const Dr = /* @__PURE__ */ ce((e, t) => {
  const { children: n, ...o } = e;
  return /* @__PURE__ */ Rn(n) ? /* @__PURE__ */ Kt(n, {
    ...Bl(o, n.props),
    ref: t ? Fs(t, n.ref) : n.ref
  }) : It.count(n) > 1 ? It.only(null) : null;
});
Dr.displayName = "SlotClone";
const Hl = ({ children: e }) => /* @__PURE__ */ k(on, null, e);
function Ul(e) {
  return /* @__PURE__ */ Rn(e) && e.type === Hl;
}
function Bl(e, t) {
  const n = {
    ...t
  };
  for (const o in t) {
    const i = e[o], r = t[o];
    /^on[A-Z]/.test(o) ? i && r ? n[o] = (...a) => {
      r(...a), i(...a);
    } : i && (n[o] = i) : o === "style" ? n[o] = {
      ...i,
      ...r
    } : o === "className" && (n[o] = [
      i,
      r
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
function Hn(e) {
  const t = e + "CollectionProvider", [n, o] = ft(t), [i, r] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), s = (y) => {
    const { scope: I, children: v } = y, g = Z.useRef(null), $ = Z.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ Z.createElement(i, {
      scope: I,
      itemMap: $,
      collectionRef: g
    }, v);
  }, a = e + "CollectionSlot", c = /* @__PURE__ */ Z.forwardRef((y, I) => {
    const { scope: v, children: g } = y, $ = r(a, v), _ = We(I, $.collectionRef);
    return /* @__PURE__ */ Z.createElement(sn, {
      ref: _
    }, g);
  }), p = e + "CollectionItemSlot", l = "data-radix-collection-item", u = /* @__PURE__ */ Z.forwardRef((y, I) => {
    const { scope: v, children: g, ...$ } = y, _ = Z.useRef(null), m = We(I, _), f = r(p, v);
    return Z.useEffect(() => (f.itemMap.set(_, {
      ref: _,
      ...$
    }), () => void f.itemMap.delete(_))), /* @__PURE__ */ Z.createElement(sn, {
      [l]: "",
      ref: m
    }, g);
  });
  function b(y) {
    const I = r(e + "CollectionConsumer", y);
    return Z.useCallback(() => {
      const g = I.collectionRef.current;
      if (!g)
        return [];
      const $ = Array.from(g.querySelectorAll(`[${l}]`));
      return Array.from(I.itemMap.values()).sort(
        (f, d) => $.indexOf(f.ref.current) - $.indexOf(d.ref.current)
      );
    }, [
      I.collectionRef,
      I.itemMap
    ]);
  }
  return [
    {
      Provider: s,
      Slot: c,
      ItemSlot: u
    },
    b,
    o
  ];
}
function pe(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function Be(e) {
  const t = K(e);
  return ae(() => {
    t.current = e;
  }), ct(
    () => (...n) => {
      var o;
      return (o = t.current) === null || o === void 0 ? void 0 : o.call(t, ...n);
    },
    []
  );
}
function $t({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [o, i] = Kl({
    defaultProp: t,
    onChange: n
  }), r = e !== void 0, s = r ? e : o, a = Be(n), c = se((p) => {
    if (r) {
      const u = typeof p == "function" ? p(e) : p;
      u !== e && a(u);
    } else
      i(p);
  }, [
    r,
    e,
    i,
    a
  ]);
  return [
    s,
    c
  ];
}
function Kl({ defaultProp: e, onChange: t }) {
  const n = $e(e), [o] = n, i = K(o), r = Be(t);
  return ae(() => {
    i.current !== o && (r(o), i.current = o);
  }, [
    o,
    i,
    r
  ]), n;
}
const Wl = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], he = Wl.reduce((e, t) => {
  const n = /* @__PURE__ */ ce((o, i) => {
    const { asChild: r, ...s } = o, a = r ? sn : t;
    return ae(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ k(a, N({}, s, {
      ref: i
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function Pr(e, t) {
  e && qi(
    () => e.dispatchEvent(t)
  );
}
const Bt = globalThis != null && globalThis.document ? Yi : () => {
};
function zl(e, t) {
  return Gi((n, o) => {
    const i = t[n][o];
    return i ?? n;
  }, e);
}
const wt = (e) => {
  const { present: t, children: n } = e, o = Yl(t), i = typeof n == "function" ? n({
    present: o.isPresent
  }) : It.only(n), r = We(o.ref, i.ref);
  return typeof n == "function" || o.isPresent ? /* @__PURE__ */ Kt(i, {
    ref: r
  }) : null;
};
wt.displayName = "Presence";
function Yl(e) {
  const [t, n] = $e(), o = K({}), i = K(e), r = K("none"), s = e ? "mounted" : "unmounted", [a, c] = zl(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return ae(() => {
    const p = bn(o.current);
    r.current = a === "mounted" ? p : "none";
  }, [
    a
  ]), Bt(() => {
    const p = o.current, l = i.current;
    if (l !== e) {
      const b = r.current, y = bn(p);
      e ? c("MOUNT") : y === "none" || (p == null ? void 0 : p.display) === "none" ? c("UNMOUNT") : c(l && b !== y ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [
    e,
    c
  ]), Bt(() => {
    if (t) {
      const p = (u) => {
        const y = bn(o.current).includes(u.animationName);
        u.target === t && y && qi(
          () => c("ANIMATION_END")
        );
      }, l = (u) => {
        u.target === t && (r.current = bn(o.current));
      };
      return t.addEventListener("animationstart", l), t.addEventListener("animationcancel", p), t.addEventListener("animationend", p), () => {
        t.removeEventListener("animationstart", l), t.removeEventListener("animationcancel", p), t.removeEventListener("animationend", p);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(a),
    ref: se((p) => {
      p && (o.current = getComputedStyle(p)), n(p);
    }, [])
  };
}
function bn(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
const Gl = le["useId".toString()] || (() => {
});
let ql = 0;
function at(e) {
  const [t, n] = le.useState(Gl());
  return Bt(() => {
    e || n(
      (o) => o ?? String(ql++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
const Vs = "Collapsible", [Xl, js] = ft(Vs), [Zl, lo] = Xl(Vs), Jl = /* @__PURE__ */ ce((e, t) => {
  const { __scopeCollapsible: n, open: o, defaultOpen: i, disabled: r, onOpenChange: s, ...a } = e, [c = !1, p] = $t({
    prop: o,
    defaultProp: i,
    onChange: s
  });
  return /* @__PURE__ */ k(Zl, {
    scope: n,
    disabled: r,
    contentId: at(),
    open: c,
    onOpenToggle: se(
      () => p(
        (l) => !l
      ),
      [
        p
      ]
    )
  }, /* @__PURE__ */ k(he.div, N({
    "data-state": uo(c),
    "data-disabled": r ? "" : void 0
  }, a, {
    ref: t
  })));
}), Ql = "CollapsibleTrigger", eu = /* @__PURE__ */ ce((e, t) => {
  const { __scopeCollapsible: n, ...o } = e, i = lo(Ql, n);
  return /* @__PURE__ */ k(he.button, N({
    type: "button",
    "aria-controls": i.contentId,
    "aria-expanded": i.open || !1,
    "data-state": uo(i.open),
    "data-disabled": i.disabled ? "" : void 0,
    disabled: i.disabled
  }, o, {
    ref: t,
    onClick: pe(e.onClick, i.onOpenToggle)
  }));
}), Hs = "CollapsibleContent", tu = /* @__PURE__ */ ce((e, t) => {
  const { forceMount: n, ...o } = e, i = lo(Hs, e.__scopeCollapsible);
  return /* @__PURE__ */ k(
    wt,
    {
      present: n || i.open
    },
    ({ present: r }) => /* @__PURE__ */ k(nu, N({}, o, {
      ref: t,
      present: r
    }))
  );
}), nu = /* @__PURE__ */ ce((e, t) => {
  const { __scopeCollapsible: n, present: o, children: i, ...r } = e, s = lo(Hs, n), [a, c] = $e(o), p = K(null), l = We(t, p), u = K(0), b = u.current, y = K(0), I = y.current, v = s.open || a, g = K(v), $ = K();
  return ae(() => {
    const _ = requestAnimationFrame(
      () => g.current = !1
    );
    return () => cancelAnimationFrame(_);
  }, []), Bt(() => {
    const _ = p.current;
    if (_) {
      $.current = $.current || {
        transitionDuration: _.style.transitionDuration,
        animationName: _.style.animationName
      }, _.style.transitionDuration = "0s", _.style.animationName = "none";
      const m = _.getBoundingClientRect();
      u.current = m.height, y.current = m.width, g.current || (_.style.transitionDuration = $.current.transitionDuration, _.style.animationName = $.current.animationName), c(o);
    }
  }, [
    s.open,
    o
  ]), /* @__PURE__ */ k(he.div, N({
    "data-state": uo(s.open),
    "data-disabled": s.disabled ? "" : void 0,
    id: s.contentId,
    hidden: !v
  }, r, {
    ref: l,
    style: {
      "--radix-collapsible-content-height": b ? `${b}px` : void 0,
      "--radix-collapsible-content-width": I ? `${I}px` : void 0,
      ...e.style
    }
  }), v && i);
});
function uo(e) {
  return e ? "open" : "closed";
}
const Us = Jl, Bs = eu, Ks = tu, ru = /* @__PURE__ */ Ht(void 0);
function Un(e) {
  const t = cn(ru);
  return e || t || "ltr";
}
const pt = "Accordion", ou = [
  "Home",
  "End",
  "ArrowDown",
  "ArrowUp",
  "ArrowLeft",
  "ArrowRight"
], [fo, iu, su] = Hn(pt), [Bn, Em] = ft(pt, [
  su,
  js
]), po = js(), Ws = /* @__PURE__ */ Z.forwardRef((e, t) => {
  const { type: n, ...o } = e, i = o, r = o;
  return /* @__PURE__ */ Z.createElement(fo.Provider, {
    scope: e.__scopeAccordion
  }, n === "multiple" ? /* @__PURE__ */ Z.createElement(uu, N({}, r, {
    ref: t
  })) : /* @__PURE__ */ Z.createElement(lu, N({}, i, {
    ref: t
  })));
});
Ws.propTypes = {
  type(e) {
    const t = e.value || e.defaultValue;
    return e.type && ![
      "single",
      "multiple"
    ].includes(e.type) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected one of `single | multiple`.") : e.type === "multiple" && typeof t == "string" ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `single` when `defaultValue` or `value` is type `string`.") : e.type === "single" && Array.isArray(t) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `multiple` when `defaultValue` or `value` is type `string[]`.") : null;
  }
};
const [zs, au] = Bn(pt), [Ys, cu] = Bn(pt, {
  collapsible: !1
}), lu = /* @__PURE__ */ Z.forwardRef((e, t) => {
  const { value: n, defaultValue: o, onValueChange: i = () => {
  }, collapsible: r = !1, ...s } = e, [a, c] = $t({
    prop: n,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ Z.createElement(zs, {
    scope: e.__scopeAccordion,
    value: a ? [
      a
    ] : [],
    onItemOpen: c,
    onItemClose: Z.useCallback(
      () => r && c(""),
      [
        r,
        c
      ]
    )
  }, /* @__PURE__ */ Z.createElement(Ys, {
    scope: e.__scopeAccordion,
    collapsible: r
  }, /* @__PURE__ */ Z.createElement(Gs, N({}, s, {
    ref: t
  }))));
}), uu = /* @__PURE__ */ Z.forwardRef((e, t) => {
  const { value: n, defaultValue: o, onValueChange: i = () => {
  }, ...r } = e, [s = [], a] = $t({
    prop: n,
    defaultProp: o,
    onChange: i
  }), c = Z.useCallback(
    (l) => a(
      (u = []) => [
        ...u,
        l
      ]
    ),
    [
      a
    ]
  ), p = Z.useCallback(
    (l) => a(
      (u = []) => u.filter(
        (b) => b !== l
      )
    ),
    [
      a
    ]
  );
  return /* @__PURE__ */ Z.createElement(zs, {
    scope: e.__scopeAccordion,
    value: s,
    onItemOpen: c,
    onItemClose: p
  }, /* @__PURE__ */ Z.createElement(Ys, {
    scope: e.__scopeAccordion,
    collapsible: !0
  }, /* @__PURE__ */ Z.createElement(Gs, N({}, r, {
    ref: t
  }))));
}), [du, Kn] = Bn(pt), Gs = /* @__PURE__ */ Z.forwardRef((e, t) => {
  const { __scopeAccordion: n, disabled: o, dir: i, orientation: r = "vertical", ...s } = e, a = Z.useRef(null), c = We(a, t), p = iu(n), u = Un(i) === "ltr", b = pe(e.onKeyDown, (y) => {
    var I;
    if (!ou.includes(y.key))
      return;
    const v = y.target, g = p().filter((w) => {
      var j;
      return !((j = w.ref.current) !== null && j !== void 0 && j.disabled);
    }), $ = g.findIndex(
      (w) => w.ref.current === v
    ), _ = g.length;
    if ($ === -1)
      return;
    y.preventDefault();
    let m = $;
    const f = 0, d = _ - 1, C = () => {
      m = $ + 1, m > d && (m = f);
    }, S = () => {
      m = $ - 1, m < f && (m = d);
    };
    switch (y.key) {
      case "Home":
        m = f;
        break;
      case "End":
        m = d;
        break;
      case "ArrowRight":
        r === "horizontal" && (u ? C() : S());
        break;
      case "ArrowDown":
        r === "vertical" && C();
        break;
      case "ArrowLeft":
        r === "horizontal" && (u ? S() : C());
        break;
      case "ArrowUp":
        r === "vertical" && S();
        break;
    }
    const T = m % _;
    (I = g[T].ref.current) === null || I === void 0 || I.focus();
  });
  return /* @__PURE__ */ Z.createElement(du, {
    scope: n,
    disabled: o,
    direction: i,
    orientation: r
  }, /* @__PURE__ */ Z.createElement(fo.Slot, {
    scope: n
  }, /* @__PURE__ */ Z.createElement(he.div, N({}, s, {
    "data-orientation": r,
    ref: c,
    onKeyDown: o ? void 0 : b
  }))));
}), Mr = "AccordionItem", [fu, mo] = Bn(Mr), pu = /* @__PURE__ */ Z.forwardRef((e, t) => {
  const { __scopeAccordion: n, value: o, ...i } = e, r = Kn(Mr, n), s = au(Mr, n), a = po(n), c = at(), p = o && s.value.includes(o) || !1, l = r.disabled || e.disabled;
  return /* @__PURE__ */ Z.createElement(fu, {
    scope: n,
    open: p,
    disabled: l,
    triggerId: c
  }, /* @__PURE__ */ Z.createElement(Us, N({
    "data-orientation": r.orientation,
    "data-state": qs(p)
  }, a, i, {
    ref: t,
    disabled: l,
    open: p,
    onOpenChange: (u) => {
      u ? s.onItemOpen(o) : s.onItemClose(o);
    }
  })));
}), mu = "AccordionHeader", _u = /* @__PURE__ */ Z.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...o } = e, i = Kn(pt, n), r = mo(mu, n);
  return /* @__PURE__ */ Z.createElement(he.h3, N({
    "data-orientation": i.orientation,
    "data-state": qs(r.open),
    "data-disabled": r.disabled ? "" : void 0
  }, o, {
    ref: t
  }));
}), Ei = "AccordionTrigger", gu = /* @__PURE__ */ Z.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...o } = e, i = Kn(pt, n), r = mo(Ei, n), s = cu(Ei, n), a = po(n);
  return /* @__PURE__ */ Z.createElement(fo.ItemSlot, {
    scope: n
  }, /* @__PURE__ */ Z.createElement(Bs, N({
    "aria-disabled": r.open && !s.collapsible || void 0,
    "data-orientation": i.orientation,
    id: r.triggerId
  }, a, o, {
    ref: t
  })));
}), vu = "AccordionContent", hu = /* @__PURE__ */ Z.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...o } = e, i = Kn(pt, n), r = mo(vu, n), s = po(n);
  return /* @__PURE__ */ Z.createElement(Ks, N({
    role: "region",
    "aria-labelledby": r.triggerId,
    "data-orientation": i.orientation
  }, s, o, {
    ref: t,
    style: {
      "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
      "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
      ...e.style
    }
  }));
});
function qs(e) {
  return e ? "open" : "closed";
}
const bu = Ws, yu = pu, Eu = _u, Iu = gu, $u = hu, Zt = {
  "accordion-item": "_accordion-item_16iii_1",
  "accordion-header": "_accordion-header_16iii_10",
  "accordion-trigger": "_accordion-trigger_16iii_15",
  "accordion-content": "_accordion-content_16iii_35",
  "slide-down": "_slide-down_16iii_1",
  "slide-up": "_slide-up_16iii_1",
  "accordion-content-text": "_accordion-content-text_16iii_43"
};
function Im({ items: e, className: t = "", ...n }) {
  return /* @__PURE__ */ E(bu, { type: "multiple", className: t, ...n, children: e == null ? void 0 : e.map((o) => /* @__PURE__ */ ne(yu, { className: Zt["accordion-item"], value: o.value, children: [
    /* @__PURE__ */ E(Eu, { className: Zt["accordion-header"], children: /* @__PURE__ */ ne(Iu, { className: Zt["accordion-trigger"], children: [
      o.title,
      /* @__PURE__ */ E(Fe, { name: "up-arrow" })
    ] }) }),
    /* @__PURE__ */ E($u, { className: Zt["accordion-content"], children: /* @__PURE__ */ E("div", { className: Zt["accordion-content-text"], children: o.content }) })
  ] }, o.value)) });
}
function wu(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Be(e);
  ae(() => {
    const o = (i) => {
      i.key === "Escape" && n(i);
    };
    return t.addEventListener("keydown", o), () => t.removeEventListener("keydown", o);
  }, [
    n,
    t
  ]);
}
const kr = "dismissableLayer.update", Cu = "dismissableLayer.pointerDownOutside", xu = "dismissableLayer.focusOutside";
let Ii;
const Tu = /* @__PURE__ */ Ht({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Xs = /* @__PURE__ */ ce((e, t) => {
  var n;
  const { disableOutsidePointerEvents: o = !1, onEscapeKeyDown: i, onPointerDownOutside: r, onFocusOutside: s, onInteractOutside: a, onDismiss: c, ...p } = e, l = cn(Tu), [u, b] = $e(null), y = (n = u == null ? void 0 : u.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, I] = $e({}), v = We(
    t,
    (T) => b(T)
  ), g = Array.from(l.layers), [$] = [
    ...l.layersWithOutsidePointerEventsDisabled
  ].slice(-1), _ = g.indexOf($), m = u ? g.indexOf(u) : -1, f = l.layersWithOutsidePointerEventsDisabled.size > 0, d = m >= _, C = Su((T) => {
    const w = T.target, j = [
      ...l.branches
    ].some(
      (Y) => Y.contains(w)
    );
    !d || j || (r == null || r(T), a == null || a(T), T.defaultPrevented || c == null || c());
  }, y), S = Nu((T) => {
    const w = T.target;
    [
      ...l.branches
    ].some(
      (Y) => Y.contains(w)
    ) || (s == null || s(T), a == null || a(T), T.defaultPrevented || c == null || c());
  }, y);
  return wu((T) => {
    m === l.layers.size - 1 && (i == null || i(T), !T.defaultPrevented && c && (T.preventDefault(), c()));
  }, y), ae(() => {
    if (u)
      return o && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (Ii = y.body.style.pointerEvents, y.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(u)), l.layers.add(u), $i(), () => {
        o && l.layersWithOutsidePointerEventsDisabled.size === 1 && (y.body.style.pointerEvents = Ii);
      };
  }, [
    u,
    y,
    o,
    l
  ]), ae(() => () => {
    u && (l.layers.delete(u), l.layersWithOutsidePointerEventsDisabled.delete(u), $i());
  }, [
    u,
    l
  ]), ae(() => {
    const T = () => I({});
    return document.addEventListener(kr, T), () => document.removeEventListener(kr, T);
  }, []), /* @__PURE__ */ k(he.div, N({}, p, {
    ref: v,
    style: {
      pointerEvents: f ? d ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: pe(e.onFocusCapture, S.onFocusCapture),
    onBlurCapture: pe(e.onBlurCapture, S.onBlurCapture),
    onPointerDownCapture: pe(e.onPointerDownCapture, C.onPointerDownCapture)
  }));
});
function Su(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Be(e), o = K(!1), i = K(() => {
  });
  return ae(() => {
    const r = (a) => {
      if (a.target && !o.current) {
        let p = function() {
          Zs(Cu, n, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: a
        };
        a.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = p, t.addEventListener("click", i.current, {
          once: !0
        })) : p();
      } else
        t.removeEventListener("click", i.current);
      o.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", r);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", r), t.removeEventListener("click", i.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function Nu(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Be(e), o = K(!1);
  return ae(() => {
    const i = (r) => {
      r.target && !o.current && Zs(xu, n, {
        originalEvent: r
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function $i() {
  const e = new CustomEvent(kr);
  document.dispatchEvent(e);
}
function Zs(e, t, n, { discrete: o }) {
  const i = n.originalEvent.target, r = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && i.addEventListener(e, t, {
    once: !0
  }), o ? Pr(i, r) : i.dispatchEvent(r);
}
const vr = "focusScope.autoFocusOnMount", hr = "focusScope.autoFocusOnUnmount", wi = {
  bubbles: !1,
  cancelable: !0
}, Ou = /* @__PURE__ */ ce((e, t) => {
  const { loop: n = !1, trapped: o = !1, onMountAutoFocus: i, onUnmountAutoFocus: r, ...s } = e, [a, c] = $e(null), p = Be(i), l = Be(r), u = K(null), b = We(
    t,
    (v) => c(v)
  ), y = K({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  ae(() => {
    if (o) {
      let v = function(m) {
        if (y.paused || !a)
          return;
        const f = m.target;
        a.contains(f) ? u.current = f : dt(u.current, {
          select: !0
        });
      }, g = function(m) {
        if (y.paused || !a)
          return;
        const f = m.relatedTarget;
        f !== null && (a.contains(f) || dt(u.current, {
          select: !0
        }));
      }, $ = function(m) {
        if (document.activeElement === document.body)
          for (const d of m)
            d.removedNodes.length > 0 && dt(a);
      };
      document.addEventListener("focusin", v), document.addEventListener("focusout", g);
      const _ = new MutationObserver($);
      return a && _.observe(a, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", v), document.removeEventListener("focusout", g), _.disconnect();
      };
    }
  }, [
    o,
    a,
    y.paused
  ]), ae(() => {
    if (a) {
      xi.add(y);
      const v = document.activeElement;
      if (!a.contains(v)) {
        const $ = new CustomEvent(vr, wi);
        a.addEventListener(vr, p), a.dispatchEvent($), $.defaultPrevented || (Ru(ku(Js(a)), {
          select: !0
        }), document.activeElement === v && dt(a));
      }
      return () => {
        a.removeEventListener(vr, p), setTimeout(() => {
          const $ = new CustomEvent(hr, wi);
          a.addEventListener(hr, l), a.dispatchEvent($), $.defaultPrevented || dt(v ?? document.body, {
            select: !0
          }), a.removeEventListener(hr, l), xi.remove(y);
        }, 0);
      };
    }
  }, [
    a,
    p,
    l,
    y
  ]);
  const I = se((v) => {
    if (!n && !o || y.paused)
      return;
    const g = v.key === "Tab" && !v.altKey && !v.ctrlKey && !v.metaKey, $ = document.activeElement;
    if (g && $) {
      const _ = v.currentTarget, [m, f] = Au(_);
      m && f ? !v.shiftKey && $ === f ? (v.preventDefault(), n && dt(m, {
        select: !0
      })) : v.shiftKey && $ === m && (v.preventDefault(), n && dt(f, {
        select: !0
      })) : $ === _ && v.preventDefault();
    }
  }, [
    n,
    o,
    y.paused
  ]);
  return /* @__PURE__ */ k(he.div, N({
    tabIndex: -1
  }, s, {
    ref: b,
    onKeyDown: I
  }));
});
function Ru(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const o of e)
    if (dt(o, {
      select: t
    }), document.activeElement !== n)
      return;
}
function Au(e) {
  const t = Js(e), n = Ci(t, e), o = Ci(t.reverse(), e);
  return [
    n,
    o
  ];
}
function Js(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const i = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || i ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function Ci(e, t) {
  for (const n of e)
    if (!Du(n, {
      upTo: t
    }))
      return n;
}
function Du(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function Pu(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function dt(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && Pu(e) && t && e.select();
  }
}
const xi = Mu();
function Mu() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Ti(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Ti(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function Ti(e, t) {
  const n = [
    ...e
  ], o = n.indexOf(t);
  return o !== -1 && n.splice(o, 1), n;
}
function ku(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const Lu = /* @__PURE__ */ ce((e, t) => {
  var n;
  const { container: o = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...i } = e;
  return o ? /* @__PURE__ */ ic.createPortal(/* @__PURE__ */ k(he.div, N({}, i, {
    ref: t
  })), o) : null;
});
let br = 0;
function Fu() {
  ae(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : Si()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : Si()), br++, () => {
      br === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (o) => o.remove()
      ), br--;
    };
  }, []);
}
function Si() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var Tn = "right-scroll-bar-position", Sn = "width-before-scroll-bar", Vu = "with-scroll-bars-hidden", ju = "--removed-body-scroll-bar-size";
function Hu(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Uu(e, t) {
  var n = $e(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(o) {
          var i = n.value;
          i !== o && (n.value = o, n.callback(o, i));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
function Bu(e, t) {
  return Uu(t || null, function(n) {
    return e.forEach(function(o) {
      return Hu(o, n);
    });
  });
}
function Ku(e) {
  return e;
}
function Wu(e, t) {
  t === void 0 && (t = Ku);
  var n = [], o = !1, i = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(r) {
      var s = t(r, o);
      return n.push(s), function() {
        n = n.filter(function(a) {
          return a !== s;
        });
      };
    },
    assignSyncMedium: function(r) {
      for (o = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(r);
      }
      n = {
        push: function(a) {
          return r(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(r) {
      o = !0;
      var s = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(r), s = n;
      }
      var c = function() {
        var l = s;
        s = [], l.forEach(r);
      }, p = function() {
        return Promise.resolve().then(c);
      };
      p(), n = {
        push: function(l) {
          s.push(l), p();
        },
        filter: function(l) {
          return s = s.filter(l), n;
        }
      };
    }
  };
  return i;
}
function zu(e) {
  e === void 0 && (e = {});
  var t = Wu(null);
  return t.options = Ke({ async: !0, ssr: !1 }, e), t;
}
var Qs = function(e) {
  var t = e.sideCar, n = Qi(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return le.createElement(o, Ke({}, n));
};
Qs.isSideCarExport = !0;
function Yu(e, t) {
  return e.useMedium(t), Qs;
}
var ea = zu(), yr = function() {
}, Wn = le.forwardRef(function(e, t) {
  var n = le.useRef(null), o = le.useState({
    onScrollCapture: yr,
    onWheelCapture: yr,
    onTouchMoveCapture: yr
  }), i = o[0], r = o[1], s = e.forwardProps, a = e.children, c = e.className, p = e.removeScrollBar, l = e.enabled, u = e.shards, b = e.sideCar, y = e.noIsolation, I = e.inert, v = e.allowPinchZoom, g = e.as, $ = g === void 0 ? "div" : g, _ = Qi(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), m = b, f = Bu([n, t]), d = Ke(Ke({}, _), i);
  return le.createElement(
    le.Fragment,
    null,
    l && le.createElement(m, { sideCar: ea, removeScrollBar: p, shards: u, noIsolation: y, inert: I, setCallbacks: r, allowPinchZoom: !!v, lockRef: n }),
    s ? le.cloneElement(le.Children.only(a), Ke(Ke({}, d), { ref: f })) : le.createElement($, Ke({}, d, { className: c, ref: f }), a)
  );
});
Wn.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Wn.classNames = {
  fullWidth: Sn,
  zeroRight: Tn
};
var Ni, Gu = function() {
  if (Ni)
    return Ni;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function qu() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Gu();
  return t && e.setAttribute("nonce", t), e;
}
function Xu(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Zu(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Ju = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = qu()) && (Xu(t, n), Zu(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Qu = function() {
  var e = Ju();
  return function(t, n) {
    le.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, ta = function() {
  var e = Qu(), t = function(n) {
    var o = n.styles, i = n.dynamic;
    return e(o, i), null;
  };
  return t;
}, ed = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Er = function(e) {
  return parseInt(e || "", 10) || 0;
}, td = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Er(n), Er(o), Er(i)];
}, nd = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return ed;
  var t = td(e), n = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - n + t[2] - t[0])
  };
}, rd = ta(), od = function(e, t, n, o) {
  var i = e.left, r = e.top, s = e.right, a = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Vu, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(a, "px ").concat(o, `;
  }
  body {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(r, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(o, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Tn, ` {
    right: `).concat(a, "px ").concat(o, `;
  }
  
  .`).concat(Sn, ` {
    margin-right: `).concat(a, "px ").concat(o, `;
  }
  
  .`).concat(Tn, " .").concat(Tn, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(Sn, " .").concat(Sn, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body {
    `).concat(ju, ": ").concat(a, `px;
  }
`);
}, id = function(e) {
  var t = e.noRelative, n = e.noImportant, o = e.gapMode, i = o === void 0 ? "margin" : o, r = le.useMemo(function() {
    return nd(i);
  }, [i]);
  return le.createElement(rd, { styles: od(r, !t, i, n ? "" : "!important") });
}, Lr = !1;
if (typeof window < "u")
  try {
    var yn = Object.defineProperty({}, "passive", {
      get: function() {
        return Lr = !0, !0;
      }
    });
    window.addEventListener("test", yn, yn), window.removeEventListener("test", yn, yn);
  } catch {
    Lr = !1;
  }
var Mt = Lr ? { passive: !1 } : !1, sd = function(e) {
  return e.tagName === "TEXTAREA";
}, na = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !sd(e) && n[t] === "visible")
  );
}, ad = function(e) {
  return na(e, "overflowY");
}, cd = function(e) {
  return na(e, "overflowX");
}, Oi = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var o = ra(e, n);
    if (o) {
      var i = oa(e, n), r = i[1], s = i[2];
      if (r > s)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, ld = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    n,
    o
  ];
}, ud = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    n,
    o
  ];
}, ra = function(e, t) {
  return e === "v" ? ad(t) : cd(t);
}, oa = function(e, t) {
  return e === "v" ? ld(t) : ud(t);
}, dd = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, fd = function(e, t, n, o, i) {
  var r = dd(e, window.getComputedStyle(t).direction), s = r * o, a = n.target, c = t.contains(a), p = !1, l = s > 0, u = 0, b = 0;
  do {
    var y = oa(e, a), I = y[0], v = y[1], g = y[2], $ = v - g - r * I;
    (I || $) && ra(e, a) && (u += $, b += I), a = a.parentNode;
  } while (
    // portaled content
    !c && a !== document.body || // self content
    c && (t.contains(a) || t === a)
  );
  return (l && (i && u === 0 || !i && s > u) || !l && (i && b === 0 || !i && -s > b)) && (p = !0), p;
}, En = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Ri = function(e) {
  return [e.deltaX, e.deltaY];
}, Ai = function(e) {
  return e && "current" in e ? e.current : e;
}, pd = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, md = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, _d = 0, kt = [];
function gd(e) {
  var t = le.useRef([]), n = le.useRef([0, 0]), o = le.useRef(), i = le.useState(_d++)[0], r = le.useState(function() {
    return ta();
  })[0], s = le.useRef(e);
  le.useEffect(function() {
    s.current = e;
  }, [e]), le.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var v = Uc([e.lockRef.current], (e.shards || []).map(Ai), !0).filter(Boolean);
      return v.forEach(function(g) {
        return g.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), v.forEach(function(g) {
          return g.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = le.useCallback(function(v, g) {
    if ("touches" in v && v.touches.length === 2)
      return !s.current.allowPinchZoom;
    var $ = En(v), _ = n.current, m = "deltaX" in v ? v.deltaX : _[0] - $[0], f = "deltaY" in v ? v.deltaY : _[1] - $[1], d, C = v.target, S = Math.abs(m) > Math.abs(f) ? "h" : "v";
    if ("touches" in v && S === "h" && C.type === "range")
      return !1;
    var T = Oi(S, C);
    if (!T)
      return !0;
    if (T ? d = S : (d = S === "v" ? "h" : "v", T = Oi(S, C)), !T)
      return !1;
    if (!o.current && "changedTouches" in v && (m || f) && (o.current = d), !d)
      return !0;
    var w = o.current || d;
    return fd(w, g, v, w === "h" ? m : f, !0);
  }, []), c = le.useCallback(function(v) {
    var g = v;
    if (!(!kt.length || kt[kt.length - 1] !== r)) {
      var $ = "deltaY" in g ? Ri(g) : En(g), _ = t.current.filter(function(d) {
        return d.name === g.type && d.target === g.target && pd(d.delta, $);
      })[0];
      if (_ && _.should) {
        g.cancelable && g.preventDefault();
        return;
      }
      if (!_) {
        var m = (s.current.shards || []).map(Ai).filter(Boolean).filter(function(d) {
          return d.contains(g.target);
        }), f = m.length > 0 ? a(g, m[0]) : !s.current.noIsolation;
        f && g.cancelable && g.preventDefault();
      }
    }
  }, []), p = le.useCallback(function(v, g, $, _) {
    var m = { name: v, delta: g, target: $, should: _ };
    t.current.push(m), setTimeout(function() {
      t.current = t.current.filter(function(f) {
        return f !== m;
      });
    }, 1);
  }, []), l = le.useCallback(function(v) {
    n.current = En(v), o.current = void 0;
  }, []), u = le.useCallback(function(v) {
    p(v.type, Ri(v), v.target, a(v, e.lockRef.current));
  }, []), b = le.useCallback(function(v) {
    p(v.type, En(v), v.target, a(v, e.lockRef.current));
  }, []);
  le.useEffect(function() {
    return kt.push(r), e.setCallbacks({
      onScrollCapture: u,
      onWheelCapture: u,
      onTouchMoveCapture: b
    }), document.addEventListener("wheel", c, Mt), document.addEventListener("touchmove", c, Mt), document.addEventListener("touchstart", l, Mt), function() {
      kt = kt.filter(function(v) {
        return v !== r;
      }), document.removeEventListener("wheel", c, Mt), document.removeEventListener("touchmove", c, Mt), document.removeEventListener("touchstart", l, Mt);
    };
  }, []);
  var y = e.removeScrollBar, I = e.inert;
  return le.createElement(
    le.Fragment,
    null,
    I ? le.createElement(r, { styles: md(i) }) : null,
    y ? le.createElement(id, { gapMode: "margin" }) : null
  );
}
const vd = Yu(ea, gd);
var ia = le.forwardRef(function(e, t) {
  return le.createElement(Wn, Ke({}, e, { ref: t, sideCar: vd }));
});
ia.classNames = Wn.classNames;
const hd = ia;
var bd = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Lt = /* @__PURE__ */ new WeakMap(), In = /* @__PURE__ */ new WeakMap(), $n = {}, Ir = 0, sa = function(e) {
  return e && (e.host || sa(e.parentNode));
}, yd = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var o = sa(n);
    return o && e.contains(o) ? o : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, Ed = function(e, t, n, o) {
  var i = yd(t, Array.isArray(e) ? e : [e]);
  $n[n] || ($n[n] = /* @__PURE__ */ new WeakMap());
  var r = $n[n], s = [], a = /* @__PURE__ */ new Set(), c = new Set(i), p = function(u) {
    !u || a.has(u) || (a.add(u), p(u.parentNode));
  };
  i.forEach(p);
  var l = function(u) {
    !u || c.has(u) || Array.prototype.forEach.call(u.children, function(b) {
      if (a.has(b))
        l(b);
      else {
        var y = b.getAttribute(o), I = y !== null && y !== "false", v = (Lt.get(b) || 0) + 1, g = (r.get(b) || 0) + 1;
        Lt.set(b, v), r.set(b, g), s.push(b), v === 1 && I && In.set(b, !0), g === 1 && b.setAttribute(n, "true"), I || b.setAttribute(o, "true");
      }
    });
  };
  return l(t), a.clear(), Ir++, function() {
    s.forEach(function(u) {
      var b = Lt.get(u) - 1, y = r.get(u) - 1;
      Lt.set(u, b), r.set(u, y), b || (In.has(u) || u.removeAttribute(o), In.delete(u)), y || u.removeAttribute(n);
    }), Ir--, Ir || (Lt = /* @__PURE__ */ new WeakMap(), Lt = /* @__PURE__ */ new WeakMap(), In = /* @__PURE__ */ new WeakMap(), $n = {});
  };
}, Id = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), i = t || bd(e);
  return i ? (o.push.apply(o, Array.from(i.querySelectorAll("[aria-live]"))), Ed(o, i, n, "aria-hidden")) : function() {
    return null;
  };
};
const aa = "Dialog", [ca, $m] = ft(aa), [$d, nt] = ca(aa), wd = (e) => {
  const { __scopeDialog: t, children: n, open: o, defaultOpen: i, onOpenChange: r, modal: s = !0 } = e, a = K(null), c = K(null), [p = !1, l] = $t({
    prop: o,
    defaultProp: i,
    onChange: r
  });
  return /* @__PURE__ */ k($d, {
    scope: t,
    triggerRef: a,
    contentRef: c,
    contentId: at(),
    titleId: at(),
    descriptionId: at(),
    open: p,
    onOpenChange: l,
    onOpenToggle: se(
      () => l(
        (u) => !u
      ),
      [
        l
      ]
    ),
    modal: s
  }, n);
}, la = "DialogPortal", [Cd, ua] = ca(la, {
  forceMount: void 0
}), xd = (e) => {
  const { __scopeDialog: t, forceMount: n, children: o, container: i } = e, r = nt(la, t);
  return /* @__PURE__ */ k(Cd, {
    scope: t,
    forceMount: n
  }, It.map(
    o,
    (s) => /* @__PURE__ */ k(wt, {
      present: n || r.open
    }, /* @__PURE__ */ k(Lu, {
      asChild: !0,
      container: i
    }, s))
  ));
}, Fr = "DialogOverlay", Td = /* @__PURE__ */ ce((e, t) => {
  const n = ua(Fr, e.__scopeDialog), { forceMount: o = n.forceMount, ...i } = e, r = nt(Fr, e.__scopeDialog);
  return r.modal ? /* @__PURE__ */ k(wt, {
    present: o || r.open
  }, /* @__PURE__ */ k(Sd, N({}, i, {
    ref: t
  }))) : null;
}), Sd = /* @__PURE__ */ ce((e, t) => {
  const { __scopeDialog: n, ...o } = e, i = nt(Fr, n);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ k(hd, {
      as: sn,
      allowPinchZoom: !0,
      shards: [
        i.contentRef
      ]
    }, /* @__PURE__ */ k(he.div, N({
      "data-state": fa(i.open)
    }, o, {
      ref: t,
      style: {
        pointerEvents: "auto",
        ...o.style
      }
    })))
  );
}), an = "DialogContent", Nd = /* @__PURE__ */ ce((e, t) => {
  const n = ua(an, e.__scopeDialog), { forceMount: o = n.forceMount, ...i } = e, r = nt(an, e.__scopeDialog);
  return /* @__PURE__ */ k(wt, {
    present: o || r.open
  }, r.modal ? /* @__PURE__ */ k(Od, N({}, i, {
    ref: t
  })) : /* @__PURE__ */ k(Rd, N({}, i, {
    ref: t
  })));
}), Od = /* @__PURE__ */ ce((e, t) => {
  const n = nt(an, e.__scopeDialog), o = K(null), i = We(t, n.contentRef, o);
  return ae(() => {
    const r = o.current;
    if (r)
      return Id(r);
  }, []), /* @__PURE__ */ k(da, N({}, e, {
    ref: i,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: pe(e.onCloseAutoFocus, (r) => {
      var s;
      r.preventDefault(), (s = n.triggerRef.current) === null || s === void 0 || s.focus();
    }),
    onPointerDownOutside: pe(e.onPointerDownOutside, (r) => {
      const s = r.detail.originalEvent, a = s.button === 0 && s.ctrlKey === !0;
      (s.button === 2 || a) && r.preventDefault();
    }),
    onFocusOutside: pe(
      e.onFocusOutside,
      (r) => r.preventDefault()
    )
  }));
}), Rd = /* @__PURE__ */ ce((e, t) => {
  const n = nt(an, e.__scopeDialog), o = K(!1), i = K(!1);
  return /* @__PURE__ */ k(da, N({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (r) => {
      var s;
      if ((s = e.onCloseAutoFocus) === null || s === void 0 || s.call(e, r), !r.defaultPrevented) {
        var a;
        o.current || (a = n.triggerRef.current) === null || a === void 0 || a.focus(), r.preventDefault();
      }
      o.current = !1, i.current = !1;
    },
    onInteractOutside: (r) => {
      var s, a;
      (s = e.onInteractOutside) === null || s === void 0 || s.call(e, r), r.defaultPrevented || (o.current = !0, r.detail.originalEvent.type === "pointerdown" && (i.current = !0));
      const c = r.target;
      ((a = n.triggerRef.current) === null || a === void 0 ? void 0 : a.contains(c)) && r.preventDefault(), r.detail.originalEvent.type === "focusin" && i.current && r.preventDefault();
    }
  }));
}), da = /* @__PURE__ */ ce((e, t) => {
  const { __scopeDialog: n, trapFocus: o, onOpenAutoFocus: i, onCloseAutoFocus: r, ...s } = e, a = nt(an, n), c = K(null), p = We(t, c);
  return Fu(), /* @__PURE__ */ k(on, null, /* @__PURE__ */ k(Ou, {
    asChild: !0,
    loop: !0,
    trapped: o,
    onMountAutoFocus: i,
    onUnmountAutoFocus: r
  }, /* @__PURE__ */ k(Xs, N({
    role: "dialog",
    id: a.contentId,
    "aria-describedby": a.descriptionId,
    "aria-labelledby": a.titleId,
    "data-state": fa(a.open)
  }, s, {
    ref: p,
    onDismiss: () => a.onOpenChange(!1)
  }))), !1);
}), Ad = "DialogTitle", Dd = /* @__PURE__ */ ce((e, t) => {
  const { __scopeDialog: n, ...o } = e, i = nt(Ad, n);
  return /* @__PURE__ */ k(he.h2, N({
    id: i.titleId
  }, o, {
    ref: t
  }));
}), Pd = "DialogDescription", Md = /* @__PURE__ */ ce((e, t) => {
  const { __scopeDialog: n, ...o } = e, i = nt(Pd, n);
  return /* @__PURE__ */ k(he.p, N({
    id: i.descriptionId
  }, o, {
    ref: t
  }));
}), kd = "DialogClose", Ld = /* @__PURE__ */ ce((e, t) => {
  const { __scopeDialog: n, ...o } = e, i = nt(kd, n);
  return /* @__PURE__ */ k(he.button, N({
    type: "button"
  }, o, {
    ref: t,
    onClick: pe(
      e.onClick,
      () => i.onOpenChange(!1)
    )
  }));
});
function fa(e) {
  return e ? "open" : "closed";
}
const pa = wd, ma = xd, _a = Td, ga = Nd, Di = Dd, Fd = Md, va = Ld, Vd = /* @__PURE__ */ ce((e, t) => /* @__PURE__ */ k(he.span, N({}, e, {
  ref: t,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...e.style
  }
}))), ha = Vd, jd = "_modal_tca6i_1", yt = {
  "modal-overlay": "_modal-overlay_tca6i_1",
  "overlay-show": "_overlay-show_tca6i_1",
  modal: jd,
  "content-show": "_content-show_tca6i_1",
  "is-small": "_is-small_tca6i_32",
  "is-medium": "_is-medium_tca6i_35",
  "is-large": "_is-large_tca6i_38",
  "modal-title": "_modal-title_tca6i_46",
  "modal-content": "_modal-content_tca6i_55",
  "modal-close": "_modal-close_tca6i_59"
}, Hd = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
};
function wm({
  size: e = "medium",
  isOpen: t = !1,
  title: n,
  description: o,
  onClose: i,
  children: r,
  actions: s,
  dangerouslySetInnerHTMLTitle: a
}) {
  const c = X(yt.modal, yt[Hd[e]]);
  return /* @__PURE__ */ E(pa, { defaultOpen: t, open: t, children: /* @__PURE__ */ ne(ma, { children: [
    /* @__PURE__ */ E(_a, { className: yt["modal-overlay"], onClick: i }),
    /* @__PURE__ */ ne(ga, { className: c, children: [
      a ? /* @__PURE__ */ E(Di, { className: yt["modal-title"], dangerouslySetInnerHTML: { __html: n } }) : /* @__PURE__ */ E(Di, { className: yt["modal-title"], children: n }),
      o && /* @__PURE__ */ E(ha, { asChild: !0, children: /* @__PURE__ */ E(Fd, { children: o }) }),
      /* @__PURE__ */ E("div", { className: yt["modal-content"], children: r }),
      s && /* @__PURE__ */ E("div", { children: s }),
      /* @__PURE__ */ E(va, { asChild: !0, children: /* @__PURE__ */ E("button", { onClick: i, className: yt["modal-close"], "aria-label": "Close", children: /* @__PURE__ */ E(Fe, { name: "remove", size: "large" }) }) })
    ] })
  ] }) });
}
const Ud = "_box_1a25d_1", Bd = "_small_1a25d_6", Kd = "_medium_1a25d_9", Pi = {
  box: Ud,
  small: Bd,
  medium: Kd
};
function Cm({ children: e, size: t = "medium", className: n = "", ...o }) {
  const i = X(Pi.box, Pi[t], n);
  return /* @__PURE__ */ E("div", { className: i, ...o, children: e });
}
const Wd = "_divider_1lvcv_1", Mi = {
  divider: Wd,
  "small-space": "_small-space_1lvcv_5"
};
function xm({ className: e, smallSpace: t, ...n }) {
  const o = X(Mi.divider, t && Mi["small-space"], e);
  return /* @__PURE__ */ E("div", { className: o, ...n });
}
const $r = "rovingFocusGroup.onEntryFocus", zd = {
  bubbles: !1,
  cancelable: !0
}, _o = "RovingFocusGroup", [Vr, ba, Yd] = Hn(_o), [Gd, ya] = ft(_o, [
  Yd
]), [qd, Xd] = Gd(_o), Zd = /* @__PURE__ */ ce((e, t) => /* @__PURE__ */ k(Vr.Provider, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ k(Vr.Slot, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ k(Jd, N({}, e, {
  ref: t
}))))), Jd = /* @__PURE__ */ ce((e, t) => {
  const { __scopeRovingFocusGroup: n, orientation: o, loop: i = !1, dir: r, currentTabStopId: s, defaultCurrentTabStopId: a, onCurrentTabStopIdChange: c, onEntryFocus: p, ...l } = e, u = K(null), b = We(t, u), y = Un(r), [I = null, v] = $t({
    prop: s,
    defaultProp: a,
    onChange: c
  }), [g, $] = $e(!1), _ = Be(p), m = ba(n), f = K(!1), [d, C] = $e(0);
  return ae(() => {
    const S = u.current;
    if (S)
      return S.addEventListener($r, _), () => S.removeEventListener($r, _);
  }, [
    _
  ]), /* @__PURE__ */ k(qd, {
    scope: n,
    orientation: o,
    dir: y,
    loop: i,
    currentTabStopId: I,
    onItemFocus: se(
      (S) => v(S),
      [
        v
      ]
    ),
    onItemShiftTab: se(
      () => $(!0),
      []
    ),
    onFocusableItemAdd: se(
      () => C(
        (S) => S + 1
      ),
      []
    ),
    onFocusableItemRemove: se(
      () => C(
        (S) => S - 1
      ),
      []
    )
  }, /* @__PURE__ */ k(he.div, N({
    tabIndex: g || d === 0 ? -1 : 0,
    "data-orientation": o
  }, l, {
    ref: b,
    style: {
      outline: "none",
      ...e.style
    },
    onMouseDown: pe(e.onMouseDown, () => {
      f.current = !0;
    }),
    onFocus: pe(e.onFocus, (S) => {
      const T = !f.current;
      if (S.target === S.currentTarget && T && !g) {
        const w = new CustomEvent($r, zd);
        if (S.currentTarget.dispatchEvent(w), !w.defaultPrevented) {
          const j = m().filter(
            (fe) => fe.focusable
          ), Y = j.find(
            (fe) => fe.active
          ), ee = j.find(
            (fe) => fe.id === I
          ), re = [
            Y,
            ee,
            ...j
          ].filter(Boolean).map(
            (fe) => fe.ref.current
          );
          Ea(re);
        }
      }
      f.current = !1;
    }),
    onBlur: pe(
      e.onBlur,
      () => $(!1)
    )
  })));
}), Qd = "RovingFocusGroupItem", ef = /* @__PURE__ */ ce((e, t) => {
  const { __scopeRovingFocusGroup: n, focusable: o = !0, active: i = !1, tabStopId: r, ...s } = e, a = at(), c = r || a, p = Xd(Qd, n), l = p.currentTabStopId === c, u = ba(n), { onFocusableItemAdd: b, onFocusableItemRemove: y } = p;
  return ae(() => {
    if (o)
      return b(), () => y();
  }, [
    o,
    b,
    y
  ]), /* @__PURE__ */ k(Vr.ItemSlot, {
    scope: n,
    id: c,
    focusable: o,
    active: i
  }, /* @__PURE__ */ k(he.span, N({
    tabIndex: l ? 0 : -1,
    "data-orientation": p.orientation
  }, s, {
    ref: t,
    onMouseDown: pe(e.onMouseDown, (I) => {
      o ? p.onItemFocus(c) : I.preventDefault();
    }),
    onFocus: pe(
      e.onFocus,
      () => p.onItemFocus(c)
    ),
    onKeyDown: pe(e.onKeyDown, (I) => {
      if (I.key === "Tab" && I.shiftKey) {
        p.onItemShiftTab();
        return;
      }
      if (I.target !== I.currentTarget)
        return;
      const v = rf(I, p.orientation, p.dir);
      if (v !== void 0) {
        I.preventDefault();
        let $ = u().filter(
          (_) => _.focusable
        ).map(
          (_) => _.ref.current
        );
        if (v === "last")
          $.reverse();
        else if (v === "prev" || v === "next") {
          v === "prev" && $.reverse();
          const _ = $.indexOf(I.currentTarget);
          $ = p.loop ? of($, _ + 1) : $.slice(_ + 1);
        }
        setTimeout(
          () => Ea($)
        );
      }
    })
  })));
}), tf = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function nf(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function rf(e, t, n) {
  const o = nf(e.key, n);
  if (!(t === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(o)) && !(t === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(o)))
    return tf[o];
}
function Ea(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function of(e, t) {
  return e.map(
    (n, o) => e[(t + o) % e.length]
  );
}
const sf = Zd, af = ef, Ia = "Tabs", [cf, Tm] = ft(Ia, [
  ya
]), $a = ya(), [lf, go] = cf(Ia), uf = /* @__PURE__ */ ce((e, t) => {
  const { __scopeTabs: n, value: o, onValueChange: i, defaultValue: r, orientation: s = "horizontal", dir: a, activationMode: c = "automatic", ...p } = e, l = Un(a), [u, b] = $t({
    prop: o,
    onChange: i,
    defaultProp: r
  });
  return /* @__PURE__ */ k(lf, {
    scope: n,
    baseId: at(),
    value: u,
    onValueChange: b,
    orientation: s,
    dir: l,
    activationMode: c
  }, /* @__PURE__ */ k(he.div, N({
    dir: l,
    "data-orientation": s
  }, p, {
    ref: t
  })));
}), df = "TabsList", ff = /* @__PURE__ */ ce((e, t) => {
  const { __scopeTabs: n, loop: o = !0, ...i } = e, r = go(df, n), s = $a(n);
  return /* @__PURE__ */ k(sf, N({
    asChild: !0
  }, s, {
    orientation: r.orientation,
    dir: r.dir,
    loop: o
  }), /* @__PURE__ */ k(he.div, N({
    role: "tablist",
    "aria-orientation": r.orientation
  }, i, {
    ref: t
  })));
}), pf = "TabsTrigger", mf = /* @__PURE__ */ ce((e, t) => {
  const { __scopeTabs: n, value: o, disabled: i = !1, ...r } = e, s = go(pf, n), a = $a(n), c = wa(s.baseId, o), p = Ca(s.baseId, o), l = o === s.value;
  return /* @__PURE__ */ k(af, N({
    asChild: !0
  }, a, {
    focusable: !i,
    active: l
  }), /* @__PURE__ */ k(he.button, N({
    type: "button",
    role: "tab",
    "aria-selected": l,
    "aria-controls": p,
    "data-state": l ? "active" : "inactive",
    "data-disabled": i ? "" : void 0,
    disabled: i,
    id: c
  }, r, {
    ref: t,
    onMouseDown: pe(e.onMouseDown, (u) => {
      !i && u.button === 0 && u.ctrlKey === !1 ? s.onValueChange(o) : u.preventDefault();
    }),
    onKeyDown: pe(e.onKeyDown, (u) => {
      [
        " ",
        "Enter"
      ].includes(u.key) && s.onValueChange(o);
    }),
    onFocus: pe(e.onFocus, () => {
      const u = s.activationMode !== "manual";
      !l && !i && u && s.onValueChange(o);
    })
  })));
}), _f = "TabsContent", gf = /* @__PURE__ */ ce((e, t) => {
  const { __scopeTabs: n, value: o, forceMount: i, children: r, ...s } = e, a = go(_f, n), c = wa(a.baseId, o), p = Ca(a.baseId, o), l = o === a.value, u = K(l);
  return ae(() => {
    const b = requestAnimationFrame(
      () => u.current = !1
    );
    return () => cancelAnimationFrame(b);
  }, []), /* @__PURE__ */ k(
    wt,
    {
      present: i || l
    },
    ({ present: b }) => /* @__PURE__ */ k(he.div, N({
      "data-state": l ? "active" : "inactive",
      "data-orientation": a.orientation,
      role: "tabpanel",
      "aria-labelledby": c,
      hidden: !b,
      id: p,
      tabIndex: 0
    }, s, {
      ref: t,
      style: {
        ...e.style,
        animationDuration: u.current ? "0s" : void 0
      }
    }), b && r)
  );
});
function wa(e, t) {
  return `${e}-trigger-${t}`;
}
function Ca(e, t) {
  return `${e}-content-${t}`;
}
const vf = uf, hf = ff, bf = mf, yf = gf, Ef = "_tabs_1r1yk_1", Qe = {
  tabs: Ef,
  "is-full-width": "_is-full-width_1r1yk_8",
  "tabs-content": "_tabs-content_1r1yk_11",
  "tabs-list": "_tabs-list_1r1yk_14",
  "is-small": "_is-small_1r1yk_17",
  "tabs-trigger-list": "_tabs-trigger-list_1r1yk_20",
  "tabs-trigger": "_tabs-trigger_1r1yk_20",
  "is-medium": "_is-medium_1r1yk_37",
  "tabs-underline": "_tabs-underline_1r1yk_47",
  "tabs-divider": "_tabs-divider_1r1yk_56"
};
function jr(e) {
  return e.replace(/\s/g, "-");
}
function xa(e, t) {
  return jr(t + "-" + e);
}
function If(e) {
  const [t, n] = $e([]);
  return ae(() => {
    const o = [];
    let i = 0;
    for (const r of e) {
      const s = document.getElementById(xa(r.title, i));
      s && (o.push(s.clientWidth), i++);
    }
    n(o);
  }, [e]), t;
}
function $f(e) {
  return ct(() => e.map((t, n) => ({
    ...t,
    value: xa(t.title, n)
  })), [e]);
}
function Sm({ tabs: e, isFullWidth: t, size: n = "medium", className: o = "", ...i }) {
  var u;
  const [r, s] = $e(0), a = $f(e), c = If(e), p = X(Qe.tabs, t && Qe["is-full-width"], o), l = X(Qe["tabs-trigger"], n && Qe[`is-${n}`]);
  return /* @__PURE__ */ ne(
    vf,
    {
      onValueChange: (b) => {
        const y = a.findIndex((I) => jr(I.value) === b);
        s(y);
      },
      className: p,
      defaultValue: (u = a[r]) == null ? void 0 : u.value,
      orientation: "horizontal",
      ...i,
      children: [
        /* @__PURE__ */ ne(hf, { className: X(Qe["tabs-list"], n === "small" && Qe["is-small"]), children: [
          /* @__PURE__ */ ne("div", { className: Qe["tabs-trigger-list"], children: [
            a.map((b) => {
              const y = b.value;
              return /* @__PURE__ */ E(
                bf,
                {
                  id: y,
                  "aria-controls": y,
                  "aria-labelledby": y,
                  className: l,
                  value: y,
                  children: b.title
                },
                y
              );
            }),
            /* @__PURE__ */ E(
              "span",
              {
                className: Qe["tabs-underline"],
                style: {
                  width: c[r],
                  transform: `translateX(${c.slice(0, r).reduce((b, y) => b + y, 0)}px)`
                }
              }
            )
          ] }),
          /* @__PURE__ */ E("div", { className: Qe["tabs-divider"] })
        ] }),
        a.map((b) => {
          const y = jr(b.value);
          return /* @__PURE__ */ E(yf, { className: Qe["tabs-content"], "aria-labelledby": y, value: y, children: b.content }, y);
        })
      ]
    }
  );
}
const wf = "_video_1chn3_1", Cf = "_iframe_1chn3_5", wn = {
  video: wf,
  iframe: Cf,
  "video-iframe": "_video-iframe_1chn3_11"
};
function Nm({ className: e = "", youtubeId: t, title: n, url: o, poster: i, ...r }) {
  const s = X(wn.video, t && wn.iframe);
  return t ? /* @__PURE__ */ E("div", { className: s, ...r, children: /* @__PURE__ */ E(
    "iframe",
    {
      className: wn["video-iframe"],
      src: `https://www.youtube.com/embed/${t}`,
      title: n,
      allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;",
      allowFullScreen: !0
    }
  ) }) : /* @__PURE__ */ E("video", { className: `${wn.video} ${e}`, poster: i, ...r, controls: !0, children: /* @__PURE__ */ E("source", { src: o, type: "video/mp4" }) });
}
const xf = "_collapsible_oyuve_1", Tf = "_arrow_oyuve_10", Ft = {
  collapsible: xf,
  "collapsible-trigger": "_collapsible-trigger_oyuve_4",
  "open-top": "_open-top_oyuve_10",
  arrow: Tf,
  "open-bottom": "_open-bottom_oyuve_10",
  "collapsible-label": "_collapsible-label_oyuve_31",
  "collapsible-content": "_collapsible-content_oyuve_34",
  "slide-down": "_slide-down_oyuve_1",
  "slide-up": "_slide-up_oyuve_1"
}, Om = ({
  className: e = "",
  labelOpen: t,
  labelClosed: n,
  children: o,
  onChange: i = () => null,
  isOpen: r = !1,
  openOn: s = "top",
  ...a
}) => {
  const [c, p] = $e(r), l = (y) => {
    p(y), i(y);
  };
  ae(() => {
    p(r);
  }, [r]);
  const u = /* @__PURE__ */ E(Ks, { className: Ft["collapsible-content"], children: o }), b = X(Ft["collapsible-trigger"], Ft[`open-${s}`]);
  return /* @__PURE__ */ ne(
    Us,
    {
      className: `${Ft.collapsible} ${e}`,
      open: c,
      onOpenChange: l,
      ...a,
      children: [
        s === "top" && u,
        /* @__PURE__ */ ne(Bs, { className: b, children: [
          /* @__PURE__ */ E(Fe, { name: "up-arrow", className: Ft.arrow }),
          /* @__PURE__ */ E("span", { className: Ft["collapsible-label"], children: c ? n : t })
        ] }),
        s === "bottom" && u
      ]
    }
  );
}, Sf = "_drawer_p1lt7_1", wr = {
  "drawer-overlay": "_drawer-overlay_p1lt7_1",
  "overlay-show": "_overlay-show_p1lt7_1",
  "overlay-hide": "_overlay-hide_p1lt7_1",
  drawer: Sf,
  "drawer-hide": "_drawer-hide_p1lt7_1",
  "drawer-show": "_drawer-show_p1lt7_1",
  "drawer-close": "_drawer-close_p1lt7_32"
};
function Nf({ children: e, isOpen: t, onClose: n, className: o }) {
  const i = X(wr.drawer, o);
  return /* @__PURE__ */ E(pa, { defaultOpen: t, open: t, children: /* @__PURE__ */ ne(ma, { children: [
    /* @__PURE__ */ E(_a, { className: wr["drawer-overlay"], onClick: n }),
    /* @__PURE__ */ ne(ga, { className: i, children: [
      e,
      /* @__PURE__ */ E(va, { asChild: !0, children: /* @__PURE__ */ E("button", { onClick: n, className: wr["drawer-close"], "aria-label": "Close", children: /* @__PURE__ */ E(Fe, { name: "remove", size: "large" }) }) })
    ] })
  ] }) });
}
const Ta = "Progress", zn = 100, [Of, Rm] = ft(Ta), [Rf, Af] = Of(Ta), Sa = /* @__PURE__ */ ce((e, t) => {
  const { __scopeProgress: n, value: o, max: i, getValueLabel: r = Mf, ...s } = e, a = Hr(i) ? i : zn, c = Oa(o, a) ? o : null, p = kn(c) ? r(c, a) : void 0;
  return /* @__PURE__ */ k(Rf, {
    scope: n,
    value: c,
    max: a
  }, /* @__PURE__ */ k(he.div, N({
    "aria-valuemax": a,
    "aria-valuemin": 0,
    "aria-valuenow": kn(c) ? c : void 0,
    "aria-valuetext": p,
    role: "progressbar",
    "data-state": Na(c, a),
    "data-value": c ?? void 0,
    "data-max": a
  }, s, {
    ref: t
  })));
});
Sa.propTypes = {
  max(e, t, n) {
    const o = e[t], i = String(o);
    return o && !Hr(o) ? new Error(kf(i, n)) : null;
  },
  value(e, t, n) {
    const o = e[t], i = String(o), r = Hr(e.max) ? e.max : zn;
    return o != null && !Oa(o, r) ? new Error(Lf(i, n)) : null;
  }
};
const Df = "ProgressIndicator", Pf = /* @__PURE__ */ ce((e, t) => {
  var n;
  const { __scopeProgress: o, ...i } = e, r = Af(Df, o);
  return /* @__PURE__ */ k(he.div, N({
    "data-state": Na(r.value, r.max),
    "data-value": (n = r.value) !== null && n !== void 0 ? n : void 0,
    "data-max": r.max
  }, i, {
    ref: t
  }));
});
function Mf(e, t) {
  return `${Math.round(e / t * 100)}%`;
}
function Na(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
function kn(e) {
  return typeof e == "number";
}
function Hr(e) {
  return kn(e) && !isNaN(e) && e > 0;
}
function Oa(e, t) {
  return kn(e) && !isNaN(e) && e <= t && e >= 0;
}
function kf(e, t) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${zn}\`.`;
}
function Lf(e, t) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${zn} if no \`max\` prop is set)
  - \`null\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
const Ff = Sa, Vf = Pf, jf = "_small_s8gd5_8", Hf = "_indicator_s8gd5_12", Uf = "_primary_s8gd5_21", Bf = "_secondary_s8gd5_27", Kf = "_tertiary_s8gd5_33", Wf = "_success_s8gd5_39", zf = "_error_s8gd5_51", Jt = {
  "progress-bar": "_progress-bar_s8gd5_1",
  small: jf,
  indicator: Hf,
  "full-width": "_full-width_s8gd5_18",
  primary: Uf,
  secondary: Bf,
  tertiary: Kf,
  success: Wf,
  "eco-green": "_eco-green_s8gd5_45",
  error: zf
}, Am = ({ value: e = 0, color: t = "primary", size: n, isFullWidth: o }) => {
  const [i, r] = $e(0), s = X(
    Jt["progress-bar"],
    n && Jt[n],
    t && Jt[t],
    o && Jt["full-width"]
  );
  return ae(() => {
    const a = setTimeout(() => r(e), 500);
    return () => clearTimeout(a);
  }, [e]), /* @__PURE__ */ E(Ff, { className: s, children: /* @__PURE__ */ E(Vf, { className: Jt.indicator, style: { transform: `translateX(-${100 - i}%)` } }) });
};
function Yf(e) {
  const t = K({
    value: e,
    previous: e
  });
  return ct(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [
    e
  ]);
}
const ln = "NavigationMenu", [vo, Gf, qf] = Hn(ln), [Ur, Xf, Zf] = Hn(ln), [ho, Dm] = ft(ln, [
  qf,
  Zf
]), [Jf, Ct] = ho(ln), [Qf, Pm] = ho(ln), ep = /* @__PURE__ */ ce((e, t) => {
  const { __scopeNavigationMenu: n, value: o, onValueChange: i, defaultValue: r, delayDuration: s = 200, skipDelayDuration: a = 300, orientation: c = "horizontal", dir: p, ...l } = e, [u, b] = $e(null), y = We(
    t,
    (w) => b(w)
  ), I = Un(p), v = K(0), g = K(0), $ = K(0), [_, m] = $e(!0), [f = "", d] = $t({
    prop: o,
    onChange: (w) => {
      const j = w !== "", Y = a > 0;
      j ? (window.clearTimeout($.current), Y && m(!1)) : (window.clearTimeout($.current), $.current = window.setTimeout(
        () => m(!0),
        a
      )), i == null || i(w);
    },
    defaultProp: r
  }), C = se(() => {
    window.clearTimeout(g.current), g.current = window.setTimeout(
      () => d(""),
      150
    );
  }, [
    d
  ]), S = se((w) => {
    window.clearTimeout(g.current), d(w);
  }, [
    d
  ]), T = se((w) => {
    f === w ? window.clearTimeout(g.current) : v.current = window.setTimeout(() => {
      window.clearTimeout(g.current), d(w);
    }, s);
  }, [
    f,
    d,
    s
  ]);
  return ae(() => () => {
    window.clearTimeout(v.current), window.clearTimeout(g.current), window.clearTimeout($.current);
  }, []), /* @__PURE__ */ k(tp, {
    scope: n,
    isRootMenu: !0,
    value: f,
    dir: I,
    orientation: c,
    rootNavigationMenu: u,
    onTriggerEnter: (w) => {
      window.clearTimeout(v.current), _ ? T(w) : S(w);
    },
    onTriggerLeave: () => {
      window.clearTimeout(v.current), C();
    },
    onContentEnter: () => window.clearTimeout(g.current),
    onContentLeave: C,
    onItemSelect: (w) => {
      d(
        (j) => j === w ? "" : w
      );
    },
    onItemDismiss: () => d("")
  }, /* @__PURE__ */ k(he.nav, N({
    "aria-label": "Main",
    "data-orientation": c,
    dir: I
  }, l, {
    ref: y
  })));
}), tp = (e) => {
  const { scope: t, isRootMenu: n, rootNavigationMenu: o, dir: i, orientation: r, children: s, value: a, onItemSelect: c, onItemDismiss: p, onTriggerEnter: l, onTriggerLeave: u, onContentEnter: b, onContentLeave: y } = e, [I, v] = $e(null), [g, $] = $e(/* @__PURE__ */ new Map()), [_, m] = $e(null);
  return /* @__PURE__ */ k(Jf, {
    scope: t,
    isRootMenu: n,
    rootNavigationMenu: o,
    value: a,
    previousValue: Yf(a),
    baseId: at(),
    dir: i,
    orientation: r,
    viewport: I,
    onViewportChange: v,
    indicatorTrack: _,
    onIndicatorTrackChange: m,
    onTriggerEnter: Be(l),
    onTriggerLeave: Be(u),
    onContentEnter: Be(b),
    onContentLeave: Be(y),
    onItemSelect: Be(c),
    onItemDismiss: Be(p),
    onViewportContentChange: se((f, d) => {
      $((C) => (C.set(f, d), new Map(C)));
    }, []),
    onViewportContentRemove: se((f) => {
      $((d) => d.has(f) ? (d.delete(f), new Map(d)) : d);
    }, [])
  }, /* @__PURE__ */ k(vo.Provider, {
    scope: t
  }, /* @__PURE__ */ k(Qf, {
    scope: t,
    items: g
  }, s)));
}, np = "NavigationMenuList", rp = /* @__PURE__ */ ce((e, t) => {
  const { __scopeNavigationMenu: n, ...o } = e, i = Ct(np, n), r = /* @__PURE__ */ k(he.ul, N({
    "data-orientation": i.orientation
  }, o, {
    ref: t
  }));
  return /* @__PURE__ */ k(he.div, {
    style: {
      position: "relative"
    },
    ref: i.onIndicatorTrackChange
  }, /* @__PURE__ */ k(vo.Slot, {
    scope: n
  }, i.isRootMenu ? /* @__PURE__ */ k(Aa, {
    asChild: !0
  }, r) : r));
}), op = "NavigationMenuItem", [ip, Ra] = ho(op), sp = /* @__PURE__ */ ce((e, t) => {
  const { __scopeNavigationMenu: n, value: o, ...i } = e, r = at(), s = o || r || "LEGACY_REACT_AUTO_VALUE", a = K(null), c = K(null), p = K(null), l = K(() => {
  }), u = K(!1), b = se((I = "start") => {
    if (a.current) {
      l.current();
      const v = Br(a.current);
      v.length && bo(I === "start" ? v : v.reverse());
    }
  }, []), y = se(() => {
    if (a.current) {
      const I = Br(a.current);
      I.length && (l.current = mp(I));
    }
  }, []);
  return /* @__PURE__ */ k(ip, {
    scope: n,
    value: s,
    triggerRef: c,
    contentRef: a,
    focusProxyRef: p,
    wasEscapeCloseRef: u,
    onEntryKeyDown: b,
    onFocusProxyEnter: b,
    onRootContentClose: y,
    onContentFocusOutside: y
  }, /* @__PURE__ */ k(he.li, N({}, i, {
    ref: t
  })));
}), ki = "NavigationMenuTrigger", ap = /* @__PURE__ */ ce((e, t) => {
  const { __scopeNavigationMenu: n, disabled: o, ...i } = e, r = Ct(ki, e.__scopeNavigationMenu), s = Ra(ki, e.__scopeNavigationMenu), a = K(null), c = We(a, s.triggerRef, t), p = Ma(r.baseId, s.value), l = ka(r.baseId, s.value), u = K(!1), b = K(!1), y = s.value === r.value;
  return /* @__PURE__ */ k(on, null, /* @__PURE__ */ k(vo.ItemSlot, {
    scope: n,
    value: s.value
  }, /* @__PURE__ */ k(Da, {
    asChild: !0
  }, /* @__PURE__ */ k(he.button, N({
    id: p,
    disabled: o,
    "data-disabled": o ? "" : void 0,
    "data-state": Pa(y),
    "aria-expanded": y,
    "aria-controls": l
  }, i, {
    ref: c,
    onPointerEnter: pe(e.onPointerEnter, () => {
      b.current = !1, s.wasEscapeCloseRef.current = !1;
    }),
    onPointerMove: pe(e.onPointerMove, Kr(() => {
      o || b.current || s.wasEscapeCloseRef.current || u.current || (r.onTriggerEnter(s.value), u.current = !0);
    })),
    onPointerLeave: pe(e.onPointerLeave, Kr(() => {
      o || (r.onTriggerLeave(), u.current = !1);
    })),
    onClick: pe(e.onClick, () => {
      r.onItemSelect(s.value), b.current = y;
    }),
    onKeyDown: pe(e.onKeyDown, (I) => {
      const g = {
        horizontal: "ArrowDown",
        vertical: r.dir === "rtl" ? "ArrowLeft" : "ArrowRight"
      }[r.orientation];
      y && I.key === g && (s.onEntryKeyDown(), I.preventDefault());
    })
  })))), y && /* @__PURE__ */ k(on, null, /* @__PURE__ */ k(ha, {
    "aria-hidden": !0,
    tabIndex: 0,
    ref: s.focusProxyRef,
    onFocus: (I) => {
      const v = s.contentRef.current, g = I.relatedTarget, $ = g === a.current, _ = v == null ? void 0 : v.contains(g);
      ($ || !_) && s.onFocusProxyEnter($ ? "start" : "end");
    }
  }), r.viewport && /* @__PURE__ */ k("span", {
    "aria-owns": l
  })));
}), Li = "navigationMenu.linkSelect", cp = /* @__PURE__ */ ce((e, t) => {
  const { __scopeNavigationMenu: n, active: o, onSelect: i, ...r } = e;
  return /* @__PURE__ */ k(Da, {
    asChild: !0
  }, /* @__PURE__ */ k(he.a, N({
    "data-active": o ? "" : void 0,
    "aria-current": o ? "page" : void 0
  }, r, {
    ref: t,
    onClick: pe(e.onClick, (s) => {
      const a = s.target, c = new CustomEvent(Li, {
        bubbles: !0,
        cancelable: !0
      });
      if (a.addEventListener(
        Li,
        (p) => i == null ? void 0 : i(p),
        {
          once: !0
        }
      ), Pr(a, c), !c.defaultPrevented && !s.metaKey) {
        const p = new CustomEvent(Nn, {
          bubbles: !0,
          cancelable: !0
        });
        Pr(a, p);
      }
    }, {
      checkForDefaultPrevented: !1
    })
  })));
}), Ln = "NavigationMenuContent", lp = /* @__PURE__ */ ce((e, t) => {
  const { forceMount: n, ...o } = e, i = Ct(Ln, e.__scopeNavigationMenu), r = Ra(Ln, e.__scopeNavigationMenu), s = We(r.contentRef, t), a = r.value === i.value, c = {
    value: r.value,
    triggerRef: r.triggerRef,
    focusProxyRef: r.focusProxyRef,
    wasEscapeCloseRef: r.wasEscapeCloseRef,
    onContentFocusOutside: r.onContentFocusOutside,
    onRootContentClose: r.onRootContentClose,
    ...o
  };
  return i.viewport ? /* @__PURE__ */ k(up, N({
    forceMount: n
  }, c, {
    ref: s
  })) : /* @__PURE__ */ k(wt, {
    present: n || a
  }, /* @__PURE__ */ k(dp, N({
    "data-state": Pa(a)
  }, c, {
    ref: s,
    onPointerEnter: pe(e.onPointerEnter, i.onContentEnter),
    onPointerLeave: pe(e.onPointerLeave, Kr(i.onContentLeave)),
    style: {
      // Prevent interaction when animating out
      pointerEvents: !a && i.isRootMenu ? "none" : void 0,
      ...c.style
    }
  })));
}), up = /* @__PURE__ */ ce((e, t) => {
  const n = Ct(Ln, e.__scopeNavigationMenu), { onViewportContentChange: o, onViewportContentRemove: i } = n;
  return Bt(() => {
    o(e.value, {
      ref: t,
      ...e
    });
  }, [
    e,
    t,
    o
  ]), Bt(() => () => i(e.value), [
    e.value,
    i
  ]), null;
}), Nn = "navigationMenu.rootContentDismiss", dp = /* @__PURE__ */ ce((e, t) => {
  const { __scopeNavigationMenu: n, value: o, triggerRef: i, focusProxyRef: r, wasEscapeCloseRef: s, onRootContentClose: a, onContentFocusOutside: c, ...p } = e, l = Ct(Ln, n), u = K(null), b = We(u, t), y = Ma(l.baseId, o), I = ka(l.baseId, o), v = Gf(n), g = K(null), { onItemDismiss: $ } = l;
  ae(() => {
    const m = u.current;
    if (l.isRootMenu && m) {
      const f = () => {
        var d;
        $(), a(), m.contains(document.activeElement) && ((d = i.current) === null || d === void 0 || d.focus());
      };
      return m.addEventListener(Nn, f), () => m.removeEventListener(Nn, f);
    }
  }, [
    l.isRootMenu,
    e.value,
    i,
    $,
    a
  ]);
  const _ = ct(() => {
    const f = v().map(
      (j) => j.value
    );
    l.dir === "rtl" && f.reverse();
    const d = f.indexOf(l.value), C = f.indexOf(l.previousValue), S = o === l.value, T = C === f.indexOf(o);
    if (!S && !T)
      return g.current;
    const w = (() => {
      if (d !== C) {
        if (S && C !== -1)
          return d > C ? "from-end" : "from-start";
        if (T && d !== -1)
          return d > C ? "to-start" : "to-end";
      }
      return null;
    })();
    return g.current = w, w;
  }, [
    l.previousValue,
    l.value,
    l.dir,
    v,
    o
  ]);
  return /* @__PURE__ */ k(Aa, {
    asChild: !0
  }, /* @__PURE__ */ k(Xs, N({
    id: I,
    "aria-labelledby": y,
    "data-motion": _,
    "data-orientation": l.orientation
  }, p, {
    ref: b,
    onDismiss: () => {
      var m;
      const f = new Event(Nn, {
        bubbles: !0,
        cancelable: !0
      });
      (m = u.current) === null || m === void 0 || m.dispatchEvent(f);
    },
    onFocusOutside: pe(e.onFocusOutside, (m) => {
      var f;
      c();
      const d = m.target;
      (f = l.rootNavigationMenu) !== null && f !== void 0 && f.contains(d) && m.preventDefault();
    }),
    onPointerDownOutside: pe(e.onPointerDownOutside, (m) => {
      var f;
      const d = m.target, C = v().some((T) => {
        var w;
        return (w = T.ref.current) === null || w === void 0 ? void 0 : w.contains(d);
      }), S = l.isRootMenu && ((f = l.viewport) === null || f === void 0 ? void 0 : f.contains(d));
      (C || S || !l.isRootMenu) && m.preventDefault();
    }),
    onKeyDown: pe(e.onKeyDown, (m) => {
      const f = m.altKey || m.ctrlKey || m.metaKey;
      if (m.key === "Tab" && !f) {
        const S = Br(m.currentTarget), T = document.activeElement, w = S.findIndex(
          (ee) => ee === T
        ), Y = m.shiftKey ? S.slice(0, w).reverse() : S.slice(w + 1, S.length);
        if (bo(Y))
          m.preventDefault();
        else {
          var C;
          (C = r.current) === null || C === void 0 || C.focus();
        }
      }
    }),
    onEscapeKeyDown: pe(e.onEscapeKeyDown, (m) => {
      s.current = !0;
    })
  })));
}), fp = "FocusGroup", Aa = /* @__PURE__ */ ce((e, t) => {
  const { __scopeNavigationMenu: n, ...o } = e, i = Ct(fp, n);
  return /* @__PURE__ */ k(Ur.Provider, {
    scope: n
  }, /* @__PURE__ */ k(Ur.Slot, {
    scope: n
  }, /* @__PURE__ */ k(he.div, N({
    dir: i.dir
  }, o, {
    ref: t
  }))));
}), Fi = [
  "ArrowRight",
  "ArrowLeft",
  "ArrowUp",
  "ArrowDown"
], pp = "FocusGroupItem", Da = /* @__PURE__ */ ce((e, t) => {
  const { __scopeNavigationMenu: n, ...o } = e, i = Xf(n), r = Ct(pp, n);
  return /* @__PURE__ */ k(Ur.ItemSlot, {
    scope: n
  }, /* @__PURE__ */ k(he.button, N({}, o, {
    ref: t,
    onKeyDown: pe(e.onKeyDown, (s) => {
      if ([
        "Home",
        "End",
        ...Fi
      ].includes(s.key)) {
        let c = i().map(
          (u) => u.ref.current
        );
        if ([
          r.dir === "rtl" ? "ArrowRight" : "ArrowLeft",
          "ArrowUp",
          "End"
        ].includes(s.key) && c.reverse(), Fi.includes(s.key)) {
          const u = c.indexOf(s.currentTarget);
          c = c.slice(u + 1);
        }
        setTimeout(
          () => bo(c)
        ), s.preventDefault();
      }
    })
  })));
});
function Br(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const i = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || i ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function bo(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
function mp(e) {
  return e.forEach((t) => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  }), () => {
    e.forEach((t) => {
      const n = t.dataset.tabindex;
      t.setAttribute("tabindex", n);
    });
  };
}
function Pa(e) {
  return e ? "open" : "closed";
}
function Ma(e, t) {
  return `${e}-trigger-${t}`;
}
function ka(e, t) {
  return `${e}-content-${t}`;
}
function Kr(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
const _p = ep, gp = rp, Fn = sp, vp = ap, hp = cp, bp = lp;
function yp() {
  const [e, t] = $e({
    width: 0,
    height: 0
  });
  return ae(() => {
    function n() {
      t({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", n), n(), () => window.removeEventListener("resize", n);
  }, []), e;
}
var Cr = { exports: {} };
/*! @license DOMPurify 3.0.8 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.0.8/LICENSE */
var Vi;
function ji() {
  return Vi || (Vi = 1, function(e, t) {
    (function(n, o) {
      e.exports = o();
    })(Tc, function() {
      const {
        entries: n,
        setPrototypeOf: o,
        isFrozen: i,
        getPrototypeOf: r,
        getOwnPropertyDescriptor: s
      } = Object;
      let {
        freeze: a,
        seal: c,
        create: p
      } = Object, {
        apply: l,
        construct: u
      } = typeof Reflect < "u" && Reflect;
      a || (a = function(H) {
        return H;
      }), c || (c = function(H) {
        return H;
      }), l || (l = function(H, te, Q) {
        return H.apply(te, Q);
      }), u || (u = function(H, te) {
        return new H(...te);
      });
      const b = S(Array.prototype.forEach), y = S(Array.prototype.pop), I = S(Array.prototype.push), v = S(String.prototype.toLowerCase), g = S(String.prototype.toString), $ = S(String.prototype.match), _ = S(String.prototype.replace), m = S(String.prototype.indexOf), f = S(String.prototype.trim), d = S(RegExp.prototype.test), C = T(TypeError);
      function S(ie) {
        return function(H) {
          for (var te = arguments.length, Q = new Array(te > 1 ? te - 1 : 0), Te = 1; Te < te; Te++)
            Q[Te - 1] = arguments[Te];
          return l(ie, H, Q);
        };
      }
      function T(ie) {
        return function() {
          for (var H = arguments.length, te = new Array(H), Q = 0; Q < H; Q++)
            te[Q] = arguments[Q];
          return u(ie, te);
        };
      }
      function w(ie, H) {
        let te = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : v;
        o && o(ie, null);
        let Q = H.length;
        for (; Q--; ) {
          let Te = H[Q];
          if (typeof Te == "string") {
            const Se = te(Te);
            Se !== Te && (i(H) || (H[Q] = Se), Te = Se);
          }
          ie[Te] = !0;
        }
        return ie;
      }
      function j(ie) {
        for (let H = 0; H < ie.length; H++)
          s(ie, H) === void 0 && (ie[H] = null);
        return ie;
      }
      function Y(ie) {
        const H = p(null);
        for (const [te, Q] of n(ie))
          s(ie, te) !== void 0 && (Array.isArray(Q) ? H[te] = j(Q) : Q && typeof Q == "object" && Q.constructor === Object ? H[te] = Y(Q) : H[te] = Q);
        return H;
      }
      function ee(ie, H) {
        for (; ie !== null; ) {
          const Q = s(ie, H);
          if (Q) {
            if (Q.get)
              return S(Q.get);
            if (typeof Q.value == "function")
              return S(Q.value);
          }
          ie = r(ie);
        }
        function te(Q) {
          return console.warn("fallback value for", Q), null;
        }
        return te;
      }
      const ue = a(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), re = a(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), fe = a(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Ee = a(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), oe = a(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), Pe = a(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), Me = a(["#text"]), x = a(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "xmlns", "slot"]), L = a(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), J = a(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), G = a(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), D = c(/\{\{[\w\W]*|[\w\W]*\}\}/gm), M = c(/<%[\w\W]*|[\w\W]*%>/gm), P = c(/\${[\w\W]*}/gm), F = c(/^data-[\-\w.\u00B7-\uFFFF]/), q = c(/^aria-[\-\w]+$/), z = c(
        /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
        // eslint-disable-line no-useless-escape
      ), W = c(/^(?:\w+script|data):/i), de = c(
        /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
        // eslint-disable-line no-control-regex
      ), R = c(/^html$/i);
      var be = /* @__PURE__ */ Object.freeze({
        __proto__: null,
        MUSTACHE_EXPR: D,
        ERB_EXPR: M,
        TMPLIT_EXPR: P,
        DATA_ATTR: F,
        ARIA_ATTR: q,
        IS_ALLOWED_URI: z,
        IS_SCRIPT_OR_DATA: W,
        ATTR_WHITESPACE: de,
        DOCTYPE_NAME: R
      });
      const V = function() {
        return typeof window > "u" ? null : window;
      }, De = function(H, te) {
        if (typeof H != "object" || typeof H.createPolicy != "function")
          return null;
        let Q = null;
        const Te = "data-tt-policy-suffix";
        te && te.hasAttribute(Te) && (Q = te.getAttribute(Te));
        const Se = "dompurify" + (Q ? "#" + Q : "");
        try {
          return H.createPolicy(Se, {
            createHTML(Ye) {
              return Ye;
            },
            createScriptURL(Ye) {
              return Ye;
            }
          });
        } catch {
          return console.warn("TrustedTypes policy " + Se + " could not be created."), null;
        }
      };
      function xe() {
        let ie = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : V();
        const H = (B) => xe(B);
        if (H.version = "3.0.8", H.removed = [], !ie || !ie.document || ie.document.nodeType !== 9)
          return H.isSupported = !1, H;
        let {
          document: te
        } = ie;
        const Q = te, Te = Q.currentScript, {
          DocumentFragment: Se,
          HTMLTemplateElement: Ye,
          Node: mt,
          Element: _t,
          NodeFilter: Ge,
          NamedNodeMap: rt = ie.NamedNodeMap || ie.MozNamedAttrMap,
          HTMLFormElement: Xe,
          DOMParser: ze,
          trustedTypes: xt
        } = ie, un = _t.prototype, Fa = ee(un, "cloneNode"), Va = ee(un, "nextSibling"), ja = ee(un, "childNodes"), Yn = ee(un, "parentNode");
        if (typeof Ye == "function") {
          const B = te.createElement("template");
          B.content && B.content.ownerDocument && (te = B.content.ownerDocument);
        }
        let Ve, Wt = "";
        const {
          implementation: Gn,
          createNodeIterator: Ha,
          createDocumentFragment: Ua,
          getElementsByTagName: Ba
        } = te, {
          importNode: Ka
        } = Q;
        let Ze = {};
        H.isSupported = typeof n == "function" && typeof Yn == "function" && Gn && Gn.createHTMLDocument !== void 0;
        const {
          MUSTACHE_EXPR: qn,
          ERB_EXPR: Xn,
          TMPLIT_EXPR: Zn,
          DATA_ATTR: Wa,
          ARIA_ATTR: za,
          IS_SCRIPT_OR_DATA: Ya,
          ATTR_WHITESPACE: $o
        } = be;
        let {
          IS_ALLOWED_URI: wo
        } = be, Oe = null;
        const Co = w({}, [...ue, ...re, ...fe, ...oe, ...Me]);
        let Re = null;
        const xo = w({}, [...x, ...L, ...J, ...G]);
        let Ce = Object.seal(p(null, {
          tagNameCheck: {
            writable: !0,
            configurable: !1,
            enumerable: !0,
            value: null
          },
          attributeNameCheck: {
            writable: !0,
            configurable: !1,
            enumerable: !0,
            value: null
          },
          allowCustomizedBuiltInElements: {
            writable: !0,
            configurable: !1,
            enumerable: !0,
            value: !1
          }
        })), zt = null, Jn = null, To = !0, Qn = !0, So = !1, No = !0, Tt = !1, gt = !1, er = !1, tr = !1, St = !1, dn = !1, fn = !1, Oo = !0, Ro = !1;
        const Ga = "user-content-";
        let nr = !0, Yt = !1, Nt = {}, Ot = null;
        const Ao = w({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
        let Do = null;
        const Po = w({}, ["audio", "video", "img", "source", "image", "track"]);
        let rr = null;
        const Mo = w({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), pn = "http://www.w3.org/1998/Math/MathML", mn = "http://www.w3.org/2000/svg", ot = "http://www.w3.org/1999/xhtml";
        let Rt = ot, or = !1, ir = null;
        const qa = w({}, [pn, mn, ot], g);
        let Gt = null;
        const Xa = ["application/xhtml+xml", "text/html"], Za = "text/html";
        let Ae = null, At = null;
        const Ja = te.createElement("form"), ko = function(h) {
          return h instanceof RegExp || h instanceof Function;
        }, sr = function() {
          let h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          if (!(At && At === h)) {
            if ((!h || typeof h != "object") && (h = {}), h = Y(h), Gt = // eslint-disable-next-line unicorn/prefer-includes
            Xa.indexOf(h.PARSER_MEDIA_TYPE) === -1 ? Za : h.PARSER_MEDIA_TYPE, Ae = Gt === "application/xhtml+xml" ? g : v, Oe = "ALLOWED_TAGS" in h ? w({}, h.ALLOWED_TAGS, Ae) : Co, Re = "ALLOWED_ATTR" in h ? w({}, h.ALLOWED_ATTR, Ae) : xo, ir = "ALLOWED_NAMESPACES" in h ? w({}, h.ALLOWED_NAMESPACES, g) : qa, rr = "ADD_URI_SAFE_ATTR" in h ? w(
              Y(Mo),
              // eslint-disable-line indent
              h.ADD_URI_SAFE_ATTR,
              // eslint-disable-line indent
              Ae
              // eslint-disable-line indent
            ) : Mo, Do = "ADD_DATA_URI_TAGS" in h ? w(
              Y(Po),
              // eslint-disable-line indent
              h.ADD_DATA_URI_TAGS,
              // eslint-disable-line indent
              Ae
              // eslint-disable-line indent
            ) : Po, Ot = "FORBID_CONTENTS" in h ? w({}, h.FORBID_CONTENTS, Ae) : Ao, zt = "FORBID_TAGS" in h ? w({}, h.FORBID_TAGS, Ae) : {}, Jn = "FORBID_ATTR" in h ? w({}, h.FORBID_ATTR, Ae) : {}, Nt = "USE_PROFILES" in h ? h.USE_PROFILES : !1, To = h.ALLOW_ARIA_ATTR !== !1, Qn = h.ALLOW_DATA_ATTR !== !1, So = h.ALLOW_UNKNOWN_PROTOCOLS || !1, No = h.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Tt = h.SAFE_FOR_TEMPLATES || !1, gt = h.WHOLE_DOCUMENT || !1, St = h.RETURN_DOM || !1, dn = h.RETURN_DOM_FRAGMENT || !1, fn = h.RETURN_TRUSTED_TYPE || !1, tr = h.FORCE_BODY || !1, Oo = h.SANITIZE_DOM !== !1, Ro = h.SANITIZE_NAMED_PROPS || !1, nr = h.KEEP_CONTENT !== !1, Yt = h.IN_PLACE || !1, wo = h.ALLOWED_URI_REGEXP || z, Rt = h.NAMESPACE || ot, Ce = h.CUSTOM_ELEMENT_HANDLING || {}, h.CUSTOM_ELEMENT_HANDLING && ko(h.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (Ce.tagNameCheck = h.CUSTOM_ELEMENT_HANDLING.tagNameCheck), h.CUSTOM_ELEMENT_HANDLING && ko(h.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (Ce.attributeNameCheck = h.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), h.CUSTOM_ELEMENT_HANDLING && typeof h.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (Ce.allowCustomizedBuiltInElements = h.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Tt && (Qn = !1), dn && (St = !0), Nt && (Oe = w({}, Me), Re = [], Nt.html === !0 && (w(Oe, ue), w(Re, x)), Nt.svg === !0 && (w(Oe, re), w(Re, L), w(Re, G)), Nt.svgFilters === !0 && (w(Oe, fe), w(Re, L), w(Re, G)), Nt.mathMl === !0 && (w(Oe, oe), w(Re, J), w(Re, G))), h.ADD_TAGS && (Oe === Co && (Oe = Y(Oe)), w(Oe, h.ADD_TAGS, Ae)), h.ADD_ATTR && (Re === xo && (Re = Y(Re)), w(Re, h.ADD_ATTR, Ae)), h.ADD_URI_SAFE_ATTR && w(rr, h.ADD_URI_SAFE_ATTR, Ae), h.FORBID_CONTENTS && (Ot === Ao && (Ot = Y(Ot)), w(Ot, h.FORBID_CONTENTS, Ae)), nr && (Oe["#text"] = !0), gt && w(Oe, ["html", "head", "body"]), Oe.table && (w(Oe, ["tbody"]), delete zt.tbody), h.TRUSTED_TYPES_POLICY) {
              if (typeof h.TRUSTED_TYPES_POLICY.createHTML != "function")
                throw C('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
              if (typeof h.TRUSTED_TYPES_POLICY.createScriptURL != "function")
                throw C('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
              Ve = h.TRUSTED_TYPES_POLICY, Wt = Ve.createHTML("");
            } else
              Ve === void 0 && (Ve = De(xt, Te)), Ve !== null && typeof Wt == "string" && (Wt = Ve.createHTML(""));
            a && a(h), At = h;
          }
        }, Lo = w({}, ["mi", "mo", "mn", "ms", "mtext"]), Fo = w({}, ["foreignobject", "desc", "title", "annotation-xml"]), Qa = w({}, ["title", "style", "font", "a", "script"]), Vo = w({}, [...re, ...fe, ...Ee]), jo = w({}, [...oe, ...Pe]), ec = function(h) {
          let A = Yn(h);
          (!A || !A.tagName) && (A = {
            namespaceURI: Rt,
            tagName: "template"
          });
          const U = v(h.tagName), Ie = v(A.tagName);
          return ir[h.namespaceURI] ? h.namespaceURI === mn ? A.namespaceURI === ot ? U === "svg" : A.namespaceURI === pn ? U === "svg" && (Ie === "annotation-xml" || Lo[Ie]) : !!Vo[U] : h.namespaceURI === pn ? A.namespaceURI === ot ? U === "math" : A.namespaceURI === mn ? U === "math" && Fo[Ie] : !!jo[U] : h.namespaceURI === ot ? A.namespaceURI === mn && !Fo[Ie] || A.namespaceURI === pn && !Lo[Ie] ? !1 : !jo[U] && (Qa[U] || !Vo[U]) : !!(Gt === "application/xhtml+xml" && ir[h.namespaceURI]) : !1;
        }, vt = function(h) {
          I(H.removed, {
            element: h
          });
          try {
            h.parentNode.removeChild(h);
          } catch {
            h.remove();
          }
        }, ar = function(h, A) {
          try {
            I(H.removed, {
              attribute: A.getAttributeNode(h),
              from: A
            });
          } catch {
            I(H.removed, {
              attribute: null,
              from: A
            });
          }
          if (A.removeAttribute(h), h === "is" && !Re[h])
            if (St || dn)
              try {
                vt(A);
              } catch {
              }
            else
              try {
                A.setAttribute(h, "");
              } catch {
              }
        }, Ho = function(h) {
          let A = null, U = null;
          if (tr)
            h = "<remove></remove>" + h;
          else {
            const Le = $(h, /^[\r\n\t ]+/);
            U = Le && Le[0];
          }
          Gt === "application/xhtml+xml" && Rt === ot && (h = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + h + "</body></html>");
          const Ie = Ve ? Ve.createHTML(h) : h;
          if (Rt === ot)
            try {
              A = new ze().parseFromString(Ie, Gt);
            } catch {
            }
          if (!A || !A.documentElement) {
            A = Gn.createDocument(Rt, "template", null);
            try {
              A.documentElement.innerHTML = or ? Wt : Ie;
            } catch {
            }
          }
          const ke = A.body || A.documentElement;
          return h && U && ke.insertBefore(te.createTextNode(U), ke.childNodes[0] || null), Rt === ot ? Ba.call(A, gt ? "html" : "body")[0] : gt ? A.documentElement : ke;
        }, Uo = function(h) {
          return Ha.call(
            h.ownerDocument || h,
            h,
            // eslint-disable-next-line no-bitwise
            Ge.SHOW_ELEMENT | Ge.SHOW_COMMENT | Ge.SHOW_TEXT,
            null
          );
        }, tc = function(h) {
          return h instanceof Xe && (typeof h.nodeName != "string" || typeof h.textContent != "string" || typeof h.removeChild != "function" || !(h.attributes instanceof rt) || typeof h.removeAttribute != "function" || typeof h.setAttribute != "function" || typeof h.namespaceURI != "string" || typeof h.insertBefore != "function" || typeof h.hasChildNodes != "function");
        }, Bo = function(h) {
          return typeof mt == "function" && h instanceof mt;
        }, it = function(h, A, U) {
          Ze[h] && b(Ze[h], (Ie) => {
            Ie.call(H, A, U, At);
          });
        }, Ko = function(h) {
          let A = null;
          if (it("beforeSanitizeElements", h, null), tc(h))
            return vt(h), !0;
          const U = Ae(h.nodeName);
          if (it("uponSanitizeElement", h, {
            tagName: U,
            allowedTags: Oe
          }), h.hasChildNodes() && !Bo(h.firstElementChild) && d(/<[/\w]/g, h.innerHTML) && d(/<[/\w]/g, h.textContent))
            return vt(h), !0;
          if (!Oe[U] || zt[U]) {
            if (!zt[U] && zo(U) && (Ce.tagNameCheck instanceof RegExp && d(Ce.tagNameCheck, U) || Ce.tagNameCheck instanceof Function && Ce.tagNameCheck(U)))
              return !1;
            if (nr && !Ot[U]) {
              const Ie = Yn(h) || h.parentNode, ke = ja(h) || h.childNodes;
              if (ke && Ie) {
                const Le = ke.length;
                for (let je = Le - 1; je >= 0; --je)
                  Ie.insertBefore(Fa(ke[je], !0), Va(h));
              }
            }
            return vt(h), !0;
          }
          return h instanceof _t && !ec(h) || (U === "noscript" || U === "noembed" || U === "noframes") && d(/<\/no(script|embed|frames)/i, h.innerHTML) ? (vt(h), !0) : (Tt && h.nodeType === 3 && (A = h.textContent, b([qn, Xn, Zn], (Ie) => {
            A = _(A, Ie, " ");
          }), h.textContent !== A && (I(H.removed, {
            element: h.cloneNode()
          }), h.textContent = A)), it("afterSanitizeElements", h, null), !1);
        }, Wo = function(h, A, U) {
          if (Oo && (A === "id" || A === "name") && (U in te || U in Ja))
            return !1;
          if (!(Qn && !Jn[A] && d(Wa, A))) {
            if (!(To && d(za, A))) {
              if (!Re[A] || Jn[A]) {
                if (
                  // First condition does a very basic check if a) it's basically a valid custom element tagname AND
                  // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                  // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                  !(zo(h) && (Ce.tagNameCheck instanceof RegExp && d(Ce.tagNameCheck, h) || Ce.tagNameCheck instanceof Function && Ce.tagNameCheck(h)) && (Ce.attributeNameCheck instanceof RegExp && d(Ce.attributeNameCheck, A) || Ce.attributeNameCheck instanceof Function && Ce.attributeNameCheck(A)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                  // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                  A === "is" && Ce.allowCustomizedBuiltInElements && (Ce.tagNameCheck instanceof RegExp && d(Ce.tagNameCheck, U) || Ce.tagNameCheck instanceof Function && Ce.tagNameCheck(U)))
                )
                  return !1;
              } else if (!rr[A]) {
                if (!d(wo, _(U, $o, ""))) {
                  if (!((A === "src" || A === "xlink:href" || A === "href") && h !== "script" && m(U, "data:") === 0 && Do[h])) {
                    if (!(So && !d(Ya, _(U, $o, "")))) {
                      if (U)
                        return !1;
                    }
                  }
                }
              }
            }
          }
          return !0;
        }, zo = function(h) {
          return h.indexOf("-") > 0;
        }, Yo = function(h) {
          it("beforeSanitizeAttributes", h, null);
          const {
            attributes: A
          } = h;
          if (!A)
            return;
          const U = {
            attrName: "",
            attrValue: "",
            keepAttr: !0,
            allowedAttributes: Re
          };
          let Ie = A.length;
          for (; Ie--; ) {
            const ke = A[Ie], {
              name: Le,
              namespaceURI: je,
              value: ht
            } = ke, qt = Ae(Le);
            let He = Le === "value" ? ht : f(ht);
            if (U.attrName = qt, U.attrValue = He, U.keepAttr = !0, U.forceKeepAttr = void 0, it("uponSanitizeAttribute", h, U), He = U.attrValue, U.forceKeepAttr || (ar(Le, h), !U.keepAttr))
              continue;
            if (!No && d(/\/>/i, He)) {
              ar(Le, h);
              continue;
            }
            Tt && b([qn, Xn, Zn], (qo) => {
              He = _(He, qo, " ");
            });
            const Go = Ae(h.nodeName);
            if (Wo(Go, qt, He)) {
              if (Ro && (qt === "id" || qt === "name") && (ar(Le, h), He = Ga + He), Ve && typeof xt == "object" && typeof xt.getAttributeType == "function" && !je)
                switch (xt.getAttributeType(Go, qt)) {
                  case "TrustedHTML": {
                    He = Ve.createHTML(He);
                    break;
                  }
                  case "TrustedScriptURL": {
                    He = Ve.createScriptURL(He);
                    break;
                  }
                }
              try {
                je ? h.setAttributeNS(je, Le, He) : h.setAttribute(Le, He), y(H.removed);
              } catch {
              }
            }
          }
          it("afterSanitizeAttributes", h, null);
        }, nc = function B(h) {
          let A = null;
          const U = Uo(h);
          for (it("beforeSanitizeShadowDOM", h, null); A = U.nextNode(); )
            it("uponSanitizeShadowNode", A, null), !Ko(A) && (A.content instanceof Se && B(A.content), Yo(A));
          it("afterSanitizeShadowDOM", h, null);
        };
        return H.sanitize = function(B) {
          let h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, A = null, U = null, Ie = null, ke = null;
          if (or = !B, or && (B = "<!-->"), typeof B != "string" && !Bo(B))
            if (typeof B.toString == "function") {
              if (B = B.toString(), typeof B != "string")
                throw C("dirty is not a string, aborting");
            } else
              throw C("toString is not a function");
          if (!H.isSupported)
            return B;
          if (er || sr(h), H.removed = [], typeof B == "string" && (Yt = !1), Yt) {
            if (B.nodeName) {
              const ht = Ae(B.nodeName);
              if (!Oe[ht] || zt[ht])
                throw C("root node is forbidden and cannot be sanitized in-place");
            }
          } else if (B instanceof mt)
            A = Ho("<!---->"), U = A.ownerDocument.importNode(B, !0), U.nodeType === 1 && U.nodeName === "BODY" || U.nodeName === "HTML" ? A = U : A.appendChild(U);
          else {
            if (!St && !Tt && !gt && // eslint-disable-next-line unicorn/prefer-includes
            B.indexOf("<") === -1)
              return Ve && fn ? Ve.createHTML(B) : B;
            if (A = Ho(B), !A)
              return St ? null : fn ? Wt : "";
          }
          A && tr && vt(A.firstChild);
          const Le = Uo(Yt ? B : A);
          for (; Ie = Le.nextNode(); )
            Ko(Ie) || (Ie.content instanceof Se && nc(Ie.content), Yo(Ie));
          if (Yt)
            return B;
          if (St) {
            if (dn)
              for (ke = Ua.call(A.ownerDocument); A.firstChild; )
                ke.appendChild(A.firstChild);
            else
              ke = A;
            return (Re.shadowroot || Re.shadowrootmode) && (ke = Ka.call(Q, ke, !0)), ke;
          }
          let je = gt ? A.outerHTML : A.innerHTML;
          return gt && Oe["!doctype"] && A.ownerDocument && A.ownerDocument.doctype && A.ownerDocument.doctype.name && d(R, A.ownerDocument.doctype.name) && (je = "<!DOCTYPE " + A.ownerDocument.doctype.name + `>
` + je), Tt && b([qn, Xn, Zn], (ht) => {
            je = _(je, ht, " ");
          }), Ve && fn ? Ve.createHTML(je) : je;
        }, H.setConfig = function() {
          let B = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          sr(B), er = !0;
        }, H.clearConfig = function() {
          At = null, er = !1;
        }, H.isValidAttribute = function(B, h, A) {
          At || sr({});
          const U = Ae(B), Ie = Ae(h);
          return Wo(U, Ie, A);
        }, H.addHook = function(B, h) {
          typeof h == "function" && (Ze[B] = Ze[B] || [], I(Ze[B], h));
        }, H.removeHook = function(B) {
          if (Ze[B])
            return y(Ze[B]);
        }, H.removeHooks = function(B) {
          Ze[B] && (Ze[B] = []);
        }, H.removeAllHooks = function() {
          Ze = {};
        }, H;
      }
      var lt = xe();
      return lt;
    });
  }(Cr)), Cr.exports;
}
window.DOMPurify || (window.DOMPurify = ji().default || ji());
const Ep = {
  MOBILE: 640,
  TABLET: 768,
  DESKTOP: 1280
}, Hi = {
  "is-hidden-desktop": "_is-hidden-desktop_1ods7_1",
  "is-hidden-mobile": "_is-hidden-mobile_1ods7_12",
  "unset-ul": "_unset-ul_1ods7_26"
}, yo = ({ children: e, hideOn: t, className: n }) => {
  const o = X(t && Hi[`is-hidden-${t}`], n);
  return /* @__PURE__ */ E("li", { className: o, children: /* @__PURE__ */ E("ul", { className: Hi["unset-ul"], children: e }) });
}, Ip = "_arrow_f9ulj_86", $p = "_navbar_f9ulj_1", ye = {
  "navbar-item": "_navbar-item_f9ulj_1",
  "navbar-drawer": "_navbar-drawer_f9ulj_9",
  "first-on-mobile": "_first-on-mobile_f9ulj_24",
  "second-on-mobile": "_second-on-mobile_f9ulj_33",
  "navbar-end": "_navbar-end_f9ulj_42",
  "navbar-item-wrapper": "_navbar-item-wrapper_f9ulj_61",
  "navbar-item-button": "_navbar-item-button_f9ulj_77",
  arrow: Ip,
  "navbar-has-dropdown": "_navbar-has-dropdown_f9ulj_99",
  "navbar-dropdown": "_navbar-dropdown_f9ulj_125",
  "is-size-small": "_is-size-small_f9ulj_129",
  "is-size-medium": "_is-size-medium_f9ulj_132",
  "navbar-item-no-padding-top-bottom": "_navbar-item-no-padding-top-bottom_f9ulj_159",
  "navbar-item-is-right": "_navbar-item-is-right_f9ulj_163",
  "navbar-item-is-center": "_navbar-item-is-center_f9ulj_168",
  "navbar-item-no-padding": "_navbar-item-no-padding_f9ulj_159",
  "is-right": "_is-right_f9ulj_175",
  "is-left": "_is-left_f9ulj_179",
  navbar: $p,
  "is-fixed-top": "_is-fixed-top_f9ulj_194",
  "navbar-burger": "_navbar-burger_f9ulj_206",
  "navbar-menu": "_navbar-menu_f9ulj_247",
  "burger-close": "_burger-close_f9ulj_261",
  "navbar-start": "_navbar-start_f9ulj_281",
  "unset-li": "_unset-li_f9ulj_315",
  "margin-auto-top": "_margin-auto-top_f9ulj_322",
  "navbar-item-larger-padding-bottom": "_navbar-item-larger-padding-bottom_f9ulj_331"
}, Mm = ({ children: e, isFixedTop: t }) => /* @__PURE__ */ E(_p, { children: /* @__PURE__ */ E(gp, { className: X(ye.navbar, t && ye["is-fixed-top"]), children: e }) }), km = ({ children: e, notificationValue: t }) => {
  const [n, o] = $e(!1), { width: i } = yp(), r = i < Ep.TABLET;
  return /* @__PURE__ */ ne(On, { children: [
    r && /* @__PURE__ */ E(wp, { children: t ? /* @__PURE__ */ E(Np, { value: t, isSmall: !0, children: /* @__PURE__ */ ne("button", { onClick: () => o(!n), className: ye["navbar-burger"], children: [
      /* @__PURE__ */ E("span", { "aria-hidden": "true" }),
      /* @__PURE__ */ E("span", { "aria-hidden": "true" }),
      /* @__PURE__ */ E("span", { "aria-hidden": "true" })
    ] }) }) : /* @__PURE__ */ ne("button", { onClick: () => o(!n), className: ye["navbar-burger"], children: [
      /* @__PURE__ */ E("span", { "aria-hidden": "true" }),
      /* @__PURE__ */ E("span", { "aria-hidden": "true" }),
      /* @__PURE__ */ E("span", { "aria-hidden": "true" })
    ] }) }),
    r && /* @__PURE__ */ E(
      Nf,
      {
        isOpen: n,
        onClose: () => o(!n),
        className: X(ye["navbar-drawer"]),
        children: e
      }
    ),
    /* @__PURE__ */ E("li", { className: X(ye["navbar-menu"]), children: /* @__PURE__ */ ne("ul", { children: [
      /* @__PURE__ */ E("li", { children: /* @__PURE__ */ E("button", { className: ye["burger-close"], onClick: () => o(!n), children: /* @__PURE__ */ E(Fe, { name: "remove", size: "large" }) }) }),
      e
    ] }) })
  ] });
}, wp = ({
  children: e,
  href: t,
  hideOn: n,
  isFirstOnMobile: o,
  isSecondOnMobile: i,
  noPaddingRight: r,
  largerPaddingBottom: s,
  noTopBottomPadding: a,
  onClick: c,
  marginAutoTop: p,
  isButton: l
}) => {
  const u = X(
    p && ye["margin-auto-top"],
    o && ye["first-on-mobile"],
    i && ye["second-on-mobile"],
    r && ye["navbar-item-no-padding"],
    l && ye["navbar-item-button"],
    a && ye["navbar-item-no-padding-top-bottom"],
    s && ye["navbar-item-larger-padding-bottom"]
  ), b = t ? /* @__PURE__ */ E(Fn, { onClick: c, className: X(ye["navbar-item-wrapper"], u), children: /* @__PURE__ */ E(hp, { className: X(ye["navbar-item"], u), href: t, children: e }) }) : /* @__PURE__ */ E(Fn, { onClick: c, className: X(ye["navbar-item"], u), children: e });
  return n ? /* @__PURE__ */ E(yo, { hideOn: n, className: X(ye["navbar-item-wrapper"], u), children: b }) : b;
}, Lm = ({ children: e, position: t }) => {
  const n = X(t && ye[`navbar-${t}`]);
  return /* @__PURE__ */ E("li", { className: n, children: /* @__PURE__ */ E("ul", { className: n, children: e }) });
}, Fm = ({ children: e, hideOn: t }) => {
  const n = X(ye["navbar-has-dropdown"], ye["navbar-item-wrapper"]);
  return t ? /* @__PURE__ */ E(yo, { hideOn: t, className: ye["navbar-item-wrapper"], children: /* @__PURE__ */ E(Fn, { className: n, children: e }) }) : /* @__PURE__ */ E(Fn, { className: n, children: e });
}, Vm = ({ children: e }) => /* @__PURE__ */ E(vp, { className: ye["navbar-item"], children: /* @__PURE__ */ ne(Vn, { gap: "2", alignItems: "center", isFullWidth: !0, justifyContent: "space-between", children: [
  e,
  /* @__PURE__ */ E(Fe, { name: "up-arrow", size: "small", className: ye.arrow })
] }) }), jm = ({ children: e, size: t, align: n = "right" }) => {
  const o = X(
    ye["navbar-dropdown"],
    ye[`is-${n}`],
    ye["navbar-item"],
    t && ye[`is-size-${t}`]
  );
  return /* @__PURE__ */ E(bp, { className: o, children: /* @__PURE__ */ E("ul", { children: e }) });
}, Ui = {
  "unset-list": "_unset-list_69pws_1",
  "navbar-brand": "_navbar-brand_69pws_9"
}, Hm = ({ children: e }) => /* @__PURE__ */ E("li", { className: Ui["unset-list"], children: /* @__PURE__ */ E("ul", { className: Ui["navbar-brand"], children: e }) }), xr = {
  "unset-list": "_unset-list_tt9be_1",
  "navbar-divider": "_navbar-divider_tt9be_7"
}, Um = ({ hideOn: e }) => {
  const t = X(xr["navbar-divider"]);
  return e ? /* @__PURE__ */ E(yo, { hideOn: e, children: /* @__PURE__ */ E("li", { className: xr["unset-list"], children: /* @__PURE__ */ E("hr", { className: t }) }) }) : /* @__PURE__ */ E("li", { className: xr["unset-list"], children: /* @__PURE__ */ E("hr", { className: t }) });
}, Cp = {
  "dropdown-divider": "_dropdown-divider_1vc0f_1"
}, Bm = () => /* @__PURE__ */ E("hr", { className: X(Cp["dropdown-divider"]) }), xp = "_avatar_j55c0_1", Bi = {
  avatar: xp,
  "is-xsmall": "_is-xsmall_j55c0_4",
  "is-small": "_is-small_j55c0_8",
  "is-medium": "_is-medium_j55c0_12",
  "is-large": "_is-large_j55c0_16"
};
function Km({ url: e, alt: t, size: n = "medium", className: o, ...i }) {
  const r = X(Bi.avatar, n && Bi[`is-${n}`], o);
  return /* @__PURE__ */ E("img", { className: r, src: e, alt: t, ...i });
}
const Tp = "_badge_51b62_1", Sp = "_root_51b62_30", Qt = {
  badge: Tp,
  "is-small": "_is-small_51b62_14",
  "has-child": "_has-child_51b62_20",
  "on-icon": "_on-icon_51b62_25",
  root: Sp
};
function Np({ value: e, isSmall: t = !1, onIcon: n = !1, children: o, className: i, ...r }) {
  const s = X(
    Qt.badge,
    t && Qt["is-small"],
    n && Qt["on-icon"],
    o && Qt["has-child"],
    i
  );
  return o ? /* @__PURE__ */ ne("span", { className: Qt.root, ...r, children: [
    /* @__PURE__ */ E("span", { className: s, children: !t && e }),
    o
  ] }) : /* @__PURE__ */ E("span", { className: s, ...r, children: !t && e });
}
const Tr = {
  "is-extra-small": "_is-extra-small_11hqx_1",
  "is-small": "_is-small_11hqx_4",
  "is-medium": "_is-medium_11hqx_7",
  "is-large": "_is-large_11hqx_10",
  "is-extra-large": "_is-extra-large_11hqx_13",
  "is-auto": "_is-auto_11hqx_16",
  "is-full-width": "_is-full-width_11hqx_19",
  "no-border": "_no-border_11hqx_22",
  "has-sm-border": "_has-sm-border_11hqx_25",
  "has-full-border": "_has-full-border_11hqx_28"
};
function Wm({ src: e, alt: t, width: n, borderRadius: o = "none", className: i = "", ...r }) {
  const s = X(Tr.img, i, Tr[Op[n]], Tr[Rp[o]]);
  return /* @__PURE__ */ E("img", { ...r, className: s, alt: t, src: e });
}
const Op = {
  xsmall: "is-extra-small",
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  xlarge: "is-extra-large",
  auto: "is-auto",
  full: "is-full-width"
}, Rp = {
  none: "no-border",
  small: "has-sm-border",
  full: "has-full-border"
}, Ap = "_columns_16lx5_1", Dp = "_column_16lx5_1", tn = {
  columns: Ap,
  column: Dp,
  "is-1": "_is-1_16lx5_33",
  "is-2": "_is-2_16lx5_37",
  "is-3": "_is-3_16lx5_41",
  "is-4": "_is-4_16lx5_45",
  "is-5": "_is-5_16lx5_49",
  "is-6": "_is-6_16lx5_53",
  "is-7": "_is-7_16lx5_57",
  "is-8": "_is-8_16lx5_61",
  "is-9": "_is-9_16lx5_65",
  "is-10": "_is-10_16lx5_69",
  "is-11": "_is-11_16lx5_73",
  "is-12": "_is-12_16lx5_77",
  "is-offset-1": "_is-offset-1_16lx5_81",
  "is-offset-2": "_is-offset-2_16lx5_84",
  "is-offset-3": "_is-offset-3_16lx5_87",
  "is-offset-4": "_is-offset-4_16lx5_90",
  "is-offset-5": "_is-offset-5_16lx5_93",
  "is-offset-6": "_is-offset-6_16lx5_96",
  "is-offset-7": "_is-offset-7_16lx5_99",
  "is-offset-8": "_is-offset-8_16lx5_102",
  "is-offset-9": "_is-offset-9_16lx5_105",
  "is-offset-10": "_is-offset-10_16lx5_108",
  "is-offset-11": "_is-offset-11_16lx5_111"
};
function zm({ children: e, className: t = "", ...n }) {
  const o = X(tn.columns, t);
  return /* @__PURE__ */ E("div", { className: o, ...n, children: e });
}
const Pp = {
  auto: "",
  1: "is-1",
  2: "is-2",
  3: "is-3",
  4: "is-4",
  5: "is-5",
  6: "is-6",
  7: "is-7",
  8: "is-8",
  9: "is-9",
  10: "is-10",
  11: "is-11",
  12: "is-12"
}, Mp = {
  auto: "",
  1: "is-offset-1",
  2: "is-offset-2",
  3: "is-offset-3",
  4: "is-offset-4",
  5: "is-offset-5",
  6: "is-offset-6",
  7: "is-offset-7",
  8: "is-offset-8",
  9: "is-offset-9",
  10: "is-offset-10",
  11: "is-offset-11",
  12: "is-offset-12"
};
function Ym({
  size: e = "auto",
  offset: t = "auto",
  isNarrow: n = !1,
  className: o = "",
  children: i,
  ...r
}) {
  const s = X(
    tn.column,
    tn[Pp[e]],
    tn[Mp[t]],
    n && tn["is-narrow"],
    o
  );
  return /* @__PURE__ */ E("div", { className: s, ...r, children: i });
}
const kp = "_container_1ndc8_1", Ki = {
  container: kp,
  "is-fluid": "_is-fluid_1ndc8_15"
};
function La({ isFluid: e = !1, children: t, className: n = "", ...o }) {
  const i = X(Ki.container, e && Ki["is-fluid"], n);
  return /* @__PURE__ */ E("div", { className: i, ...o, children: t });
}
const Lp = "_section_1btgy_1", Fp = {
  section: Lp
};
function Gm({ children: e, className: t = "", ...n }) {
  const o = X(Fp.section, t);
  return /* @__PURE__ */ E("section", { ...n, className: o, children: e });
}
const Vp = "_hero_1vqmo_1", Vt = {
  hero: Vp,
  "hero-body": "_hero-body_1vqmo_8",
  "is-small": "_is-small_1vqmo_19",
  "is-medium": "_is-medium_1vqmo_22",
  "is-large": "_is-large_1vqmo_25",
  "is-halfheight": "_is-halfheight_1vqmo_28",
  "is-fullheight": "_is-fullheight_1vqmo_35",
  "hero-background-image": "_hero-background-image_1vqmo_42",
  "hero-top-left": "_hero-top-left_1vqmo_52"
}, jp = {
  auto: "",
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  halfHeight: "is-halfheight",
  fullHeight: "is-fullheight"
};
function qm({ backgroundImage: e, imageSrc: t, className: n, size: o = "auto", children: i, topLeft: r, ...s }) {
  const a = X(Vt.hero, Vt[jp[o]], n);
  let c;
  if (e) {
    const p = Vt["hero-background-image"];
    c = Kt(e, {
      className: p,
      ...e.props
    });
  }
  return /* @__PURE__ */ ne("section", { className: a, ...s, children: [
    t && /* @__PURE__ */ E("img", { className: Vt["hero-background-image"], src: t, alt: "img-header" }),
    e && !t && c,
    r && /* @__PURE__ */ E("div", { className: Vt["hero-top-left"], children: r }),
    /* @__PURE__ */ E("div", { className: Vt["hero-body"], children: i })
  ] });
}
const Hp = "_flex_jspfd_1", Up = "_wrap_jspfd_43", Bp = "_nowrap_jspfd_46", ut = {
  flex: Hp,
  "flex-row": "_flex-row_jspfd_10",
  "flex-column": "_flex-column_jspfd_13",
  "justify-start": "_justify-start_jspfd_16",
  "justify-end": "_justify-end_jspfd_19",
  "justify-center": "_justify-center_jspfd_22",
  "justify-space-between": "_justify-space-between_jspfd_25",
  "justify-space-around": "_justify-space-around_jspfd_28",
  "align-start": "_align-start_jspfd_31",
  "align-end": "_align-end_jspfd_34",
  "align-center": "_align-center_jspfd_37",
  "align-stretch": "_align-stretch_jspfd_40",
  wrap: Up,
  nowrap: Bp,
  "wrap-reverse": "_wrap-reverse_jspfd_49",
  "is-full-width": "_is-full-width_jspfd_55",
  "gap-0": "_gap-0_jspfd_58",
  "gap-1": "_gap-1_jspfd_61",
  "gap-2": "_gap-2_jspfd_64",
  "gap-3": "_gap-3_jspfd_67",
  "gap-4": "_gap-4_jspfd_70",
  "gap-5": "_gap-5_jspfd_73",
  "gap-6": "_gap-6_jspfd_76",
  "gap-7": "_gap-7_jspfd_79",
  "gap-8": "_gap-8_jspfd_82",
  "gap-9": "_gap-9_jspfd_85",
  "gap-10": "_gap-10_jspfd_88",
  "gap-11": "_gap-11_jspfd_91",
  "gap-12": "_gap-12_jspfd_94",
  "gap-14": "_gap-14_jspfd_97",
  "gap-16": "_gap-16_jspfd_100",
  "gap-18": "_gap-18_jspfd_103",
  "gap-20": "_gap-20_jspfd_106",
  "gap-24": "_gap-24_jspfd_109",
  "gap-28": "_gap-28_jspfd_112",
  "gap-32": "_gap-32_jspfd_115",
  "gap-36": "_gap-36_jspfd_118",
  "gap-40": "_gap-40_jspfd_121",
  "gap-44": "_gap-44_jspfd_124",
  "gap-48": "_gap-48_jspfd_127",
  "gap-52": "_gap-52_jspfd_130",
  "gap-56": "_gap-56_jspfd_133",
  "gap-60": "_gap-60_jspfd_136",
  "gap-64": "_gap-64_jspfd_139",
  "gap-72": "_gap-72_jspfd_142",
  "gap-80": "_gap-80_jspfd_145",
  "gap-96": "_gap-96_jspfd_148",
  "no-margin": "_no-margin_jspfd_151"
};
function Vn({
  children: e,
  direction: t = "row",
  justifyContent: n = "start",
  alignItems: o = "start",
  flexWrap: i = "wrap",
  className: r = "",
  isFullWidth: s = !1,
  gap: a,
  style: c,
  noMargin: p = !1,
  ...l
}) {
  const u = X(
    ut.flex,
    ut[`flex-${t}`],
    ut[`justify-${n}`],
    ut[`align-${o}`],
    ut[i],
    s && ut["is-full-width"],
    a && ut[`gap-${a}`],
    p && ut["no-margin"],
    r
  );
  return /* @__PURE__ */ E("div", { className: u, ...l, style: c, children: e });
}
const Kp = "_footer_1nnyw_1", Wp = "_mobile_1nnyw_5", zp = "_desktop_1nnyw_16", Yp = "_banner_1nnyw_24", Gp = "_item_1nnyw_119", qp = "_separator_1nnyw_122", we = {
  footer: Kp,
  "footer-content": "_footer-content_1nnyw_1",
  mobile: Wp,
  desktop: zp,
  banner: Yp,
  "footer-cta-banner": "_footer-cta-banner_1nnyw_27",
  "background-img": "_background-img_1nnyw_34",
  "banner-wrapper": "_banner-wrapper_1nnyw_37",
  "banner-text": "_banner-text_1nnyw_54",
  "banner-cta": "_banner-cta_1nnyw_73",
  "banner-img": "_banner-img_1nnyw_89",
  "footer-headband": "_footer-headband_1nnyw_93",
  "footer-headband-content": "_footer-headband-content_1nnyw_103",
  "is-left": "_is-left_1nnyw_108",
  "is-right": "_is-right_1nnyw_111",
  item: Gp,
  separator: qp
};
function Xm({ children: e }) {
  return /* @__PURE__ */ E("div", { className: we["footer-content"], children: e });
}
function Zm({ children: e }) {
  return /* @__PURE__ */ E("div", { className: we["footer-headband"], children: /* @__PURE__ */ E(La, { children: /* @__PURE__ */ E(Vn, { justifyContent: "space-between", children: e }) }) });
}
function Jm({ children: e, align: t }) {
  return /* @__PURE__ */ E("div", { className: X(we["footer-headband-content"], we[`is-${t}`]), children: e });
}
function Qm({ children: e, href: t }) {
  return t ? /* @__PURE__ */ ne(On, { children: [
    /* @__PURE__ */ E("a", { href: t, className: we.item, children: /* @__PURE__ */ E(Jo, { isSmall: !0, color: "inverted", children: e }) }),
    /* @__PURE__ */ E("div", { className: we.separator })
  ] }) : /* @__PURE__ */ ne(On, { children: [
    /* @__PURE__ */ E(Jo, { className: we.item, isSmall: !0, color: "inverted", children: e }),
    /* @__PURE__ */ E("div", { className: we.separator })
  ] });
}
function e_({ children: e }) {
  return /* @__PURE__ */ E("footer", { className: we.footer, children: e });
}
function t_() {
  return /* @__PURE__ */ E("div", { className: we.separator });
}
function n_({
  href: e,
  backgroundImage: t,
  image: n,
  text: o,
  cta: i,
  mobileBackgroundImage: r,
  mobileText: s
}) {
  return /* @__PURE__ */ E(La, { className: we.banner, children: /* @__PURE__ */ E("a", { href: e, children: /* @__PURE__ */ E(Vn, { justifyContent: "center", isFullWidth: !0, children: /* @__PURE__ */ ne(Vn, { className: we["footer-cta-banner"], justifyContent: "space-between", isFullWidth: !0, children: [
    /* @__PURE__ */ E(
      "img",
      {
        className: X(we["background-img"], we.desktop),
        src: t,
        alt: "collection"
      }
    ),
    /* @__PURE__ */ E(
      "img",
      {
        className: X(we["background-img"], we.mobile),
        src: r,
        alt: "collection"
      }
    ),
    /* @__PURE__ */ ne("div", { className: we["banner-wrapper"], children: [
      /* @__PURE__ */ E("div", { className: X(we["banner-text"], we.desktop), children: o }),
      /* @__PURE__ */ E("div", { className: X(we["banner-text"], we.mobile), children: s }),
      /* @__PURE__ */ E("img", { className: we["banner-img"], src: n, alt: "collection" }),
      /* @__PURE__ */ E("div", { className: we["banner-cta"], children: i })
    ] })
  ] }) }) }) });
}
const jn = ["light", "dark"], Eo = "(prefers-color-scheme: dark)", Xp = typeof window > "u", Io = /* @__PURE__ */ Ht(void 0), Zp = { setTheme: (e) => {
}, themes: [] }, Jp = () => {
  var e;
  return (e = cn(Io)) !== null && e !== void 0 ? e : Zp;
}, Qp = (e) => cn(Io) ? /* @__PURE__ */ Z.createElement(on, null, e.children) : /* @__PURE__ */ Z.createElement(tm, e), em = ["light", "dark"], tm = ({ forcedTheme: e, disableTransitionOnChange: t = !1, enableSystem: n = !0, enableColorScheme: o = !0, storageKey: i = "theme", themes: r = em, defaultTheme: s = n ? "system" : "light", attribute: a = "data-theme", value: c, children: p, nonce: l }) => {
  const [u, b] = $e(() => Wi(i, s)), [y, I] = $e(() => Wi(i)), v = c ? Object.values(c) : r, g = se((f) => {
    let d = f;
    if (!d)
      return;
    f === "system" && n && (d = zi());
    const C = c ? c[d] : d, S = t ? rm() : null, T = document.documentElement;
    if (a === "class" ? (T.classList.remove(...v), C && T.classList.add(C)) : C ? T.setAttribute(a, C) : T.removeAttribute(a), o) {
      const w = jn.includes(s) ? s : null, j = jn.includes(d) ? d : w;
      T.style.colorScheme = j;
    }
    S == null || S();
  }, []), $ = se((f) => {
    b(f);
    try {
      localStorage.setItem(i, f);
    } catch {
    }
  }, [e]), _ = se((f) => {
    const d = zi(f);
    I(d), u === "system" && n && !e && g("system");
  }, [u, e]);
  ae(() => {
    const f = window.matchMedia(Eo);
    return f.addListener(_), _(f), () => f.removeListener(_);
  }, [_]), ae(() => {
    const f = (d) => {
      d.key === i && $(d.newValue || s);
    };
    return window.addEventListener("storage", f), () => window.removeEventListener("storage", f);
  }, [$]), ae(() => {
    g(e ?? u);
  }, [e, u]);
  const m = ct(() => ({ theme: u, setTheme: $, forcedTheme: e, resolvedTheme: u === "system" ? y : u, themes: n ? [...r, "system"] : r, systemTheme: n ? y : void 0 }), [u, $, e, y, n, r]);
  return Z.createElement(Io.Provider, { value: m }, /* @__PURE__ */ Z.createElement(nm, { forcedTheme: e, disableTransitionOnChange: t, enableSystem: n, enableColorScheme: o, storageKey: i, themes: r, defaultTheme: s, attribute: a, value: c, children: p, attrs: v, nonce: l }), p);
}, nm = /* @__PURE__ */ oc(({ forcedTheme: e, storageKey: t, attribute: n, enableSystem: o, enableColorScheme: i, defaultTheme: r, value: s, attrs: a, nonce: c }) => {
  const p = r === "system", l = n === "class" ? `var d=document.documentElement,c=d.classList;c.remove(${a.map((I) => `'${I}'`).join(",")});` : `var d=document.documentElement,n='${n}',s='setAttribute';`, u = i ? jn.includes(r) && r ? `if(e==='light'||e==='dark'||!e)d.style.colorScheme=e||'${r}'` : "if(e==='light'||e==='dark')d.style.colorScheme=e" : "", b = (I, v = !1, g = !0) => {
    const $ = s ? s[I] : I, _ = v ? I + "|| ''" : `'${$}'`;
    let m = "";
    return i && g && !v && jn.includes(I) && (m += `d.style.colorScheme = '${I}';`), n === "class" ? m += v || $ ? `c.add(${_})` : "null" : $ && (m += `d[s](n,${_})`), m;
  }, y = e ? `!function(){${l}${b(e)}}()` : o ? `!function(){try{${l}var e=localStorage.getItem('${t}');if('system'===e||(!e&&${p})){var t='${Eo}',m=window.matchMedia(t);if(m.media!==t||m.matches){${b("dark")}}else{${b("light")}}}else if(e){${s ? `var x=${JSON.stringify(s)};` : ""}${b(s ? "x[e]" : "e", !0)}}${p ? "" : "else{" + b(r, !1, !1) + "}"}${u}}catch(e){}}()` : `!function(){try{${l}var e=localStorage.getItem('${t}');if(e){${s ? `var x=${JSON.stringify(s)};` : ""}${b(s ? "x[e]" : "e", !0)}}else{${b(r, !1, !1)};}${u}}catch(t){}}();`;
  return Z.createElement("script", { nonce: c, dangerouslySetInnerHTML: { __html: y } });
}, () => !0), Wi = (e, t) => {
  if (Xp)
    return;
  let n;
  try {
    n = localStorage.getItem(e) || void 0;
  } catch {
  }
  return n || t;
}, rm = () => {
  const e = document.createElement("style");
  return e.appendChild(document.createTextNode("*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}")), document.head.appendChild(e), () => {
    window.getComputedStyle(document.body), setTimeout(() => {
      document.head.removeChild(e);
    }, 1);
  };
}, zi = (e) => (e || (e = window.matchMedia(Eo)), e.matches ? "dark" : "light");
function r_() {
  const { theme: e, setTheme: t } = Jp(), n = se(
    (s) => {
      t(s);
    },
    [t]
  ), o = se(() => n("dark"), [n]), i = se(() => n("light"), [n]), r = se(() => n(e === "light" ? "dark" : "light"), [e, n]);
  return { theme: e, changeTheme: n, setDarkTheme: o, setLightTheme: i, toggleTheme: r };
}
const o_ = Ht({
  theme: "light",
  changeTheme: (e) => {
    document.documentElement.setAttribute("data-theme", e);
  }
});
function i_({ children: e, defaultTheme: t }) {
  return /* @__PURE__ */ E(Qp, { defaultTheme: t, children: e });
}
export {
  Im as Accordion,
  gm as Autocomplete,
  Km as Avatar,
  Rp as BORDER_RADIUSES,
  pc as BUTTON_COLORS,
  mc as BUTTON_SIZES,
  Np as Badge,
  _m as Block,
  Cm as Box,
  ym as Breadcrumbs,
  am as Button,
  cm as Buttons,
  Fl as COLOR_BREADCRUMB,
  lm as Card,
  dm as Carousel,
  fm as CarouselItem,
  hm as Checkbox,
  Om as Collapsible,
  Ym as Column,
  zm as Columns,
  La as Container,
  i_ as DesignProvider,
  xm as Divider,
  Nf as Drawer,
  Vn as Flex,
  e_ as Footer,
  n_ as FooterCTABanner,
  Xm as FooterContent,
  Zm as FooterHeadband,
  Jm as FooterHeadbandContent,
  Qm as FooterHeadbandItem,
  t_ as FooterHeadbandSeparator,
  qm as Hero,
  yo as HideItem,
  Op as IMAGE_SIZES,
  Fe as Icon,
  Xo as IconList,
  Wm as Image,
  um as InfoCard,
  vm as Input,
  mm as Link,
  wm as Modal,
  Mm as Navbar,
  Hm as NavbarBrand,
  Um as NavbarDivider,
  Fm as NavbarDropdown,
  jm as NavbarDropdownContent,
  Bm as NavbarDropdownDivider,
  Vm as NavbarDropdownTrigger,
  wp as NavbarItem,
  Lm as NavbarItemWrapper,
  km as NavbarMenu,
  Am as ProgressBar,
  Gm as Section,
  Cc as TEXT_ALIGNMENTS,
  Sm as Tabs,
  bm as Tag,
  Jo as Text,
  o_ as ThemeContext,
  pm as Title,
  Nm as Video,
  Pl as statusStyle,
  r_ as useTheme
};
